window.palletPhotoLists = {
  "best-buy-electronics-16-free-shipping-eligible": {
    "title": "Best Buy Electronics #16 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #16",
    "productId": "gid://shopify/Product/9663655969023",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-16-free-shipping-eligible-best-buy-electronics-16-free-shipping-eligible-liquidationdeals-ca-1256995193.jpg?v=1788467439",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-16-free-shipping-eligible-best-buy-electronics-16-free-shipping-eligible-liquidationdeals-ca-1256995193.jpg?v=1788467439",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-16-free-shipping-eligible-best-buy-electronics-16-free-shipping-eligible-liquidationdeals-ca-1256995192.jpg?v=1788467411",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-16-free-shipping-eligible-best-buy-electronics-16-free-shipping-eligible-liquidationdeals-ca-1256995191.jpg?v=1788467376",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-16-free-shipping-eligible-best-buy-electronics-16-free-shipping-eligible-liquidationdeals-ca-1256995190.jpg?v=1788467350",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Midea portable air-conditioner cartons",
        "marker": [
          62,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Midea 3-in-1 portable AC cartons appear on every side. Some labels show 7000 BTU SACC / 10000 BTU ASHRAE; other capacities also appear.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BLACK+DECKER portable AC with heat carton",
        "marker": [
          38,
          69
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom centre",
        "note": "Photo 2 shows 8350 BTU SACC / 12000 BTU ASHRAE and a heat-mode rating.",
        "price": 549.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BLACK+DECKER 10200 BTU SACC / 14000 BTU ASHRAE portable air conditioner",
        "comparisonNote": "Comparison is the cooling model listed by the retailer; capacity and heat-mode features may differ.",
        "priceUnit": "one air conditioner",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Black-Decker-Portable-Air-Conditioner-10-200-BTU-SACC-CEC-14-000-BTU-ASHRAE-128-for-Rooms-Up-To-700-Sq-Ft-White/71SEXRNSOGY2",
        "referenceKey": "blackdecker_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Panasonic 1.3-cu.-ft. microwave carton",
        "marker": [
          61,
          15
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top centre",
        "note": "Photo 3 shows Panasonic 1.3-cu.-ft. microwave packaging.",
        "price": 249.95,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Panasonic NN-SU66LS 1.3-cu.-ft. 1100W Genius Sensor microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Panasonic US",
        "url": "https://shop.panasonic.com/products/1-3-cu-ft-genius-sensor-microwave-1100w-nn-su66ls",
        "referenceKey": "panasonic_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach microwave carton",
        "marker": [
          62,
          33
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The Hamilton Beach microwave carton is visible below the Panasonic box.",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach compact-refrigerator carton",
        "marker": [
          64,
          77
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "Photo 3 shows a green Hamilton Beach compact-refrigerator carton. The exact capacity is not readable.",
        "price": 99.97,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 3.3-cu.-ft. single-door mini fridge, black",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-3-3-Cu-Ft-Mini-Fridge-with-Freezer-Compact-Refrigerator-Single-Door-Energy-Star-Reversible-Door-Black/6000206662116",
        "referenceKey": "hamilton_fridge_single",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Arctic King refrigerator carton",
        "marker": [
          72,
          74
        ],
        "photoIndex": 4,
        "position": "Photo 4 · bottom right",
        "note": "Photo 4 shows an Arctic King refrigerator carton; capacity and model are partly obscured.",
        "price": 179.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Arctic King 4.4-cu.-ft. single-door mini fridge",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Arctic-King-4-4-Cu-ft-Single-Door-Mini-Fridge/6000201856485",
        "referenceKey": "arctic_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Westinghouse water-dispenser carton",
        "marker": [
          50,
          74
        ],
        "photoIndex": 4,
        "position": "Photo 4 · bottom centre",
        "note": "Photo 4 shows Westinghouse water-dispenser packaging.",
        "price": 258,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Unboxed window air conditioner",
        "marker": [
          36,
          49
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows a window AC under wrap. Its brand and BTU rating are not readable.",
        "price": 140,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "best-buy-electronics-15-free-shipping-eligible": {
    "title": "Best Buy Electronics #15 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #15",
    "productId": "gid://shopify/Product/9663653773567",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-15-free-shipping-eligible-best-buy-electronics-15-free-shipping-eligible-liquidationdeals-ca-1256995185.jpg?v=1788467677",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-15-free-shipping-eligible-best-buy-electronics-15-free-shipping-eligible-liquidationdeals-ca-1256995185.jpg?v=1788467677",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-15-free-shipping-eligible-best-buy-electronics-15-free-shipping-eligible-liquidationdeals-ca-1256995199.jpg?v=1788467650",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-15-free-shipping-eligible-best-buy-electronics-15-free-shipping-eligible-liquidationdeals-ca-1256995183.jpg?v=1788467617",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-15-free-shipping-eligible-best-buy-electronics-15-free-shipping-eligible-liquidationdeals-ca-1256995198.jpg?v=1788467590",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Midea portable air-conditioner cartons",
        "marker": [
          50,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Midea 3-in-1 portable air-conditioner cartons show multiple capacities.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea room air-conditioner carton",
        "marker": [
          57,
          66
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows a Midea window air-conditioner carton; capacity is obscured.",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach countertop-oven cartons",
        "marker": [
          69,
          24
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top right",
        "note": "Green-and-white Hamilton Beach cartons show countertop ovens.",
        "quantityLabel": "Multiple cartons shown",
        "price": 154.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 31103DC convection countertop oven with rotisserie",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Countertop-Oven-with-Convection-Rotisserie-31103DC/3MVW1XZBPOJ8",
        "referenceKey": "countertop_oven",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach microwave carton",
        "marker": [
          69,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A Hamilton Beach microwave package is visible in the front view.",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Avalon A1 top-loading water-cooler carton",
        "marker": [
          28,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The brown carton says Avalon A1 Top Loading Water Cooler.",
        "price": 258,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Philips 2.1 soundbar carton",
        "marker": [
          47,
          29
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top centre",
        "note": "Photo 3 shows a Philips wireless-audio 2.1 soundbar package; exact model is unclear.",
        "price": 69.97,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "onn. 20-inch 2.0 Bluetooth soundbar with coloured lighting",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/onn-20-in-Bluetooth-2-Speakers-LED-2-0-Soundbar-with-Multicolour-Lighting/6000205723544",
        "referenceKey": "soundbar",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ninja Thirsti drink-system carton",
        "marker": [
          42,
          15
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top centre",
        "note": "Ninja Thirsti branding and drink-system pictures are readable in photo 3.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Snow Joe electric snow-shovel carton",
        "marker": [
          47,
          82
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "Photo 3 shows Snow Joe Snow Shovel packaging. The exact model and width are unclear.",
        "price": 151.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR SPEG08U, 12A, 17-inch corded snow shovel. Listed out of stock; DEKO model/width not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "VEVOR at Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/VEVOR-Electric-Snow-Shovel-12A-17-inch-Corded-60-Adjustable-Chute-20-ft-Throwing-Distance-Snowthrower-Dual-Safety-Switch-Winter-Ice-Removal-Tool-Driv/6E8ZTUAL7Z2D",
        "referenceKey": "snow_shovel",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hyper Tough 20V trimmer/blower combo carton",
        "marker": [
          61,
          31
        ],
        "photoIndex": 4,
        "position": "Photo 4 · top centre",
        "note": "Photo 4 shows a Hyper Tough 20V Max carton with string trimmer and leaf blower illustrations.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Portable jump-starter carton",
        "marker": [
          42,
          23
        ],
        "photoIndex": 4,
        "position": "Photo 4 · top centre",
        "note": "The yellow jump-starter package in photo 4 shows a power pack. Branding and output rating are partly obscured.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Galanz microwave carton",
        "marker": [
          46,
          64
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 shows red-and-black Galanz microwave packaging.",
        "price": 99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "best-buy-electronics-17-free-shipping-eligible": {
    "title": "Best Buy Electronics #17 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #17",
    "productId": "gid://shopify/Product/9663653118207",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-17-free-shipping-eligible-best-buy-electronics-17-free-shipping-eligible-liquidationdeals-ca-1256995204.jpg?v=1788467796",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-17-free-shipping-eligible-best-buy-electronics-17-free-shipping-eligible-liquidationdeals-ca-1256995204.jpg?v=1788467796",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-17-free-shipping-eligible-best-buy-electronics-17-free-shipping-eligible-liquidationdeals-ca-1256995203.jpg?v=1788467769",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-17-free-shipping-eligible-best-buy-electronics-17-free-shipping-eligible-liquidationdeals-ca-1256995189.jpg?v=1788467738",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-17-free-shipping-eligible-best-buy-electronics-17-free-shipping-eligible-liquidationdeals-ca-1256995188.jpg?v=1788467709",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Hamilton Beach microwave cartons",
        "marker": [
          46,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Several Hamilton Beach microwave cartons are visible; different packages may indicate different models.",
        "quantityLabel": "Multiple cartons shown",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea 5000 BTU window-AC carton",
        "marker": [
          35,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The Midea room air-conditioner carton is marked 5000 BTU.",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea portable-AC carton",
        "marker": [
          50,
          39
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows a Midea 3-in-1 portable air-conditioner carton.",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Greenworks pressure-washer cartons",
        "marker": [
          61,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Greenworks branding and pressure-washer illustrations are visible; one package shows 2000 PSI.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BLACK+DECKER portable-AC cartons",
        "marker": [
          41,
          38
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 shows a 10200 BTU SACC / 14000 BTU ASHRAE carton. A smaller capacity carton appears on the opposite side.",
        "quantityLabel": "Multiple cartons shown",
        "price": 549.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BLACK+DECKER 10200 BTU SACC / 14000 BTU ASHRAE portable air conditioner",
        "comparisonNote": "Comparison is the cooling model listed by the retailer; capacity and heat-mode features may differ.",
        "priceUnit": "one air conditioner",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Black-Decker-Portable-Air-Conditioner-10-200-BTU-SACC-CEC-14-000-BTU-ASHRAE-128-for-Rooms-Up-To-700-Sq-Ft-White/71SEXRNSOGY2",
        "referenceKey": "blackdecker_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Honeywell QuietSet tower-fan carton",
        "marker": [
          56,
          30
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top centre",
        "note": "Photo 2 shows Honeywell QuietSet branding and a tower-fan image.",
        "price": 64.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Honeywell HYF260BC QuietSet 5, 40-inch tower fan",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Honeywell-HYF260BC-QuietSet-5-Whole-Room-40-Tower-Fan/6000196572574",
        "referenceKey": "tower_fan",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Frigidaire beverage-cooler carton",
        "marker": [
          36,
          72
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "Photo 3 shows a glass-door Frigidaire beverage cooler with can shelves.",
        "price": 240.18,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Frigidaire 1.6-cu.-ft. glass-door beverage refrigerator, 70-can/17-bottle",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Frigidaire-70-Can-17-Bottle-Beverage-Refrigerator-1-6-Cu-ft-Glass-Door-Mini-Fridge-Black/6LMAIDI8LGZE",
        "referenceKey": "beverage_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Arctic King refrigerator carton",
        "marker": [
          40,
          75
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom centre",
        "note": "The carton in photo 2 shows an Arctic King compact refrigerator; the capacity is unclear.",
        "price": 179.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Arctic King 4.4-cu.-ft. single-door mini fridge",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Arctic-King-4-4-Cu-ft-Single-Door-Mini-Fridge/6000201856485",
        "referenceKey": "arctic_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Westinghouse water-dispenser cartons",
        "marker": [
          25,
          72
        ],
        "photoIndex": 4,
        "position": "Photo 4 · bottom left",
        "note": "Photo 4 shows Westinghouse water-dispenser packaging.",
        "quantityLabel": "Multiple cartons shown",
        "price": 258,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Philips appliance carton",
        "marker": [
          55,
          75
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "A narrow Philips-branded carton is visible, but its appliance model and purpose are not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "best-buy-electronics-18-free-shipping-eligible": {
    "title": "Best Buy Electronics #18 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #18",
    "productId": "gid://shopify/Product/9663651578111",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-18-free-shipping-eligible-best-buy-electronics-18-free-shipping-eligible-liquidationdeals-ca-1256995207.jpg?v=1788467917",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-18-free-shipping-eligible-best-buy-electronics-18-free-shipping-eligible-liquidationdeals-ca-1256995207.jpg?v=1788467917",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-18-free-shipping-eligible-best-buy-electronics-18-free-shipping-eligible-liquidationdeals-ca-1256995210.jpg?v=1788467890",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-18-free-shipping-eligible-best-buy-electronics-18-free-shipping-eligible-liquidationdeals-ca-1256995209.jpg?v=1788467858",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-18-free-shipping-eligible-best-buy-electronics-18-free-shipping-eligible-liquidationdeals-ca-1256995208.jpg?v=1788467830",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Hamilton Beach microwave carton",
        "marker": [
          66,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Hamilton Beach microwave packaging is visible.",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "LG microwave carton",
        "marker": [
          63,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The black carton says LG Microwave Oven; model and capacity are obscured.",
        "price": 203,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "LG MSER1590S 1.5-cu.-ft. countertop microwave",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Canadian Appliance Source",
        "url": "https://www.canadianappliance.ca/product/LG_MSER1590S_Countertop_Microwaves_LG_MSER1590S.html",
        "referenceKey": "lg_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Snow Joe cordless snow-blower carton",
        "marker": [
          71,
          42
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle right",
        "note": "Photo 4 shows a Snow Joe 48V cordless snow blower kit; the carton mentions batteries and a charger. Their presence inside is not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Arctic King 4.4-cu.-ft. refrigerator carton",
        "marker": [
          36,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The front Arctic King carton is marked 4.4 cu. ft. refrigerator.",
        "price": 179.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Arctic King 4.4-cu.-ft. single-door mini fridge",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Arctic-King-4-4-Cu-ft-Single-Door-Mini-Fridge/6000201856485",
        "referenceKey": "arctic_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Arctic King 7-cu.-ft. chest-freezer carton",
        "marker": [
          47,
          71
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "Photo 3 shows Arctic King 7.0 cu. ft. Chest Freezer.",
        "price": 239.97,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Arctic King 7.0-cu.-ft. convertible chest freezer",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Arctic-King-7-0-Cu-Ft-Convertible-Chest-Freezer/4S331NT2LQK3",
        "referenceKey": "chest_freezer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea portable-AC cartons",
        "marker": [
          49,
          36
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The side view shows Midea 3-in-1 portable air-conditioner cartons.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea room air-conditioner carton",
        "marker": [
          49,
          30
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top centre",
        "note": "Photo 2 shows a 6000 BTU Midea room-AC carton.",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Unboxed two-door refrigerator",
        "marker": [
          65,
          66
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "A silver two-door refrigerator is visible under wrap. Its badge and capacity are not clear enough for an exact match.",
        "price": 169.97,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 3.1-cu.-ft. two-door mini fridge with true freezer",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-3-1-Cu-Ft-Mini-Fridge-with-True-Freezer-2-Door-Compact-Refrigerator-Energy-Star-Reversible-Doors-Stainless-Steel/6000207964347",
        "referenceKey": "hamilton_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ninja cooking-appliance carton",
        "marker": [
          72,
          16
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top right",
        "note": "A Ninja package is visible at the top rear. The appliance model needs a closer label photo.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "best-buy-electronics-20-free-shipping-eligible": {
    "title": "Best Buy Electronics #20 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #20",
    "productId": "gid://shopify/Product/9663646171391",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-20-free-shipping-eligible-best-buy-electronics-20-free-shipping-eligible-liquidationdeals-ca-1256995225.jpg?v=1788468279",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-20-free-shipping-eligible-best-buy-electronics-20-free-shipping-eligible-liquidationdeals-ca-1256995225.jpg?v=1788468279",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-20-free-shipping-eligible-best-buy-electronics-20-free-shipping-eligible-liquidationdeals-ca-1256995176.jpg?v=1788468251",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-20-free-shipping-eligible-best-buy-electronics-20-free-shipping-eligible-liquidationdeals-ca-1256995214.jpg?v=1788468220",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-20-free-shipping-eligible-best-buy-electronics-20-free-shipping-eligible-liquidationdeals-ca-1256995215.jpg?v=1788468193",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Midea window air-conditioner cartons",
        "marker": [
          36,
          27
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Midea room-AC cartons show 5000 and 6000 BTU labels.",
        "quantityLabel": "Multiple cartons shown",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BLACK+DECKER portable-AC cartons",
        "marker": [
          50,
          36
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 shows 5000 BTU SACC / 8000 BTU ASHRAE portable-AC cartons.",
        "quantityLabel": "Multiple cartons shown",
        "price": 549.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BLACK+DECKER 10200 BTU SACC / 14000 BTU ASHRAE portable air conditioner",
        "comparisonNote": "Comparison is the cooling model listed by the retailer; capacity and heat-mode features may differ.",
        "priceUnit": "one air conditioner",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Black-Decker-Portable-Air-Conditioner-10-200-BTU-SACC-CEC-14-000-BTU-ASHRAE-128-for-Rooms-Up-To-700-Sq-Ft-White/71SEXRNSOGY2",
        "referenceKey": "blackdecker_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Frigidaire two-door compact refrigerator carton",
        "marker": [
          70,
          67
        ],
        "photoIndex": 4,
        "position": "Photo 4 · bottom right",
        "note": "Photo 4 shows Frigidaire compact refrigerator packaging with a 4.5-cu.-ft. badge.",
        "price": 259.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Frigidaire 4.5-cu.-ft. compact refrigerator with freezer, platinum",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Frigidaire-4-5-Cu-ft-Compact-Retro-Refrigerator-with-Freezer-Compartment-Platinum-Mini-Fridge-for-Bedroom-Dorm-Office-Apartment/6000207840380",
        "referenceKey": "frigidaire_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach two-door compact-fridge cartons",
        "marker": [
          47,
          68
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "Photo 3 shows Hamilton Beach 2-Door Refrigerator/Freezer cartons marked 3.1 cu. ft.",
        "quantityLabel": "Multiple cartons shown",
        "price": 169.97,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 3.1-cu.-ft. two-door mini fridge with true freezer",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-3-1-Cu-Ft-Mini-Fridge-with-True-Freezer-2-Door-Compact-Refrigerator-Energy-Star-Reversible-Doors-Stainless-Steel/6000207964347",
        "referenceKey": "hamilton_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Arctic King refrigerator carton",
        "marker": [
          62,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "An Arctic King carton pictures a refrigerator. Its capacity is not clear.",
        "price": 179.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Arctic King 4.4-cu.-ft. single-door mini fridge",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Arctic-King-4-4-Cu-ft-Single-Door-Mini-Fridge/6000201856485",
        "referenceKey": "arctic_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Nespresso Vertuo Pop+ carton",
        "marker": [
          57,
          18
        ],
        "photoIndex": 4,
        "position": "Photo 4 · top centre",
        "note": "Photo 4 shows Nespresso Vertuo Pop+ packaging.",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Pop+ Pacific Blue coffee machine",
        "comparisonNote": "Colour and bundle contents may differ.",
        "priceUnit": "one machine, no milk frother",
        "source": "Nespresso Canada",
        "url": "https://www.nespresso.com/ca/en/order/machines/vertuo/vertuo-pop-plus-pacific-blue",
        "referenceKey": "nespresso_pop",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Unboxed microwave",
        "marker": [
          35,
          16
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top centre",
        "note": "Photo 2 shows a microwave under wrap. The manufacturer and model label are not readable.",
        "price": 99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "best-buy-electronics-04-free-shipping-eligible": {
    "title": "Best Buy Electronics #04 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #04",
    "productId": "gid://shopify/Product/9663644893439",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-04-free-shipping-eligible-best-buy-electronics-04-free-shipping-eligible-liquidationdeals-ca-1256995218.jpg?v=1788468397",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-04-free-shipping-eligible-best-buy-electronics-04-free-shipping-eligible-liquidationdeals-ca-1256995218.jpg?v=1788468397",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-04-free-shipping-eligible-best-buy-electronics-04-free-shipping-eligible-liquidationdeals-ca-1256995227.jpg?v=1788468369",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-04-free-shipping-eligible-best-buy-electronics-04-free-shipping-eligible-liquidationdeals-ca-1256995219.jpg?v=1788468338",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-04-free-shipping-eligible-best-buy-electronics-04-free-shipping-eligible-liquidationdeals-ca-1256995200.jpg?v=1788468310",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Expert Grill combo-grill carton",
        "marker": [
          38,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The red carton says Expert Grill Combo Grill with 4 burners. A grill-and-griddle illustration is visible on another side.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BISSELL PowerForce Compact vacuum carton",
        "marker": [
          62,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "BISSELL PowerForce Compact branding is readable.",
        "price": 94.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL PowerForce Compact 2112 upright vacuum",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/BISSELL-PowerForce-Compact-Bagless-Improved/dp/B07JJPKVTP",
        "referenceKey": "bissell_powerforce",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BISSELL PowerForce Turbo Pet vacuum carton",
        "marker": [
          62,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "BISSELL PowerForce Turbo Pet packaging is visible below the coffee-machine carton.",
        "price": 94.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL PowerForce Compact 2112 upright vacuum",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/BISSELL-PowerForce-Compact-Bagless-Improved/dp/B07JJPKVTP",
        "referenceKey": "bissell_powerforce",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BISSELL PowerClean TurboBrush carpet-cleaner carton",
        "marker": [
          69,
          28
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top right",
        "note": "Photo 3 shows BISSELL PowerClean TurboBrush branding.",
        "price": 89,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "BISSELL PowerForce PowerBrush Pet Advanced carpet cleaner 2910",
        "comparisonNote": "Different BISSELL carpet-cleaner model; features and attachments vary.",
        "priceUnit": "one carpet cleaner",
        "source": "BISSELL US",
        "url": "https://www.bissell.com/en-us/product/powerforce-powerbrush-pet-advanced-carpet-cleaner-2910.html",
        "referenceKey": "bissell_upright_cleaner",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Philips Avent fast bottle-warmer carton",
        "marker": [
          69,
          22
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top right",
        "note": "The purple Philips Avent carton says Fast and Safe Warming.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Nespresso coffee-machine cartons",
        "marker": [
          67,
          63
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle right",
        "note": "Photo 3 shows Nespresso and De'Longhi branding on a capsule-coffee-machine carton; model text is obscured.",
        "quantityLabel": "Multiple cartons shown",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Pop+ Pacific Blue coffee machine",
        "comparisonNote": "Colour and bundle contents may differ.",
        "priceUnit": "one machine, no milk frother",
        "source": "Nespresso Canada",
        "url": "https://www.nespresso.com/ca/en/order/machines/vertuo/vertuo-pop-plus-pacific-blue",
        "referenceKey": "nespresso_pop",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach microwave carton",
        "marker": [
          43,
          16
        ],
        "photoIndex": 4,
        "position": "Photo 4 · top centre",
        "note": "The rear view shows Hamilton Beach microwave packaging.",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Proscan 6-in-1 turntable cartons",
        "marker": [
          47,
          48
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows Proscan Turntable 6 in 1 packaging; colour and model suffix are unclear.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Sylvania portable DVD-player packaging",
        "marker": [
          71,
          37
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle right",
        "note": "Sylvania Portable DVD Player is visible. Screen size and whether it is a dual-screen set need confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CD/Bluetooth boombox cartons",
        "marker": [
          34,
          74
        ],
        "photoIndex": 4,
        "position": "Photo 4 · bottom centre",
        "note": "Several packages say CD Bluetooth Boombox. Exact brand/model markings are not consistently legible.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BLACK+DECKER rice-cooker carton",
        "marker": [
          67,
          48
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle right",
        "note": "Photo 3 shows BLACK+DECKER Rice Cooker packaging.",
        "price": 49.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Rice Robot 4-cup cooker, model 2524. Confirm the size on the carton.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Staples Canada",
        "url": "https://www.staples.ca/products/3096930-en-rice-robot-4-cup-space-saving-rice-cooker-with-ceramic-nonstick-inner-pot-white",
        "referenceKey": "rice_cooker",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Coffee-maker cartons",
        "marker": [
          75,
          60
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle right",
        "note": "Photo 2 shows several coffee-maker packages, including De'Longhi branding. The exact machine types and model numbers are not clear enough for one price.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "BISSELL Little Green portable-cleaner carton",
        "marker": [
          67,
          87
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom right",
        "note": "Photo 2 shows a Little Green portable-cleaner package at the bottom right.",
        "price": 159.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL Little Green ProHeat Deluxe portable carpet cleaner, 25137 bundle",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "bissell_little_green",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Steam-mop carton",
        "marker": [
          51,
          34
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The tall green carton in photo 2 pictures a steam mop; the brand and model are obscured.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "best-buy-electronics-21-free-shipping-eligible": {
    "title": "Best Buy Electronics #21 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #21",
    "productId": "gid://shopify/Product/9663644008703",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-21-free-shipping-eligible-best-buy-electronics-21-free-shipping-eligible-liquidationdeals-ca-1256995177.jpg?v=1788468517",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-21-free-shipping-eligible-best-buy-electronics-21-free-shipping-eligible-liquidationdeals-ca-1256995177.jpg?v=1788468517",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-21-free-shipping-eligible-best-buy-electronics-21-free-shipping-eligible-liquidationdeals-ca-1256995178.jpg?v=1788468491",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-21-free-shipping-eligible-best-buy-electronics-21-free-shipping-eligible-liquidationdeals-ca-1256995220.jpg?v=1788468457",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-21-free-shipping-eligible-best-buy-electronics-21-free-shipping-eligible-liquidationdeals-ca-1256995180.jpg?v=1788468431",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Midea 5000 BTU window-AC cartons",
        "marker": [
          56,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Several Midea 5000 BTU room air-conditioner cartons are visible.",
        "quantityLabel": "Multiple cartons shown",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea portable-AC cartons",
        "marker": [
          28,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Midea 3-in-1 portable air-conditioner cartons show more than one capacity.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Arctic King 7-cu.-ft. convertible chest-freezer carton",
        "marker": [
          61,
          72
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom centre",
        "note": "Photo 2 shows Arctic King, 7.0 cu. ft. and Convertible Chest Freezer.",
        "price": 239.97,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Arctic King 7.0-cu.-ft. convertible chest freezer",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Arctic-King-7-0-Cu-Ft-Convertible-Chest-Freezer/4S331NT2LQK3",
        "referenceKey": "chest_freezer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BISSELL PowerClean Pet Pro carton",
        "marker": [
          27,
          63
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle left",
        "note": "Photo 2 shows BISSELL PowerClean and Pet Pro branding on a carpet-cleaner carton.",
        "price": 89,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "BISSELL PowerForce PowerBrush Pet Advanced carpet cleaner 2910",
        "comparisonNote": "Different BISSELL carpet-cleaner model; features and attachments vary.",
        "priceUnit": "one carpet cleaner",
        "source": "BISSELL US",
        "url": "https://www.bissell.com/en-us/product/powerforce-powerbrush-pet-advanced-carpet-cleaner-2910.html",
        "referenceKey": "bissell_upright_cleaner",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BISSELL Little Green portable-cleaner carton",
        "marker": [
          27,
          85
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom left",
        "note": "BISSELL Little Green packaging appears below the upright-cleaner carton.",
        "price": 159.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL Little Green ProHeat Deluxe portable carpet cleaner, 25137 bundle",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "bissell_little_green",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Eureka cordless stick-vacuum carton",
        "marker": [
          28,
          20
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top left",
        "note": "A Eureka cordless stick-vacuum package is visible; the model suffix is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Hyper Tough pressure-washer carton",
        "marker": [
          59,
          29
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top centre",
        "note": "Photo 3 shows Hyper Tough branding and pressure-washer accessories.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Frigidaire water-dispenser cartons",
        "marker": [
          31,
          30
        ],
        "photoIndex": 4,
        "position": "Photo 4 · top left",
        "note": "Photo 4 shows Frigidaire dispenser packaging with 3- or 5-gallon bottle compatibility.",
        "quantityLabel": "Multiple cartons shown",
        "price": 258,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Westinghouse water-dispenser cartons",
        "marker": [
          74,
          29
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top right",
        "note": "Photo 3 shows Westinghouse dispenser packaging. Exact model numbers are obscured.",
        "quantityLabel": "Multiple cartons shown",
        "price": 258,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "best-buy-electronics-22-free-shipping-eligible": {
    "title": "Best Buy Electronics #22 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #22",
    "productId": "gid://shopify/Product/9663642665215",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-22-free-shipping-eligible-best-buy-electronics-22-free-shipping-eligible-liquidationdeals-ca-1256995228.jpg?v=1788468636",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-22-free-shipping-eligible-best-buy-electronics-22-free-shipping-eligible-liquidationdeals-ca-1256995228.jpg?v=1788468636",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-22-free-shipping-eligible-best-buy-electronics-22-free-shipping-eligible-liquidationdeals-ca-1256995224.jpg?v=1788468609",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-22-free-shipping-eligible-best-buy-electronics-22-free-shipping-eligible-liquidationdeals-ca-1256995223.jpg?v=1788468576",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-22-free-shipping-eligible-best-buy-electronics-22-free-shipping-eligible-liquidationdeals-ca-1256995222.jpg?v=1788468548",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Midea portable air-conditioner cartons",
        "marker": [
          34,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Midea 3-in-1 portable air-conditioner cartons appear on every side; capacity labels vary.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea 5000 BTU window-AC cartons",
        "marker": [
          70,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "5000 BTU is readable on the Midea room air-conditioner cartons.",
        "quantityLabel": "Multiple cartons shown",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Frigidaire compact refrigerator carton",
        "marker": [
          59,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Frigidaire branding and a two-door compact-refrigerator image are visible. The capacity badge is not clear enough for an exact model match.",
        "price": 259.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Frigidaire 4.5-cu.-ft. compact refrigerator with freezer, platinum",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Frigidaire-4-5-Cu-ft-Compact-Retro-Refrigerator-with-Freezer-Compartment-Platinum-Mini-Fridge-for-Bedroom-Dorm-Office-Apartment/6000207840380",
        "referenceKey": "frigidaire_fridge",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BLACK+DECKER portable AC with heat carton",
        "marker": [
          32,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The carton says 8350 BTU SACC / 12000 BTU ASHRAE and heat mode.",
        "price": 549.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BLACK+DECKER 10200 BTU SACC / 14000 BTU ASHRAE portable air conditioner",
        "comparisonNote": "Comparison is the cooling model listed by the retailer; capacity and heat-mode features may differ.",
        "priceUnit": "one air conditioner",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Black-Decker-Portable-Air-Conditioner-10-200-BTU-SACC-CEC-14-000-BTU-ASHRAE-128-for-Rooms-Up-To-700-Sq-Ft-White/71SEXRNSOGY2",
        "referenceKey": "blackdecker_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Master Chef digital air-fryer carton",
        "marker": [
          72,
          17
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top right",
        "note": "Photo 3 shows a Master Chef 5.7 L digital air-fryer package.",
        "price": 78,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Gourmia 6-quart digital window air fryer, black",
        "comparisonNote": "Pictured capacity/model is not established; comparison is the 6-quart window version.",
        "priceUnit": "one air fryer",
        "source": "Walmart US",
        "url": "https://www.walmart.com/ip/Gourmia-6-Qt-Digital-Window-Air-Fryer-with-12-Presets-Guided-Cooking-Black/5218129948",
        "referenceKey": "gourmia_air_fryer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Eureka AirSwivel Pro upright-vacuum carton",
        "marker": [
          70,
          39
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle right",
        "note": "Eureka AirSwivel Pro is readable in photo 3.",
        "price": 94.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "BISSELL PowerForce Compact 2112 upright vacuum",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/BISSELL-PowerForce-Compact-Bagless-Improved/dp/B07JJPKVTP",
        "referenceKey": "bissell_powerforce",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ninja Foodi dual-basket air-fryer carton",
        "marker": [
          51,
          45
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows a Ninja Foodi two-basket appliance; the exact capacity is not clear.",
        "price": 139.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Chefman 8.5L / 9-quart dual-basket air fryer, RJ38-SQPF-45TDB-CA. Confirm capacity on the carton.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Chefman Direct · Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Chefman-TurboFry-Digital-Touch-Dual-Basket-Air-Fryer-XL-8-5L-9-Quart/7AVPK94FMIWY",
        "referenceKey": "dual_airfryer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Partly visible wheeled frame",
        "marker": [
          58,
          7
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top centre",
        "note": "A green wheeled frame protrudes above the cartons. The photo does not show a complete identifiable product.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "best-buy-electronics-23-free-shipping-eligible": {
    "title": "Best Buy Electronics #23 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #23",
    "productId": "gid://shopify/Product/9663641518335",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-23-free-shipping-eligible-best-buy-electronics-23-free-shipping-eligible-liquidationdeals-ca-1256995181.jpg?v=1788468758",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-23-free-shipping-eligible-best-buy-electronics-23-free-shipping-eligible-liquidationdeals-ca-1256995181.jpg?v=1788468758",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-23-free-shipping-eligible-best-buy-electronics-23-free-shipping-eligible-liquidationdeals-ca-1256995231.jpg?v=1788468731",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-23-free-shipping-eligible-best-buy-electronics-23-free-shipping-eligible-liquidationdeals-ca-1256995226.jpg?v=1788468698",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-23-free-shipping-eligible-best-buy-electronics-23-free-shipping-eligible-liquidationdeals-ca-1256995184.jpg?v=1788468669",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Panasonic 1.3-cu.-ft. microwave cartons",
        "marker": [
          31,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Panasonic, 1.3 cu. ft. and 1100 W appear on multiple microwave cartons.",
        "quantityLabel": "Multiple cartons shown",
        "price": 249.95,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Panasonic NN-SU66LS 1.3-cu.-ft. 1100W Genius Sensor microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Panasonic US",
        "url": "https://shop.panasonic.com/products/1-3-cu-ft-genius-sensor-microwave-1100w-nn-su66ls",
        "referenceKey": "panasonic_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach microwave cartons",
        "marker": [
          59,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Hamilton Beach microwave packaging appears on several sides. Different carton designs may indicate different models.",
        "quantityLabel": "Multiple cartons shown",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach countertop-oven cartons",
        "marker": [
          81,
          23
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top right",
        "note": "Green cartons show a countertop oven; exact model and functions are not readable.",
        "quantityLabel": "Multiple cartons shown",
        "price": 154.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 31103DC convection countertop oven with rotisserie",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Countertop-Oven-with-Convection-Rotisserie-31103DC/3MVW1XZBPOJ8",
        "referenceKey": "countertop_oven",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea 5000 BTU window-AC cartons",
        "marker": [
          48,
          30
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top centre",
        "note": "Photo 3 shows 5000 BTU Midea room air-conditioner packaging.",
        "quantityLabel": "Multiple cartons shown",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea portable-AC cartons",
        "marker": [
          73,
          65
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle right",
        "note": "Photo 3 shows Midea 3-in-1 portable AC cartons, including a 7000 BTU SACC / 10000 BTU ASHRAE label.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "BLACK+DECKER portable-AC carton",
        "marker": [
          50,
          34
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows 6300 BTU DOE / 10000 BTU ASHRAE and BLACK+DECKER branding.",
        "price": 549.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BLACK+DECKER 10200 BTU SACC / 14000 BTU ASHRAE portable air conditioner",
        "comparisonNote": "Comparison is the cooling model listed by the retailer; capacity and heat-mode features may differ.",
        "priceUnit": "one air conditioner",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Black-Decker-Portable-Air-Conditioner-10-200-BTU-SACC-CEC-14-000-BTU-ASHRAE-128-for-Rooms-Up-To-700-Sq-Ft-White/71SEXRNSOGY2",
        "referenceKey": "blackdecker_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Nespresso Vertuo Pop+ carton",
        "marker": [
          54,
          20
        ],
        "photoIndex": 2,
        "position": "Photo 2 · top centre",
        "note": "A Nespresso Vertuo Pop+ package with Breville branding is visible at the back.",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Pop+ Pacific Blue coffee machine",
        "comparisonNote": "Colour and bundle contents may differ.",
        "priceUnit": "one machine, no milk frother",
        "source": "Nespresso Canada",
        "url": "https://www.nespresso.com/ca/en/order/machines/vertuo/vertuo-pop-plus-pacific-blue",
        "referenceKey": "nespresso_pop",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ninja Swirl by CREAMi carton",
        "marker": [
          56,
          59
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "Ninja Swirl by CREAMi branding and the dispensing appliance are visible.",
        "price": 349.98,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Ninja Swirl by CREAMi NC701C ice-cream and soft-serve machine",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/Ninja-Milkshake-Calories-Program-NC701C/dp/B0DXXMW8T9",
        "referenceKey": "ninja_swirl",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Greenworks corded lawn-mower carton",
        "marker": [
          78,
          68
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom right",
        "note": "The Greenworks carton says 36 cm / 14 in. and 9 A corded.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Cuisinart countertop convection-oven carton",
        "marker": [
          47,
          55
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 shows Cuisinart Countertop Convection Oven packaging.",
        "price": 154.98,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 31103DC convection countertop oven with rotisserie",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Countertop-Oven-with-Convection-Rotisserie-31103DC/3MVW1XZBPOJ8",
        "referenceKey": "countertop_oven",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "LG microwave carton",
        "marker": [
          28,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The black LG carton says Microwave Oven; capacity and model are obscured.",
        "price": 203,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "LG MSER1590S 1.5-cu.-ft. countertop microwave",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Canadian Appliance Source",
        "url": "https://www.canadianappliance.ca/product/LG_MSER1590S_Countertop_Microwaves_LG_MSER1590S.html",
        "referenceKey": "lg_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Water-dispenser cartons",
        "marker": [
          28,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Blue dispenser packaging is visible. Other sides also show Westinghouse dispenser cartons; exact models are unclear.",
        "quantityLabel": "Multiple cartons shown",
        "price": 258,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "best-buy-electronics-24-free-shipping-eligible": {
    "title": "Best Buy Electronics #24 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Best Buy Electronics #24",
    "productId": "gid://shopify/Product/9663640797439",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "bestbuy"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-24-free-shipping-eligible-best-buy-electronics-24-free-shipping-eligible-liquidationdeals-ca-1256995232.jpg?v=1788468877",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-24-free-shipping-eligible-best-buy-electronics-24-free-shipping-eligible-liquidationdeals-ca-1256995232.jpg?v=1788468877",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-24-free-shipping-eligible-best-buy-electronics-24-free-shipping-eligible-liquidationdeals-ca-1256995229.jpg?v=1788468851",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-24-free-shipping-eligible-best-buy-electronics-24-free-shipping-eligible-liquidationdeals-ca-1256995197.jpg?v=1788468817",
        "width": 1200,
        "height": 1600
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/best-buy-electronics-24-free-shipping-eligible-best-buy-electronics-24-free-shipping-eligible-liquidationdeals-ca-1256995233.jpg?v=1788468789",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Midea 3-in-1 portable air-conditioner cartons",
        "marker": [
          29,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Several Midea portable AC cartons are visible from different sides, with different capacity labels. They are grouped here to avoid counting the same carton twice.",
        "quantityLabel": "Multiple cartons shown",
        "price": 388,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 10000 BTU ASHRAE / 7000 BTU SACC portable air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-10-000-BTU-ASHRAE-7-000-BTU-SACC-Portable-Air-Conditioner/6000205573216",
        "referenceKey": "midea_portable_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Midea room air-conditioner carton",
        "marker": [
          67,
          29
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top right",
        "note": "Photo 3 shows a Midea Room Air Conditioner carton among the portable units.",
        "price": 140,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Midea 5000 BTU mechanical window air conditioner",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Midea-5000-BTU-Mechanical-Window-Air-Conditioner/6000205572807",
        "referenceKey": "midea_window_ac",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hamilton Beach microwave cartons",
        "marker": [
          50,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Hamilton Beach branding and microwave images are visible.",
        "quantityLabel": "Multiple cartons shown",
        "price": 99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Panasonic 1.3-cu.-ft. microwave cartons",
        "marker": [
          55,
          43
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows Panasonic 1.3-cu.-ft. microwave packaging. Exact model suffixes are obscured.",
        "quantityLabel": "Multiple cartons shown",
        "price": 249.95,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Panasonic NN-SU66LS 1.3-cu.-ft. 1100W Genius Sensor microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Panasonic US",
        "url": "https://shop.panasonic.com/products/1-3-cu-ft-genius-sensor-microwave-1100w-nn-su66ls",
        "referenceKey": "panasonic_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "AERLANG neck-and-shoulder massager carton",
        "marker": [
          49,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "AERLANG branding and the neck-and-shoulder massager illustration are visible; model is unclear.",
        "price": 77.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "AERLANG Shiatsu neck and shoulder massager with heat",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/ip/AERLANG-Shiatsu-Neck-Shoulder-Massager-Back-Massager-Heat-Deeper-Tissue-Kneading-Massage-Shoulder-Neck-Back-Massage-Electric-Massagers-Fathers-Day-Gi/17072701245",
        "referenceKey": "neck_massager",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Westinghouse water-dispenser carton",
        "marker": [
          72,
          71
        ],
        "photoIndex": 4,
        "position": "Photo 4 · bottom right",
        "note": "Photo 4 shows Westinghouse branding and a water-dispenser image.",
        "price": 258,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Westinghouse Premium bottom-loading tri-temperature water dispenser",
        "comparisonNote": "Comparison is a bottom-loading model; bottle loading style and temperature options may differ.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Westinghouse-Premium-Bottom-Loading-Tri-Temp-Water-Dispenser/6000205879989",
        "referenceKey": "water_dispenser",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Black wrapped appliance",
        "marker": [
          31,
          64
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle left",
        "note": "The rear view shows a black appliance and an energy label, but no clear product label or model.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-190": {
    "title": "Bulk Electronics #188 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #188",
    "productId": "gid://shopify/Product/9662242619647",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-188-free-shipping-eligible-bulk-electronics-188-free-shipping-eligible-liquidationdeals-ca-1256833059.jpg?v=1788381069",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-188-free-shipping-eligible-bulk-electronics-188-free-shipping-eligible-liquidationdeals-ca-1256833059.jpg?v=1788381069",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Artika Imperium pendant lights",
        "marker": [
          54,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Imperium and Artika are printed on two geometric pendant-light cartons; finishes differ.",
        "quantityLabel": "2 cartons shown",
        "price": 69,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Artika Imperium single pendant light, brushed nickel",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Artika US",
        "url": "https://artika.com/products/imperium-2",
        "referenceKey": "artika_imperium",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "LANCHEZ submersible pumps",
        "marker": [
          23,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "LANCHEZ Submersible Pump wording and pump drawings appear on two cartons; ratings/models need confirmation.",
        "quantityLabel": "2 cartons shown",
        "price": 40.49,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "STEELITE DG530-2 garden shredder",
        "marker": [
          40,
          62
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "STEELITE GARDEN SHREDDER DG530-2 is printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "COMFEE dishwasher",
        "marker": [
          29,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "COMFEE and DISHWASHER are readable; exact model/place-setting capacity is unclear.",
        "price": 289.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Comfee black countertop dishwasher, 6 place settings",
        "comparisonNote": "Capacity, controls and water connection may differ from the pictured model.",
        "priceUnit": "one dishwasher",
        "source": "Comfee",
        "url": "https://shop.feelcomfee.com/products/black-countertop-portable-dishwasher",
        "referenceKey": "comfee_dishwasher",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Food chopper",
        "marker": [
          54,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "FOOD CHOPPER and bowl/motor illustrations are visible; exact brand/capacity is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vibration plate",
        "marker": [
          81,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "VIBRATION PLATE is printed; brand/model is hidden.",
        "price": 199.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Lifepro Waver vibration plate",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Lifepro",
        "url": "https://lifeprofitness.com/products/the-waver-vibration-platform",
        "referenceKey": "vibration_plate",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "MEDCURSOR-branded appliance carton",
        "marker": [
          22,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "The brand is visible, but the device type and model are not sufficiently clear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Pocezo-branded carton",
        "marker": [
          84,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "The brand is readable; the product type is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-189": {
    "title": "Bulk Electronics #189 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #189",
    "productId": "gid://shopify/Product/9662242554111",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-189-free-shipping-eligible-bulk-electronics-189-free-shipping-eligible-liquidationdeals-ca-1256833058.jpg?v=1788381096",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-189-free-shipping-eligible-bulk-electronics-189-free-shipping-eligible-liquidationdeals-ca-1256833058.jpg?v=1788381096",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "HANDNAM drywall sander",
        "marker": [
          50,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "DRYWALL SANDER and HANDNAM are printed; motor and disc specifications are not visible.",
        "price": 139.9,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR foldable electric drywall sander with LED light and vacuum bag. Wattage/model differs or is unreadable.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "VEVOR Canada",
        "url": "https://www.vevor.ca/electric-drywall-sander-c_11011/vevor-drywall-sander-electric-foldable-sander-750w-with-led-light-and-vacuum-bag-p_010906349725",
        "referenceKey": "drywall_sander",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "KBS bread maker",
        "marker": [
          37,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "KBS bread-machine packaging lists 17 programmes; exact model/capacity is not confirmed.",
        "price": 89.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 2-lb programmable bread maker, white, 12 settings",
        "comparisonNote": "Different model/brand; loaf size and programs may differ.",
        "priceUnit": "one bread maker",
        "source": "Walmart US",
        "url": "https://www.walmart.com/ip/Hamilton-Beach-Bread-Maker-Machine-Digital-Programmable-12-Settings-Plus-Gluten-Free-2-lb-Capacity-White/1055806349",
        "referenceKey": "bread_maker",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Steam cleaner",
        "marker": [
          68,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "STEAM CLEANER and a canister-style steam cleaner are pictured; model is unclear.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "NORTHCLAN thermoelectric cooler/warmer",
        "marker": [
          37,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "THERMOELECTRIC COOLER AND WARMER and model YT-A-15X are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric griddle",
        "marker": [
          64,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Electric Griddle is printed; cooking-surface dimensions are not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "FOTING shallow-well jet pump",
        "marker": [
          29,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "FOTING and a shallow-well pump with pressure tank are pictured; exact rating is unclear.",
        "price": 79.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "LANCHEZ 1.2 HP / 2,100 GPH shallow-well pump. Reference listing does not confirm the same model/flow rating.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/ip/LANCHEZ-1-2-HP-Stainless-Steel-Shallow-Well-Pump-115V-2100-GPH-Water-Booster-Jet-Pump/20147259225",
        "referenceKey": "jet_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Aimiler electric-vehicle charger",
        "marker": [
          81,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Electric Vehicle Charger and Aimiler are printed; connector, amperage and supply requirements need confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vibration plate",
        "marker": [
          14,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "VIBRATION PLATE is printed; exact brand/model is not visible.",
        "price": 199.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Lifepro Waver vibration plate",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Lifepro",
        "url": "https://lifeprofitness.com/products/the-waver-vibration-platform",
        "referenceKey": "vibration_plate",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "bulk-electronics-186": {
    "title": "Bulk Electronics #185 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #185",
    "productId": "gid://shopify/Product/9662226104575",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-185-bulk-electronics-185-liquidationdeals-ca-1256791588.png?v=1788359377",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-185-bulk-electronics-185-liquidationdeals-ca-1256791588.png?v=1788359377",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "KitchenAid Pure Power blender",
        "marker": [
          59,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "PURE POWER BLENDER and KitchenAid are printed; exact model/colour code needs confirmation.",
        "price": 99.97,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "KitchenAid Pure Power blender KSB2072BM",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/KitchenAid%C2%AE-Pure-Power-Blender-KSB2072BM/dp/B09R4NTXVR",
        "referenceKey": "kitchenaid_blender",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "AC Infinity CLOUDLINE S6 inline fan",
        "marker": [
          90,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "CLOUDLINE S6 and Environmental Inline Fan are printed.",
        "price": 99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "AC Infinity CLOUDLINE S6 6-inch inline fan with speed controller",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "AC Infinity",
        "url": "https://acinfinity.com/cloudline-s6-quiet-inline-fan-6-with-speed-controller/",
        "referenceKey": "cloudline_s6",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Herdio 6.5-inch in-wall/in-ceiling speakers",
        "marker": [
          60,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "6.5-inch two-way full-range speakers are described; pack quantity is not verified.",
        "price": 163.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Herdio 6.5-inch in-ceiling speakers, HCS4-628 four-speaker set",
        "comparisonNote": "Pictured package's speaker count and wiring/amplifier bundle are not confirmed.",
        "priceUnit": "one four-speaker set",
        "source": "Herdio",
        "url": "https://herdiotech.com/products/6-5-ceiling-speakers-300-watts-hcs4-628-4-speakers",
        "referenceKey": "herdio_speakers",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Gawfolk computer monitor",
        "marker": [
          66,
          10
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Gawfolk and Computer LED Monitor are printed; size/resolution are not visible.",
        "price": 85.79,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Gawfolk 24.5-inch 120Hz FHD curved monitor with speakers, black",
        "comparisonNote": "Size, resolution and refresh rate on the pallet carton are not confirmed.",
        "priceUnit": "one monitor",
        "source": "Gawfolk at Walmart US",
        "url": "https://www.walmart.com/ip/Gawfolk-24-Inch-Curved-Gaming-Monitor-100Hz-Full-HD-1080P-Built-In-Speakers-Tilt-Adjustable/5136475758",
        "referenceKey": "computer_monitor",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Waitbird CB-03A steam cleaner",
        "marker": [
          57,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Waitbird CB-03A and the steam-cleaner drawing are readable.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Additional steam-cleaner carton",
        "marker": [
          89,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Product Name: Steam Cleaner is printed; model and electrical configuration require confirmation.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "TANGME electric fryer",
        "marker": [
          25,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "TANGME Electric Fryer and a basket fryer are pictured; capacity is not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Fan-light fixture — B259 carton",
        "marker": [
          54,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Intelligent Fan Light and B259 are printed; diameter and fixture specifications are not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Pendant light — JP-435-3AY/1 carton",
        "marker": [
          25,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Pendant Lights, a hanging-light illustration and the model code are visible.",
        "price": 69,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Artika Imperium single pendant light, brushed nickel",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Artika US",
        "url": "https://artika.com/products/imperium-2",
        "referenceKey": "artika_imperium",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Carton labelled AMPLIFIER AMP2",
        "marker": [
          25,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "An audio amplifier is named, but the brand and electrical specifications are not clear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Bluetooth microphone/rhythm speaker carton",
        "marker": [
          47,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Bluetooth and Microphone Rhythm Speaker are printed; exact model/accessories are unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "bulk-electronics-184": {
    "title": "Bulk Electronics #184 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #184",
    "productId": "gid://shopify/Product/9662226039039",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-184-bulk-electronics-184-liquidationdeals-ca-1256791589.png?v=1788359412",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-184-bulk-electronics-184-liquidationdeals-ca-1256791589.png?v=1788359412",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "MALYAN desktop 3D printer",
        "marker": [
          23,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "MALYAN Desktop 3D Printer is printed; model/build volume is not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "PXN V99 force-feedback racing wheel",
        "marker": [
          57,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "PXN V99 and Force Feedback Racing Wheel are readable; pedals are pictured.",
        "price": 179.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "PXN V9 Gen2 steering wheel, pedals and shifter",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one wheel/pedals/shifter set",
        "source": "PXN US",
        "url": "https://us.e-pxn.com/products/pxn-v9-gen2-steering-wheel",
        "referenceKey": "pxn_v9",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "PXN V900 Gen2 racing wheel",
        "marker": [
          25,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "PXN V900 Gen2 is printed; exact bundle contents are not checked.",
        "price": 115.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "PXN V900 Gen2 wheel and pedal bundle",
        "comparisonNote": "Generation, compatibility and supplied pedals may differ.",
        "priceUnit": "one wheel and pedal set",
        "source": "PXN",
        "url": "https://shop.e-pxn.com/products/pxn-v900-gen2-steering-wheel",
        "referenceKey": "pxn_v900",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Levoit Core 200S smart air purifier",
        "marker": [
          24,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Levoit Core 200S Smart Air Purifier is printed.",
        "price": 74.96,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Levoit Core 200S-P smart air purifier",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Levoit US",
        "url": "https://levoit.com/products/core-200s-p-smart-air-purifier",
        "referenceKey": "levoit_core200",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Waitbird CB-03A steam cleaner",
        "marker": [
          46,
          58
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Waitbird, CB-03A and multi-function steam-cleaner wording are readable.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electric pressure cooker",
        "marker": [
          25,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "An electric pressure cooker and cooking presets are pictured; brand/capacity is not clear.",
        "price": 109.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Instant Pot Duo 6-quart multi-use pressure cooker",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Instant Pot",
        "url": "https://instantpot.com/products/instant-pot-duo-6qt-multi-use-pressure-cooker",
        "referenceKey": "pressure_cooker",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Food dehydrator",
        "marker": [
          27,
          92
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "FOOD DEHYDRATOR and a tray-cabinet illustration are visible; tray count/size is unclear.",
        "price": 99.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 32100C food dehydrator",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/Hamilton-Beach-32100C-Hamilton-Beach-Dehydrator/dp/B013JL6J7Y",
        "referenceKey": "dehydrator",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Countertop electric composter",
        "marker": [
          84,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "COMPOSTER, 4.0L capacity and 500W are printed; brand/model needs confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Air-purifier carton",
        "marker": [
          59,
          10
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Air-purifier wording is visible on the blue carton; exact model is not readable.",
        "price": 74.96,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Levoit Core 200S-P smart air purifier",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Levoit US",
        "url": "https://levoit.com/products/core-200s-p-smart-air-purifier",
        "referenceKey": "levoit_core200",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "SNAILAX-branded carton",
        "marker": [
          85,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Only SNAILAX branding and its slogan are visible; the exact product is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-178": {
    "title": "Bulk Electronics #178 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #178",
    "productId": "gid://shopify/Product/9662223319295",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-178-bulk-electronics-178-liquidationdeals-ca-1256791595.png?v=1788359591",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-178-bulk-electronics-178-liquidationdeals-ca-1256791595.png?v=1788359591",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "CUSIMAX kitchen stand mixer",
        "marker": [
          71,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "CUSIMAX KITCHEN MIXER and bowl/attachments are pictured; model and bowl size are unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "MUSETEX computer case",
        "marker": [
          67,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "MUSETEX and a desktop-tower chassis are pictured. The box does not establish that PC components are included.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "TVD SW608-A steam cleaner",
        "marker": [
          36,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "TVD STEAM CLEANER SW608-A is readable.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "FOTING QB50G4 sump pump",
        "marker": [
          68,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "FOTING QB50G4 Stainless Steel Sump Pump is printed.",
        "price": 40.49,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "UMAY U5 under-desk elliptical trainer",
        "marker": [
          43,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "UMAY U5 Elliptical Trainer and a compact pedal unit are pictured.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "ATV/UTV soundbar",
        "marker": [
          17,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "ATV/UTV SOUNDBAR AUDIO SYSTEMS is printed; brand, length and power rating are unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Dehumidifier",
        "marker": [
          36,
          15
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "DEHUMIDIFIER is printed; model/capacity is hidden.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "IKROOO steam cleaner",
        "marker": [
          70,
          91
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "IKROOO STEAM CLEANER and a canister cleaner are pictured.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Vibration-plate carton",
        "marker": [
          17,
          89
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "VIBRATION PLATE is visible on the side label; model is unclear.",
        "price": 199.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Lifepro Waver vibration plate",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Lifepro",
        "url": "https://lifeprofitness.com/products/the-waver-vibration-platform",
        "referenceKey": "vibration_plate",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "bulk-electronics-175": {
    "title": "Bulk Electronics #175 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #175",
    "productId": "gid://shopify/Product/9662223024383",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-175-bulk-electronics-175-liquidationdeals-ca-1256791597.png?v=1788359650",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-175-bulk-electronics-175-liquidationdeals-ca-1256791597.png?v=1788359650",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Giraffe Tools Grandfalls wall-mounted pressure washer",
        "marker": [
          53,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "GRANDFALLS PRESSURE WASHER WITH 65FT AUTO-RETRACT HOSE is printed.",
        "price": 629.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Giraffe Tools Grandfalls Pro 3700 PSI wall-mounted pressure washer",
        "comparisonNote": "Pro-series comparison; photographed generation, hose length and pressure rating may differ.",
        "priceUnit": "one product",
        "source": "Giraffe Tools US",
        "url": "https://giraffetools.com/products/grandfalls-pressure-washer-pro",
        "referenceKey": "grandfalls",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "FOTING electric pressure washer",
        "marker": [
          59,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "FOTING, 13A and 2.8 GPM are printed; exact model is not visible.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Pressure washer — G5163-Yellow carton",
        "marker": [
          28,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The washer illustration and G5163-Yellow code are visible; brand/rating need confirmation.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "MaxLander MLDS01 electric dethatcher/scarifier",
        "marker": [
          25,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "MaxLander Electric Dethatcher & Scarifier and MLDS01 are printed.",
        "price": 139.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe AJ801E 13-inch 12A electric scarifier/dethatcher",
        "comparisonNote": "Width and motor differ; this comparison is corded, including when the pictured machine is cordless.",
        "priceUnit": "one corded machine",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-13-in-12-Amp-Electric-Scarifier-Lawn-Dethatcher-with-Collection-Bag-AJ801E/207137229",
        "referenceKey": "electric_dethatcher",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electric garage heater — 8500W",
        "marker": [
          27,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "8500W / 240V / 29010 BTU is printed; brand/model is not visible.",
        "price": 250.96,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Namdaq 8500W 240V hardwired garage heater with remote",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/AFAIF-8500W-Electric-Garage-Heater-240V-with-Thermostat-and-Timer-with-Overheat-Protection-and-Remote-Hardwired-NO-PLUG-HDBFDJ24030601/329895275",
        "referenceKey": "garage_heater",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "COMFORTLIFE CL9 towel-warmer cabinet",
        "marker": [
          59,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Towel Warmer Cabinet COMFORTLIFE (CL9) is printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "FOTING submersible utility pump",
        "marker": [
          82,
          33
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Submersible Utility Pump and FOTING are printed; exact model is not clear.",
        "price": 40.49,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Three-in-one iced coffee maker",
        "marker": [
          82,
          51
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "3 IN 1 ICED COFFEE MAKER is printed; brand/model and capacity are unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric grinder carton",
        "marker": [
          80,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "GRINDER and a cylindrical grinding appliance are visible; capacity/model are not clear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Adjustable trailer-hitch carton",
        "marker": [
          59,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A 2.5-inch receiver and six-inch drop/rise selection are printed; towing ratings and complete kit need verification.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "AUXBEAM LED fog lights",
        "marker": [
          23,
          8
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "LED FOG LIGHTS is printed; vehicle fitment is not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "White room-appliance carton",
        "marker": [
          80,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "A white room appliance is pictured, but the function/model is not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-174": {
    "title": "Bulk Electronics #174 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #174",
    "productId": "gid://shopify/Product/9662222860543",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-174-bulk-electronics-174-liquidationdeals-ca-1256791598.png?v=1788359678",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-174-bulk-electronics-174-liquidationdeals-ca-1256791598.png?v=1788359678",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "Rice Robot rice cooker",
        "marker": [
          21,
          12
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Rice Robot branding and cooker pictured. Capacity/model label is covered.",
        "quantityLabel": "1 carton",
        "price": 49.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Rice Robot 4-cup cooker, model 2524. Confirm the size on the carton.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Staples Canada",
        "url": "https://www.staples.ca/products/3096930-en-rice-robot-4-cup-space-saving-rice-cooker-with-ceramic-nonstick-inner-pot-white",
        "referenceKey": "rice_cooker",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "FOTING submersible utility pump",
        "marker": [
          58,
          12
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "FOTING and “Submersible utility pump” are printed on the carton. Horsepower is obscured.",
        "quantityLabel": "1 carton",
        "price": 40.49,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "DEKO electric snow shovel",
        "marker": [
          31,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "DEKO snow-shovel illustration; 110–120V / 60Hz and 20 ft throw printed on the box. Model partly covered.",
        "quantityLabel": "1 carton",
        "price": 151.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR SPEG08U, 12A, 17-inch corded snow shovel. Listed out of stock; DEKO model/width not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "VEVOR at Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/VEVOR-Electric-Snow-Shovel-12A-17-inch-Corded-60-Adjustable-Chute-20-ft-Throwing-Distance-Snowthrower-Dual-Safety-Switch-Winter-Ice-Removal-Tool-Driv/6E8ZTUAL7Z2D",
        "referenceKey": "snow_shovel",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Anybear Juice Master juicer",
        "marker": [
          60,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Anybear “Juice Master” branding and vertical juicer pictured. Exact model/wattage is not readable.",
        "quantityLabel": "1 carton",
        "price": 159.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Anybear/Amumu 250W cold-press juicer with 4.3-inch chute. Listed sold out; model match needs confirmation.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Anybear U.S. store",
        "url": "https://anybear.com/products/1",
        "referenceKey": "slow_juicer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "VELPAX long-reach drywall sander",
        "marker": [
          83,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "VELPAX branding with a circular sanding head, telescopic shaft and dust hose pictured.",
        "quantityLabel": "1 carton",
        "price": 139.9,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR foldable electric drywall sander with LED light and vacuum bag. Wattage/model differs or is unreadable.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "VEVOR Canada",
        "url": "https://www.vevor.ca/electric-drywall-sander-c_11011/vevor-drywall-sander-electric-foldable-sander-750w-with-led-light-and-vacuum-bag-p_010906349725",
        "referenceKey": "drywall_sander",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Small cylindrical appliance carton",
        "marker": [
          61,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "A white cylindrical appliance is pictured. Wrapping obscures the product name and brand.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "ZIPEAK ceiling-hanging heater",
        "marker": [
          31,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "ZIPEAK and “Ceiling Hanging Heater” are readable. Wattage/model is not visible.",
        "quantityLabel": "1 carton",
        "price": 189.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "EnerG+ HEA-22000HBR, 750/1,500W hanging infrared heater. ZIPEAK specifications are not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot Canada",
        "url": "https://www.homedepot.ca/product/energ-infrared-electric-outdoor-heater-hanging/1001965805",
        "referenceKey": "hanging_heater",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "LANCHEZ shallow-well jet pump",
        "marker": [
          61,
          62
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Stainless-well jet pump, model JGP9007WUINOX PRO printed on the box.",
        "quantityLabel": "1 carton",
        "price": 79.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "LANCHEZ 1.2 HP / 2,100 GPH shallow-well pump. Reference listing does not confirm the same model/flow rating.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/ip/LANCHEZ-1-2-HP-Stainless-Steel-Shallow-Well-Pump-115V-2100-GPH-Water-Booster-Jet-Pump/20147259225",
        "referenceKey": "jet_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Chefman TurboFry Touch XL dual air fryer",
        "marker": [
          32,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Chefman TurboFry Touch XL branding and two baskets pictured. Exact model is not readable.",
        "quantityLabel": "1 carton",
        "price": 139.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Chefman 8.5L / 9-quart dual-basket air fryer, RJ38-SQPF-45TDB-CA. Confirm capacity on the carton.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Chefman Direct · Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Chefman-TurboFry-Digital-Touch-Dual-Basket-Air-Fryer-XL-8-5L-9-Quart/7AVPK94FMIWY",
        "referenceKey": "dual_airfryer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electric garage heater · 8,500W",
        "marker": [
          33,
          88
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "8,500W / 240V / 29,010 BTU and QTY 1 PC are printed on the box. Brand and model are hidden.",
        "quantityLabel": "1 carton",
        "price": 250.96,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Namdaq 8500W 240V hardwired garage heater with remote",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/AFAIF-8500W-Electric-Garage-Heater-240V-with-Thermostat-and-Timer-with-Overheat-Protection-and-Remote-Hardwired-NO-PLUG-HDBFDJ24030601/329895275",
        "referenceKey": "garage_heater",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Countertop dishwasher carton",
        "marker": [
          70,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Dishwasher-style front door pictured. Box states tank and faucet water-filling modes; brand/model is hidden.",
        "quantityLabel": "1 carton",
        "price": 249.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "AIRMSEN AE-TDQR03 countertop dishwasher, white/black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/ip/AIRMSEN-Portable-Countertop-Dishwasher-with-5-Liter-Built-in-Water-Tank-and-Air-Dry-Function-5-Washing-Programs-Mini-Dishwasher-AE-TDQR03/256074875",
        "referenceKey": "airmsen_dishwasher",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "bulk-electronics-171": {
    "title": "Bulk Electronics #171 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #171",
    "productId": "gid://shopify/Product/9662222401791",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-171-bulk-electronics-171-liquidationdeals-ca-1256791601.png?v=1788359796",
    "photoWidth": 1200,
    "photoHeight": 1600,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-171-bulk-electronics-171-liquidationdeals-ca-1256791601.png?v=1788359796",
        "width": 1200,
        "height": 1600
      }
    ],
    "items": [
      {
        "label": "PXN V9 Gen2 racing wheel",
        "marker": [
          22,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "PXN V9 Gen2 and 900-degree Gaming Racing Wheel are printed; pedals are pictured.",
        "price": 179.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "PXN V9 Gen2 steering wheel, pedals and shifter",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one wheel/pedals/shifter set",
        "source": "PXN US",
        "url": "https://us.e-pxn.com/products/pxn-v9-gen2-steering-wheel",
        "referenceKey": "pxn_v9",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Birtechway pressure washer",
        "marker": [
          35,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Birtechway PRESSURE WASHER and SKU JX16/0007 are printed.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Mellif 36V cordless scarifier",
        "marker": [
          35,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Mellif CORDLESS SCARIFIER, 36V and model MFSCRF02 are readable.",
        "price": 139.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe AJ801E 13-inch 12A electric scarifier/dethatcher",
        "comparisonNote": "Width and motor differ; this comparison is corded, including when the pictured machine is cordless.",
        "priceUnit": "one corded machine",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-13-in-12-Amp-Electric-Scarifier-Lawn-Dethatcher-with-Collection-Bag-AJ801E/207137229",
        "referenceKey": "electric_dethatcher",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "AIVOLT PWX-3200S pressure washer",
        "marker": [
          64,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "AIVOLT PWX-3200S and a wheeled washer are pictured.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "16-inch pressure-washer surface cleaner",
        "marker": [
          70,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "16-inch Pressure Washer Surface Cleaner is printed; connector/pressure rating need confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Sump pump — DSP900C1-US carton",
        "marker": [
          45,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "SUMP PUMP and the model code are printed; exact rating needs a closer label check.",
        "price": 40.49,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "SEOBIOG UFO LED high-bay light",
        "marker": [
          68,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "UFO LED High Bay Light and a round industrial light are pictured; wattage is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Enclosed appliance carton",
        "marker": [
          32,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "A rounded rectangular enclosure is pictured, but its product type/model is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-177": {
    "title": "Bulk Electronics #177 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-177-bulk-electronics-177-liquidationdeals-ca-1256791604.png?v=1788359888",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "JIMMY cleaning-appliance box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Scanner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "BOSWELL air-fryer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "FOTING pressure-washer boxes",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Steam-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Headphone box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "bulk-electronics-185": {
    "title": "Bulk Electronics #185 — FREE SHIPPING ELIGIBLE",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-185-bulk-electronics-185-liquidationdeals-ca-1256791605.jpg?v=1788359916",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "KitchenAid mixer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Herdio ceiling-speaker box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Gawfolk monitor box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Vacuum-cleaner box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-17-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #17-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-17-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-17-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549553.png?v=1788208176",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Anker-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "PROMOUNT-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-01-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #01-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-01-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-01-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549554.png?v=1788208209",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "GAMING HEADSET-labelled box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-02-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #02-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-02-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-02-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549555.png?v=1788208237",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a small white heater",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-16-oak-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #16-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-16-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-16-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572537.png?v=1788215377",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Honeywell-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a two-burner hot plate",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-14-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #14-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-14-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-14-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572539.png?v=1788215437",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a portable speaker",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a small desk fan",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-07-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #07-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-07-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-07-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549551.png?v=1788208331",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "HUMIDIFIER-labelled box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-09-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #09-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-09-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-09-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549549.png?v=1788208359",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Thermal-printer box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "SLOOSH-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-10-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #10-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-10-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-10-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549548.png?v=1788208391",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "UGREEN-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Toy activity-set box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-12-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #12-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-12-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-12-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572541.png?v=1788215497",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a flat rectangular electronic device",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-08-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #08-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-08-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-08-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256549550.png?v=1788208418",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a hair-styling tool",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "MAXLIN-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "ASTON-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-13-liquidation-pallet-wholesale": {
    "title": "Highcount LPN Pallet #13-oak — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-13-oak-liquidation-pallet-wholesale-highcount-lpn-pallet-13-oak-liquidation-pallet-wholesale-liquidationdeals-ca-1256572540.png?v=1788215528",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "SHALL tool-set box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "moman-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #16 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-16-wholesale-liquidation-pallet-high-count-fc-16-wholesale-liquidation-pallet-liquidationdeals-ca-1255914757.jpg?v=1787783380",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Assorted small retail cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Wrapped soft goods",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-174": {
    "title": "Medium General Merchandise 167",
    "shortTitle": "Medium General Merchandise 167",
    "productId": "gid://shopify/Product/9653752692991",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-167-medium-general-merchandise-167-liquidationdeals-ca-1255898179.jpg?v=1787776273",
    "photoWidth": 833,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-167-medium-general-merchandise-167-liquidationdeals-ca-1255898179.jpg?v=1787776273",
        "width": 833,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Gourmia air fryer",
        "marker": [
          27,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Gourmia and AIR FRYER are printed on the carton; capacity/model is not visible.",
        "price": 78,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Gourmia 6-quart digital window air fryer, black",
        "comparisonNote": "Pictured capacity/model is not established; comparison is the 6-quart window version.",
        "priceUnit": "one air fryer",
        "source": "Walmart US",
        "url": "https://www.walmart.com/ip/Gourmia-6-Qt-Digital-Window-Air-Fryer-with-12-Presets-Guided-Cooking-Black/5218129948",
        "referenceKey": "gourmia_air_fryer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "iRobot Roomba vacuum and mop with wash dock",
        "marker": [
          71,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Roomba branding and a dock are pictured; confirm the exact series on the carton.",
        "price": 799.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "iRobot Roomba Plus 405 Combo robot with AutoWash dock, white",
        "comparisonNote": "Pictured Roomba generation/model is not readable; comparison is the Plus 405 Combo.",
        "priceUnit": "one robot and dock set",
        "source": "iRobot US",
        "url": "https://www.irobot.com/en_US/roomba-plus-405-combo-robot-plus-autowash-dock/G185220.html",
        "referenceKey": "roomba_wash",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "REALLEAD artificial olive tree",
        "marker": [
          30,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Artificial olive tree is printed on the long carton; height is not readable.",
        "price": 49.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Nearly Natural 6-foot artificial olive tree with natural trunk",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Nearly Natural US",
        "url": "https://www.nearlynatural.com/products/6-artificial-olive-tree-with-natural-trunk",
        "referenceKey": "olive_tree",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "ILM-branded carton",
        "marker": [
          26,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Brand is readable, but the product/model is not identified on this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Insure-branded carton",
        "marker": [
          73,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Branding is visible; the smaller product description is obscured by wrap.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Cartons marked J6L021HS01A",
        "marker": [
          69,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The code is readable on two adjacent cartons, but the product identity is not established.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "skid-173": {
    "title": "Medium General Merchandise 170",
    "shortTitle": "Medium General Merchandise 170",
    "productId": "gid://shopify/Product/9653752627455",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-170-medium-general-merchandise-170-liquidationdeals-ca-1255898180.jpg?v=1787776298",
    "photoWidth": 1018,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-170-medium-general-merchandise-170-liquidationdeals-ca-1255898180.jpg?v=1787776298",
        "width": 1018,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Jafanda JF260 air purifier",
        "marker": [
          77,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "JF260 and AIR PURIFIER are readable on the upper-right carton.",
        "price": 142.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Jafanda JF260 air purifier",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Jafanda US",
        "url": "https://www.jafanda.com/products/jafanda-jf260-air-purifier",
        "referenceKey": "jafanda_jf260",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Residential-height RV toilet",
        "marker": [
          53,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "RV toilet and a foot-pedal toilet drawing are visible; confirm the manufacturer and connection dimensions.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Automatic cat litter box",
        "marker": [
          53,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "AUTOMATIC CAT LITTER BOX is printed on the lower carton; brand/model is hidden.",
        "price": 288,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut 72L automatic self-cleaning cat litter box",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "PawHut Canada",
        "url": "https://pawhutstore.com/en-ca/products/self-cleaning-litter-box-automatic-cat-litter-box-for-multi-cats-extra-large-72l-app-control-safety-sensor-odor",
        "referenceKey": "automatic_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Vented appliance cartons",
        "marker": [
          21,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Vented-appliance drawings are visible, but the product type and model cannot be confirmed from this photo.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Other closed shipping cartons",
        "marker": [
          21,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Labels are covered or unreadable. No contents or value inferred.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "skid-171": {
    "title": "Medium General Merchandise 171",
    "shortTitle": "Medium General Merchandise 171",
    "productId": "gid://shopify/Product/9653752561919",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-171-medium-general-merchandise-171-liquidationdeals-ca-1255898181.jpg?v=1787776329",
    "photoWidth": 956,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-171-medium-general-merchandise-171-liquidationdeals-ca-1255898181.jpg?v=1787776329",
        "width": 956,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Pickup-truck bed protection mat",
        "marker": [
          52,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "ULTIMATE TRUCK FLOOR PROTECTION is readable. Vehicle fitment is not established.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Owens Corning R-8 garage-door insulation kits",
        "marker": [
          38,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "R8 and eight vinyl-faced insulation panels are printed on each visible kit carton.",
        "quantityLabel": "2 kit cartons shown",
        "price": 184.3,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Owens Corning GD01 R-8 garage-door insulation kit",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one 8-panel kit",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Owens-Corning-Garage-Door-Fiberglass-Insulation-Kit-22-in-x-54-in-8-Panels-GD01/202257272",
        "referenceKey": "garage_insulation",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "UPPAbaby MESA V3 infant car seat",
        "marker": [
          64,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "MESA V3 and UPPAbaby are readable. A sealed-looking box does not establish the seat's history or usable condition.",
        "price": 549.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "UPPAbaby MESA V3 infant car seat, starting price",
        "comparisonNote": "Retail price starts at this amount; colour/fabric and regional version on the carton are not established.",
        "priceUnit": "one car seat",
        "source": "West Coast Kids",
        "url": "https://www.westcoastkids.ca/mesa-v3-infant-car-seat",
        "referenceKey": "mesa_v3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Pipishell utility cart",
        "marker": [
          56,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "UTILITY CART and Pipishell branding are visible; model/size needs confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Large cat scratching pad",
        "marker": [
          56,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Cat Scratching Pad Large is printed on the carton; exact dimensions are unreadable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Large bird cage",
        "marker": [
          69,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A wheeled cage with perches and an open roof is pictured; brand/dimensions are unclear.",
        "price": 144.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut 56-inch bird cage with detachable rolling stand",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Aosom Canada",
        "url": "https://www.aosom.ca/item/pawhut-56-h-bird-cage-parrot-cage-w-detachable-rolling-stand-removable-tray-storage-shelf-perches-food-container~25B9KRS245O00.html",
        "referenceKey": "bird_cage",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Husky Liners Weatherbeater floor liners",
        "marker": [
          18,
          74
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Weatherbeater branding is readable, but vehicle/application details are hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Tall stand carton",
        "marker": [
          84,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "A vertical stand is pictured, but its intended use and model are unclear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "skid-177": {
    "title": "Medium General Merchandise 177",
    "shortTitle": "Medium General Merchandise 177",
    "productId": "gid://shopify/Product/9653752529151",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-177-medium-general-merchandise-177-liquidationdeals-ca-1255898182.jpg?v=1787776359",
    "photoWidth": 924,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-177-medium-general-merchandise-177-liquidationdeals-ca-1255898182.jpg?v=1787776359",
        "width": 924,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Intex Splash 'N Chill inflatable island",
        "marker": [
          46,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "SPLASH N CHILL ISLAND and the multi-person floating lounger are visible.",
        "price": 189.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Intex Splash 'N Chill inflatable island, 145 × 125 inches",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Intex US",
        "url": "https://intexcorp.com/products/sporting-goods/sporting-lounges-islands/splash-n-chill-island/",
        "referenceKey": "intex_island",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Freein camping sleeping pad",
        "marker": [
          77,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Camping Sleeping Pad is printed below Freein; size/model is not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "POOLPURE pool-filter cartridge carton",
        "marker": [
          48,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "POOLPURE branding is readable; the cartridge code is partly covered. Compatibility must be checked.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Pet potty tray carton",
        "marker": [
          32,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Pet Potty is printed on the narrow white carton; exact configuration is not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Multi-colour-temperature floor-lamp carton",
        "marker": [
          23,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "3000, 4000 and 6500 Kelvin settings are printed; exact model is not readable.",
        "price": 34.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "DAYBETTER floor lamp with 9W bulb and three colour temperatures",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://business.walmart.com/ip/DAYBETTER-LED-Floor-Lamp-3-Color-Temperatures-with-Remote-Control-9W-LED-Bulb-Modern-Standing-Lamp-with-Lampshade-for-Living-Room-Bedroom-Office/19946704558",
        "referenceKey": "floor_lamp",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Dingchen-branded long cartons",
        "marker": [
          38,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Dingchen labels are visible on several long cartons; contents are not identified on these faces.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "KEMIMOTO-branded carton",
        "marker": [
          76,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Brand is readable; the specific accessory and fitment are not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked BFTLPT-3010",
        "marker": [
          77,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The SKU is printed, but the product type is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "skid-176": {
    "title": "Medium General Merchandise 176",
    "shortTitle": "Medium General Merchandise 176",
    "productId": "gid://shopify/Product/9653752365311",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-176-medium-general-merchandise-176-liquidationdeals-ca-1255898184.jpg?v=1787776417",
    "photoWidth": 910,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-176-medium-general-merchandise-176-liquidationdeals-ca-1255898184.jpg?v=1787776417",
        "width": 910,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "LAQUAL 6.5-gallon glass fish tank",
        "marker": [
          29,
          52
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "LAQUAL 6.5-Gallon Glass Fish Tank is clearly printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Globexis 2.5-litre dehumidifier",
        "marker": [
          58,
          52
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Globexis Dehumidifier, 2.5L capacity and seven-colour night light are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Gardner Pet acrylic dog playpen",
        "marker": [
          28,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "24-inch, 12-panel Acrylic Dog Playpen is printed on the lower-left carton.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Children's water activity tables",
        "marker": [
          26,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Two cartons show the same blue multi-tier water-play table and accessories; brand/model is unclear.",
        "quantityLabel": "2 cartons shown",
        "price": 89.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Step2 Rain Showers Splash Pond water table",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Step2 US",
        "url": "https://www.step2.com/products/rain-showers-splash-pond-water-table",
        "referenceKey": "water_table",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Lunix-branded carton",
        "marker": [
          58,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Lunix branding is visible; the product model and contents are not identified on this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Jieker-branded carton",
        "marker": [
          24,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "The brand is readable, but the product type/model is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "skid-162": {
    "title": "Medium General Merchandise 162",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-162-medium-general-merchandise-162-liquidationdeals-ca-1255898187.jpg?v=1787776450",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Box showing a wheeled office chair",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "LAEOTI-branded carton",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-169": {
    "title": "Medium General Merchandise 169",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-169-medium-general-merchandise-169-liquidationdeals-ca-1255898189.jpg?v=1787776478",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Control-arm kit box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folding rocking-chair box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "YOUNUO-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-159": {
    "title": "Medium General Merchandise 159",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-159-medium-general-merchandise-159-liquidationdeals-ca-1255898185.jpg?v=1787776511",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "K&N air-intake system box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "GOTIDY-branded cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Brother printer-consumable box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a cylindrical bin",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-163": {
    "title": "Medium General Merchandise 163",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-163-medium-general-merchandise-163-liquidationdeals-ca-1255898192.jpg?v=1787776597",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Folding camping-chair box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a multi-drawer unit",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-164": {
    "title": "Medium General Merchandise 164",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-164-medium-general-merchandise-164-liquidationdeals-ca-1255898188.jpg?v=1787776691",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Toshiba-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Box showing a wheeled stool",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-170": {
    "title": "Medium General Merchandise 170",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-170-medium-general-merchandise-170-liquidationdeals-ca-1255898186.jpg?v=1787776720",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Patio-product box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Residential RV toilet box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "skid-167": {
    "title": "Medium General Merchandise 167",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-167-medium-general-merchandise-167-liquidationdeals-ca-1255898195.jpg?v=1787776748",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Playpen box labelled 150 × 180",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Chefman-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-135-1": {
    "title": "Medium General Merchandise #135-1",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-135-1-medium-general-merchandise-135-1-liquidationdeals-ca-1255797474.jpg?v=1787689775",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "iFold-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "CHAMPRO-branded box",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted closed shipping cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "medium-general-merchandise-139": {
    "title": "Medium General Merchandise #139 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #139",
    "productId": "gid://shopify/Product/9652695138559",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-139-medium-general-merchandise-139-liquidationdeals-ca-1255797477.jpg?v=1787689870",
    "photoWidth": 879,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-139-medium-general-merchandise-139-liquidationdeals-ca-1255797477.jpg?v=1787689870",
        "width": 879,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Children's drawing boards with easel stands",
        "marker": [
          25,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Three pink cartons show a drawing board on a stand with accessories; exact brand/model is unclear.",
        "quantityLabel": "3 cartons shown",
        "price": 69.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax adjustable magnetic chalkboard/whiteboard easel, blue",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Art-Easel-for-Kids-Height-Adjustable-Magnetic-Chalkboard-White-Drawing-Board-Blue/6N8FPCLDOMWS",
        "referenceKey": "drawing_easel",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "LIFERSE artificial olive tree",
        "marker": [
          52,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "ARTIFICIAL OLIVE TREE is printed; the tree height is not readable.",
        "price": 49.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Nearly Natural 6-foot artificial olive tree with natural trunk",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Nearly Natural US",
        "url": "https://www.nearlynatural.com/products/6-artificial-olive-tree-with-natural-trunk",
        "referenceKey": "olive_tree",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "FANPAT canopy with sidewalls",
        "marker": [
          36,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "CANOPY WITH SIDEWALLS is printed; size and exact configuration are obscured.",
        "price": 196,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VIVOHOME 10 × 10-foot pop-up canopy with four sides",
        "comparisonNote": "Pictured FANPAT size, frame and sidewall count are not confirmed.",
        "priceUnit": "one canopy kit",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VIVOHOME-10-ft-x-10-ft-Pop-Up-4-Sided-Commercial-Canopy-Tent-VH1426/332304891",
        "referenceKey": "canopy",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Carton with 20/24/28-size, three-piece set label",
        "marker": [
          73,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The label lists three pieces and dark purple, but the product name is not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked DY-02-BK",
        "marker": [
          45,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The model/code is readable, but the product type is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Reused beverage carton",
        "marker": [
          78,
          51
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Printed beverage packaging is visible. It does not establish what is packed inside.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-144": {
    "title": "Medium General Merchandise #144",
    "shortTitle": "Medium General Merchandise #144",
    "productId": "gid://shopify/Product/9652694450431",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-144-medium-general-merchandise-144-liquidationdeals-ca-1255797478.jpg?v=1787689898",
    "photoWidth": 899,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-144-medium-general-merchandise-144-liquidationdeals-ca-1255797478.jpg?v=1787689898",
        "width": 899,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Evenflo-branded carton",
        "marker": [
          44,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Evenflo branding is visible; the product type/model is not shown on this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Floor-lamp carton",
        "marker": [
          44,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The centre-carton model label describes a floor lamp; exact model details require a closer label check.",
        "price": 34.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "DAYBETTER floor lamp with 9W bulb and three colour temperatures",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://business.walmart.com/ip/DAYBETTER-LED-Floor-Lamp-3-Color-Temperatures-with-Remote-Control-9W-LED-Bulb-Modern-Standing-Lamp-with-Lampshade-for-Living-Room-Bedroom-Office/19946704558",
        "referenceKey": "floor_lamp",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Cat furniture carton",
        "marker": [
          78,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "A multi-platform cat-tower drawing is visible; brand, height and configuration are not confirmed.",
        "price": 82.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut 55-inch cat tree with condo and hammocks",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Aosom Canada",
        "url": "https://www.aosom.ca/item/pawhut-55-cat-tree-for-indoor-cats-cat-tower-kitty-activity-center-with-cat-bed-ramp-condo-hammocks-hanging-ball-toys~1AR68GR839801.html",
        "referenceKey": "cat_tree",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Bath-time accessory cartons",
        "marker": [
          20,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Seat, rinse cup, brush and bath-time wording appears on the cartons; exact set and included pieces are not established.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked J6L021GR02",
        "marker": [
          81,
          74
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The printed code is visible, but the product identity is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-145": {
    "title": "Medium General Merchandise #145",
    "shortTitle": "Medium General Merchandise #145",
    "productId": "gid://shopify/Product/9652694024447",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-145-medium-general-merchandise-145-liquidationdeals-ca-1255797479.jpg?v=1787689930",
    "photoWidth": 919,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-145-medium-general-merchandise-145-liquidationdeals-ca-1255797479.jpg?v=1787689930",
        "width": 919,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "KASUE home steam sauna",
        "marker": [
          55,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "STEAM SAUNA FOR HOME and KASUE are printed on the central carton.",
        "price": 217.51,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 1600W one-person portable steam sauna tent",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VEVOR-Portable-Steam-Sauna-Tent-1-Person-Indoor-Metal-Frame-Material-Portable-Sauna-1600-Watt-with-Visible-Window-Black-ZQBXSSN1600W7NBQQV1/329097077",
        "referenceKey": "steam_sauna",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Tent carton — ITENT-89915-CTT",
        "marker": [
          77,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Tent branding and the item code are visible. Intended tent type, dimensions and kit contents need confirmation.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Chair carton",
        "marker": [
          33,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "A chair is pictured on the tall carton; exact style, brand and dimensions are not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Gardner Pet-branded cartons",
        "marker": [
          13,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Pet-product branding is visible; the individual product names are not readable.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Dingchen-branded long cartons",
        "marker": [
          64,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Several long cartons show the brand, but no readable product description.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Closed cartons with support instructions",
        "marker": [
          62,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Only generic support text is visible; product type and quantity inside are unknown.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-147": {
    "title": "Medium General Merchandise #147",
    "shortTitle": "Medium General Merchandise #147",
    "productId": "gid://shopify/Product/9652693532927",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-147-medium-general-merchandise-147-liquidationdeals-ca-1255797480.jpg?v=1787689957",
    "photoWidth": 869,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-147-medium-general-merchandise-147-liquidationdeals-ca-1255797480.jpg?v=1787689957",
        "width": 869,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Evenflo Revolve360 Slim rotating car seat",
        "marker": [
          45,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Revolve360 Slim and the rotating-seat illustration are clearly visible; exact trim is not confirmed.",
        "price": 399.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Evenflo Revolve360 Slim 2-in-1 rotational car seat",
        "comparisonNote": "US retail version; trim, included components and regional model may differ.",
        "priceUnit": "one product",
        "source": "Evenflo US",
        "url": "https://www.evenflo.com/products/revolve360-slim-rotational-car-seat-core",
        "referenceKey": "revolve_slim",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Stainless-steel litter box",
        "marker": [
          47,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Stainless Steel Litter Box is printed; size and brand are not established.",
        "price": 29.97,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "One Paw 17L stainless-steel litter box, 19.5 × 13.5 × 4 inches",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/One-Paw-Stainless-Steel-Cat-Litter-Box-Large-19-5-x-13-5-x-4-17L-for-Cats/6000208547435",
        "referenceKey": "steel_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Enclosed litter box",
        "marker": [
          19,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "ENCLOSED LITTER BOX and a covered tray drawing are visible; exact size/model is unclear.",
        "price": 46.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut covered cat litter box with high sides, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/PawHut-Cat-Litter-Box-with-Lid-Covered-Litter-Box-w-High-Sides-White/1PS9621A4EFL",
        "referenceKey": "covered_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Office chair cartons",
        "marker": [
          55,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "OFFICE CHAIR is readable on two lower cartons; one lists model JD01. The models may differ.",
        "quantityLabel": "2 cartons shown",
        "price": 65.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "edx mid-back ergonomic mesh desk chair, black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/edx-Mid-Back-Ergonomic-Desk-Chair-with-Wheels-Lumbar-Support-for-Home-Office-Bedroom-Black/5W8HGB8BHWCP",
        "referenceKey": "office_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "UNILY-branded carton",
        "marker": [
          41,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The brand is visible, but the product description is hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked 251214HS / 500 LBS",
        "marker": [
          86,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "The code and capacity are printed; product type cannot be established from this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-138": {
    "title": "Medium General Merchandise #138 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #138",
    "productId": "gid://shopify/Product/9652692320511",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-138-medium-general-merchandise-138-liquidationdeals-ca-1255797482.jpg?v=1787690016",
    "photoWidth": 976,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-138-medium-general-merchandise-138-liquidationdeals-ca-1255797482.jpg?v=1787690016",
        "width": 976,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Helavo H1070 rollator",
        "marker": [
          36,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Helavo H1070 is readable, with a seat and footrests pictured.",
        "price": 174.9,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Helavo H1070 2-in-1 rollator/transport-chair combo",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Helavo US",
        "url": "https://helavo-mobility.com/products/2-in-1-rollator-wheelchair-combo-h1070-black",
        "referenceKey": "helavo_h1070",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Globber Primo foldable light-up scooter",
        "marker": [
          41,
          25
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "PRIMO, light-up wheels and a three-wheel scooter are pictured; confirm the exact edition.",
        "price": 130,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Globber Primo Plus foldable scooter with light-up wheels",
        "comparisonNote": "Primo Plus comparison; pictured Primo edition and colour may differ.",
        "priceUnit": "one scooter",
        "source": "Brighten Up Toys & Games",
        "url": "https://brightenuptoysandgames.ca/products/globber-primo-plus-foldable-scooter-with-lights-copy",
        "referenceKey": "globber_primo",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "HOMLAND shower chair",
        "marker": [
          78,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "SHOWER CHAIR, HOMLAND and the seat/backrest drawing are visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "HUANUO under-desk keyboard tray",
        "marker": [
          37,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Keyboard Tray and HUANUO are printed; exact tray width is not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "PawHut covered litter box",
        "marker": [
          78,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "A hooded litter box and scoop are pictured beside PawHut branding.",
        "price": 46.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "PawHut covered cat litter box with high sides, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/PawHut-Cat-Litter-Box-with-Lid-Covered-Litter-Box-w-High-Sides-White/1PS9621A4EFL",
        "referenceKey": "covered_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Vehicle control-arm kit",
        "marker": [
          38,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "CONTROL ARM KITS is readable, but vehicle fitment and part numbers are hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "JOYSTAR-branded cartons",
        "marker": [
          77,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Several labelled JOYSTAR cartons are visible; their model/size codes need a closer check.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-148": {
    "title": "Medium General Merchandise #148",
    "shortTitle": "Medium General Merchandise #148",
    "productId": "gid://shopify/Product/9652690125055",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-148-medium-general-merchandise-148-liquidationdeals-ca-1255797485.jpg?v=1787690112",
    "photoWidth": 901,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-148-medium-general-merchandise-148-liquidationdeals-ca-1255797485.jpg?v=1787690112",
        "width": 901,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "VEVOR electronic safe cartons",
        "marker": [
          56,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Three safe illustrations are visible; VEVOR appears on the central carton. Capacities/models may differ.",
        "quantityLabel": "3 cartons shown",
        "price": 90.9,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "VEVOR 1.2-cu.-ft. keypad home safe, single door",
        "comparisonNote": "Capacity and lock configuration of the photographed cartons are not confirmed. Retailer currently marks this configuration out of stock.",
        "priceUnit": "one safe",
        "source": "VEVOR US",
        "url": "https://www.vevor.com/electronic-safes-c_10271/vevor-safe-1-2-cubic-feet-home-safe-steel-for-cash-gold-15-8x11-8x13-8-inch-p_010910855833",
        "referenceKey": "electronic_safe",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "CHERRYLUX floor mattress",
        "marker": [
          23,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Floor Mattress and CHERRYLUX are printed; size/thickness is not visible.",
        "price": 109.98,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "MAXYOYO twin 3-inch Japanese-style floor mattress",
        "comparisonNote": "Pictured CHERRYLUX mattress size and thickness are not established.",
        "priceUnit": "one twin floor mattress",
        "source": "MAXYOYO",
        "url": "https://www.maxyoyohome.com/products/maxyoyo-japanese-floor-futon-mattress-twin-size-3-thicken-tatami-sleeping-pad-foldable-roll-up-mattress-portable-floor-mattress-pad-for-adults-guest-room-camping",
        "referenceKey": "floor_mattress",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Adjustable bar-stool carton",
        "marker": [
          63,
          74
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Two upholstered, gas-lift bar stools are pictured. Pack quantity and dimensions must be checked.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Rollator walker carton",
        "marker": [
          57,
          89
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "A wheeled walker with a seat, backrest and storage basket is pictured; brand/model is unreadable.",
        "price": 174.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Helavo H1070 2-in-1 rollator/transport-chair combo",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Helavo US",
        "url": "https://helavo-mobility.com/products/2-in-1-rollator-wheelchair-combo-h1070-black",
        "referenceKey": "helavo_h1070",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Gardner Pet-branded carton",
        "marker": [
          86,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Pet-product branding is visible; the product type is not readable on this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked DY-02-BKRD",
        "marker": [
          16,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The code is readable, but product identity is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-143-1-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #143-1 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #143-1 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652681965823",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-143-1-liquidation-pallet-wholesale-medium-general-merchandise-143-1-liquidation-pallet-wholesale-liquidationdeals-ca-1255797486.jpg?v=1787690139",
    "photoWidth": 920,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-143-1-liquidation-pallet-wholesale-medium-general-merchandise-143-1-liquidation-pallet-wholesale-liquidationdeals-ca-1255797486.jpg?v=1787690139",
        "width": 920,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Children's water table",
        "marker": [
          47,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "WATER TABLE is printed on the blue carton; exact model/accessories are not shown.",
        "price": 89.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Step2 Rain Showers Splash Pond water table",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Step2 US",
        "url": "https://www.step2.com/products/rain-showers-splash-pond-water-table",
        "referenceKey": "water_table",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ceramic vessel sink",
        "marker": [
          45,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "CERAMIC VESSEL SINK is printed; dimensions and shape need confirmation.",
        "price": 79.9,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR 19 × 14.7-inch white ceramic vessel sink",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/VEVOR-Modern-Ceramic-Vessel-Sink-19-x14-7-Bathroom-Vanity-Bowl-Countertop-White/3GXR3EB8AGHE",
        "referenceKey": "vessel_sink",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Computer desk carton",
        "marker": [
          16,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The Chinese carton text identifies a computer desk; size and brand are not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "12-inch-wheel bicycle carton",
        "marker": [
          27,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The label lists a 12-inch wheel and green colour; the bicycle's exact model/configuration is not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Okaysou-branded carton",
        "marker": [
          44,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The brand is readable, but the appliance type/model is hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "GARVEE-branded long carton",
        "marker": [
          13,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The brand is visible; the product description is not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Unidentified large cartons",
        "marker": [
          74,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "These faces show country-of-origin text and covered labels only; contents and quantities are unknown.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-157-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #157 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #157 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652670955775",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-157-liquidation-pallet-wholesale-medium-general-merchandise-157-liquidation-pallet-wholesale-liquidationdeals-ca-1255797487.jpg?v=1787690169",
    "photoWidth": 869,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-157-liquidation-pallet-wholesale-medium-general-merchandise-157-liquidation-pallet-wholesale-liquidationdeals-ca-1255797487.jpg?v=1787690169",
        "width": 869,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Heat-transfer press",
        "marker": [
          49,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "HEAT TRANSFER PRESSES and an opening platen press are pictured; platen size and model are unclear.",
        "price": 197.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 15 × 15-inch swing-away 5-in-1 heat press",
        "comparisonNote": "Comparison includes five attachments; platen size and included attachments on the pictured carton are not confirmed.",
        "priceUnit": "one press kit",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VEVOR-15-in-x-15-in-Pro-Heat-Press-Machine-5-in-1-Combo-360-Swing-Away-Digital-Sublimation-Vinyl-Transfer-Printer-Blue-TJWHYXKLP8038N8U4V1/318963499",
        "referenceKey": "heat_press",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Portable baby bassinet",
        "marker": [
          61,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The carton describes mesh sides and three height settings, with a bassinet illustration; exact brand/model is not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Motorcycle helmet carton",
        "marker": [
          81,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "A full-face helmet is illustrated and HELMET is printed; size and safety rating are not established.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Children's drawing board with stand",
        "marker": [
          22,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The pink carton shows the drawing board and easel-style stand.",
        "price": 69.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax adjustable magnetic chalkboard/whiteboard easel, blue",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Art-Easel-for-Kids-Height-Adjustable-Magnetic-Chalkboard-White-Drawing-Board-Blue/6N8FPCLDOMWS",
        "referenceKey": "drawing_easel",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "DELTA-branded carton",
        "marker": [
          7,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "DELTA branding is visible, but the specific product is not shown.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked LN-2514-BEIGE2",
        "marker": [
          46,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The label states two pieces, but no readable product name is visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-156-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #156 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #156 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652670464255",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-156-liquidation-pallet-wholesale-medium-general-merchandise-156-liquidation-pallet-wholesale-liquidationdeals-ca-1255797488.jpg?v=1787690196",
    "photoWidth": 874,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-156-liquidation-pallet-wholesale-medium-general-merchandise-156-liquidation-pallet-wholesale-liquidationdeals-ca-1255797488.jpg?v=1787690196",
        "width": 874,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Litter-box cartons",
        "marker": [
          51,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Litter Box wording and covered-box drawings are visible; brand and dimensions are not established.",
        "quantityLabel": "2 cartons shown",
        "price": 46.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut covered cat litter box with high sides, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/PawHut-Cat-Litter-Box-with-Lid-Covered-Litter-Box-w-High-Sides-White/1PS9621A4EFL",
        "referenceKey": "covered_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "COSMOID inline skates",
        "marker": [
          71,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "The white carton shows an inline skate and size label 43 / US 10; exact model is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "TV wall-mount cartons",
        "marker": [
          73,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "TV-size and VESA markings appear on the black cartons; exact compatibility and load rating need confirmation.",
        "quantityLabel": "Several cartons shown",
        "price": 89.97,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Commercial Electric XD2616-L full-motion wall mount for 32–90-inch TVs",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Commercial-Electric-Full-Motion-TV-Wall-Mount-for-32-in-to-90-in-TVs-XD2616-L/328180253",
        "referenceKey": "tv_mount",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Children's play-tent set",
        "marker": [
          29,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The coloured side-panel pictures show children's pop-up play tents; included pieces are not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Catalytic-converter carton",
        "marker": [
          65,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "CATALYTIC CONVERTER is readable; vehicle fitment and part number are not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Long carton marked WIX-GA-027",
        "marker": [
          50,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The SKU is readable, but the product type is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-155-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #155 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #155 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652670038271",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-155-liquidation-pallet-wholesale-medium-general-merchandise-155-liquidation-pallet-wholesale-liquidationdeals-ca-1255797489.jpg?v=1787690230",
    "photoWidth": 922,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-155-liquidation-pallet-wholesale-medium-general-merchandise-155-liquidation-pallet-wholesale-liquidationdeals-ca-1255797489.jpg?v=1787690230",
        "width": 922,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Carex locking raised toilet seat",
        "marker": [
          24,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "CAREX and Locking Raised Toilet Seat are readable; exact model/height needs confirmation.",
        "price": 43.74,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Carex E-Z Lock locking raised toilet seat",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Carex US",
        "url": "https://carex.com/products/carex-e-z-lock-locking-raised-toilet-seat",
        "referenceKey": "carex_raised",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Carex toilet-seat elevator with handles",
        "marker": [
          73,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The blue carton specifies a seat elevator with handles for standard round toilets.",
        "price": 69.2,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Carex toilet-seat elevator with handles for standard toilets",
        "comparisonNote": "Comparison is the standard-toilet version with handles; bowl shape and features may differ.",
        "priceUnit": "one product",
        "source": "Carex US",
        "url": "https://carex.com/products/carex-toilet-seat-elevator-with-handles-standard",
        "referenceKey": "carex_elevator",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Regalo Easy Open extra-wide safety gate",
        "marker": [
          82,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "EASY OPEN EXTRA WIDE SAFETY GATE and model 1165 DS are printed.",
        "price": 54.97,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Regalo Easy Open baby safety gate",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Regalo-Easy-Open-Baby-Safety-Gate/6000196552659",
        "referenceKey": "regalo_gate",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "50-foot slackline with hanging obstacles",
        "marker": [
          52,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "50FT Slackline with Hanging Obstacles is printed; accessory count is not verified.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Eight-port automatic chicken feeder",
        "marker": [
          22,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Eight-port, silver-colour automatic chicken feeder is printed on the carton.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Children's drawing boards",
        "marker": [
          20,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Drawing Board wording and product diagrams appear on two white cartons.",
        "quantityLabel": "2 cartons shown",
        "price": 69.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax adjustable magnetic chalkboard/whiteboard easel, blue",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Art-Easel-for-Kids-Height-Adjustable-Magnetic-Chalkboard-White-Drawing-Board-Blue/6N8FPCLDOMWS",
        "referenceKey": "drawing_easel",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "medium-general-merchandise-154-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #154 — Free Shipping Eligible for Parts of Ontario Only — Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #154 — Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652669612287",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-154-liquidation-pallet-wholesale-medium-general-merchandise-154-liquidation-pallet-wholesale-liquidationdeals-ca-1255797490.jpg?v=1787690257",
    "photoWidth": 959,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-154-liquidation-pallet-wholesale-medium-general-merchandise-154-liquidation-pallet-wholesale-liquidationdeals-ca-1255797490.jpg?v=1787690257",
        "width": 959,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Memory-foam mattress topper",
        "marker": [
          16,
          25
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Memory Foam Mattress Topper is printed; bed size and thickness are not visible.",
        "price": 58,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Mainstays 3-inch gel memory-foam mattress topper, Twin",
        "comparisonNote": "Comparison is Twin size and 3 inches thick; photographed size/thickness are unclear.",
        "priceUnit": "one product",
        "source": "Walmart US",
        "url": "https://www.walmart.com/ip/Mainstays-3-Memory-Foam-Mattress-Topper-Twin/2320810121",
        "referenceKey": "mattress_topper",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Children's drawing boards with stands",
        "marker": [
          57,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Two pink cartons picture the drawing board and easel-style stand.",
        "quantityLabel": "2 cartons shown",
        "price": 69.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax adjustable magnetic chalkboard/whiteboard easel, blue",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Art-Easel-for-Kids-Height-Adjustable-Magnetic-Chalkboard-White-Drawing-Board-Blue/6N8FPCLDOMWS",
        "referenceKey": "drawing_easel",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Tewio stainless-steel litter box",
        "marker": [
          30,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Stainless-steel litter-box wording and a tray illustration appear on the tall carton.",
        "price": 29.97,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "One Paw 17L stainless-steel litter box, 19.5 × 13.5 × 4 inches",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/One-Paw-Stainless-Steel-Cat-Litter-Box-Large-19-5-x-13-5-x-4-17L-for-Cats/6000208547435",
        "referenceKey": "steel_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Warmplants artificial tree",
        "marker": [
          17,
          74
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Artificial tree and Warmplants are printed; species and height are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Peel-and-stick vinyl flooring",
        "marker": [
          60,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Flooring is identified on the slim carton; colour, pack coverage and plank size are unclear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Throw-target game set",
        "marker": [
          77,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "THROW TARGET GAME SET is printed, but the exact game and included pieces are not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "LCL toner cartridge",
        "marker": [
          86,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Toner Cartridge and LCL are readable; printer compatibility is not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "GOTIDY-branded cartons",
        "marker": [
          77,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The brand is visible on several cartons, but the product names are hidden.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-151-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #151 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #151 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652668367103",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-151-liquidation-pallet-wholesale-medium-general-merchandise-151-liquidation-pallet-wholesale-liquidationdeals-ca-1255797493.jpg?v=1787690348",
    "photoWidth": 961,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-151-liquidation-pallet-wholesale-medium-general-merchandise-151-liquidation-pallet-wholesale-liquidationdeals-ca-1255797493.jpg?v=1787690348",
        "width": 961,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Helavo upright rollator",
        "marker": [
          40,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The Helavo carton pictures a rollator with forearm supports; exact model is obscured.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ubbi stainless-steel diaper pail",
        "marker": [
          70,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Ubbi Stainless Steel Diaper Pail is clearly readable.",
        "price": 69.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Ubbi steel diaper pail, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Ubbi US",
        "url": "https://ubbiworld.com/products/ubbi-diaper-pail",
        "referenceKey": "ubbi_pail",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Heybly cat trees",
        "marker": [
          57,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Heybly Cat Tree wording appears on two cartons with different model codes.",
        "quantityLabel": "2 cartons shown",
        "price": 82.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut 55-inch cat tree with condo and hammocks",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Aosom Canada",
        "url": "https://www.aosom.ca/item/pawhut-55-cat-tree-for-indoor-cats-cat-tower-kitty-activity-center-with-cat-bed-ramp-condo-hammocks-hanging-ball-toys~1AR68GR839801.html",
        "referenceKey": "cat_tree",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Baby high chair",
        "marker": [
          28,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Baby High Chair is printed on the horizontal carton; model details are partly covered.",
        "price": 79.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Cosco Simple Fold high chair",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Goldtex Canada",
        "url": "https://goldtex.ca/products/cosco-simple-fold-high-chair",
        "referenceKey": "high_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "SAMODRA raised toilet seat",
        "marker": [
          28,
          33
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Raised Toilet Seat wording is visible; exact configuration is obscured.",
        "price": 43.74,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Carex E-Z Lock locking raised toilet seat",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Carex US",
        "url": "https://carex.com/products/carex-e-z-lock-locking-raised-toilet-seat",
        "referenceKey": "carex_raised",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Carex hinged toilet-seat riser",
        "marker": [
          26,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Carex and Hinged Toilet Seat Riser are readable; confirm toilet shape/model.",
        "price": 69.2,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Carex toilet-seat elevator with handles for standard toilets",
        "comparisonNote": "Comparison is the standard-toilet version with handles; bowl shape and features may differ.",
        "priceUnit": "one product",
        "source": "Carex US",
        "url": "https://carex.com/products/carex-toilet-seat-elevator-with-handles-standard",
        "referenceKey": "carex_elevator",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "GOODKING 94-piece socket-wrench set",
        "marker": [
          56,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "94 pcs Socket Wrench Auto Repair Tool Set is printed; contents have not been checked.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Gromast iFold 2.0 stroller carton",
        "marker": [
          78,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "iFold 2.0 and stroller instructions are printed; exact variant is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-general-merchandise-150-liquidation-pallet-wholesale": {
    "title": "Medium General Merchandise #150 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #150 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9652667744511",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-150-liquidation-pallet-wholesale-medium-general-merchandise-150-liquidation-pallet-wholesale-liquidationdeals-ca-1255797494.jpg?v=1787690376",
    "photoWidth": 926,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-150-liquidation-pallet-wholesale-medium-general-merchandise-150-liquidation-pallet-wholesale-liquidationdeals-ca-1255797494.jpg?v=1787690376",
        "width": 926,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Ergobaby Omni Deluxe baby carrier",
        "marker": [
          36,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Ergobaby and OMNI DELUXE are readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electronic safe cartons",
        "marker": [
          79,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Keypad safes are pictured on three cartons; dimensions and models may differ.",
        "quantityLabel": "3 cartons shown",
        "price": 90.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 1.2-cu.-ft. keypad home safe, single door",
        "comparisonNote": "Capacity and lock configuration of the photographed cartons are not confirmed. Retailer currently marks this configuration out of stock.",
        "priceUnit": "one safe",
        "source": "VEVOR US",
        "url": "https://www.vevor.com/electronic-safes-c_10271/vevor-safe-1-2-cubic-feet-home-safe-steel-for-cash-gold-15-8x11-8x13-8-inch-p_010910855833",
        "referenceKey": "electronic_safe",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Disney Frozen II children's scooter",
        "marker": [
          12,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Frozen II characters and a three-wheel scooter are pictured; exact model is not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "REALLEAD artificial olive tree",
        "marker": [
          78,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "ARTIFICIAL OLIVE TREE is printed; height is unreadable.",
        "price": 49.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Nearly Natural 6-foot artificial olive tree with natural trunk",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Nearly Natural US",
        "url": "https://www.nearlynatural.com/products/6-artificial-olive-tree-with-natural-trunk",
        "referenceKey": "olive_tree",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "CHERRYLUX floor mattress",
        "marker": [
          38,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Floor Mattress is printed; bed size/thickness is not visible.",
        "price": 109.98,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "MAXYOYO twin 3-inch Japanese-style floor mattress",
        "comparisonNote": "Pictured CHERRYLUX mattress size and thickness are not established.",
        "priceUnit": "one twin floor mattress",
        "source": "MAXYOYO",
        "url": "https://www.maxyoyohome.com/products/maxyoyo-japanese-floor-futon-mattress-twin-size-3-thicken-tatami-sleeping-pad-foldable-roll-up-mattress-portable-floor-mattress-pad-for-adults-guest-room-camping",
        "referenceKey": "floor_mattress",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ceramic washbasin cartons",
        "marker": [
          45,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "CERAMIC WASHBASIN and CERAMIC ABOVE COUNTER BASIN appear on two cartons; sizes may differ.",
        "quantityLabel": "2 cartons shown",
        "price": 79.9,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR 19 × 14.7-inch white ceramic vessel sink",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/VEVOR-Modern-Ceramic-Vessel-Sink-19-x14-7-Bathroom-Vanity-Bowl-Countertop-White/3GXR3EB8AGHE",
        "referenceKey": "vessel_sink",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "JET 14-piece cushion-grip screwdriver set",
        "marker": [
          43,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "JET and 14-piece Cushion Grip Screwdriver Set are readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Detroit Axle brake-caliper carton",
        "marker": [
          35,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Premium Brake Caliper is printed; vehicle fitment and part number are not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Edge Wedge carton",
        "marker": [
          57,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Edge Wedge is readable, but dimensions and exact use/model are unclear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-42-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #42 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #42 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642992238847",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-42-liquidation-pallet-wholesale-medium-general-merchandise-42-liquidation-pallet-wholesale-liquidationdeals-ca-1255270428.jpg?v=1787250577",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-42-liquidation-pallet-wholesale-medium-general-merchandise-42-liquidation-pallet-wholesale-liquidationdeals-ca-1255270428.jpg?v=1787250577",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "SUCHTALE 40-inch tow-behind dethatcher",
        "marker": [
          25,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "40-INCH TINE TOW DETHATCHER and SUCHTALE are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Office chair — JD01 carton",
        "marker": [
          66,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "OFFICE CHAIR, model JD01 and one-set carton quantity are printed.",
        "price": 65.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "edx mid-back ergonomic mesh desk chair, black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/edx-Mid-Back-Ergonomic-Desk-Chair-with-Wheels-Lumbar-Support-for-Home-Office-Bedroom-Black/5W8HGB8BHWCP",
        "referenceKey": "office_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Gittelsnow cat tree",
        "marker": [
          88,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Cat Tree and model GCT003SW are printed; height/accessory layout is not visible.",
        "price": 82.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut 55-inch cat tree with condo and hammocks",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Aosom Canada",
        "url": "https://www.aosom.ca/item/pawhut-55-cat-tree-for-indoor-cats-cat-tower-kitty-activity-center-with-cat-bed-ramp-condo-hammocks-hanging-ball-toys~1AR68GR839801.html",
        "referenceKey": "cat_tree",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ceramic washbasin cartons",
        "marker": [
          43,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "CERAMIC ABOVE COUNTER BASIN and CERAMIC WASH BASIN are readable; dimensions may differ.",
        "quantityLabel": "2 cartons shown",
        "price": 79.9,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR 19 × 14.7-inch white ceramic vessel sink",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/VEVOR-Modern-Ceramic-Vessel-Sink-19-x14-7-Bathroom-Vanity-Bowl-Countertop-White/3GXR3EB8AGHE",
        "referenceKey": "vessel_sink",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Pull-out cabinet organizer basket",
        "marker": [
          12,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Pull Out Cabinet Organizer Basket is printed on the narrow carton; exact mounting dimensions need confirmation.",
        "price": 103.29,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "HOMLUX 14 × 18-inch two-tier pull-out cabinet organizer",
        "comparisonNote": "Basket count and cabinet dimensions may differ.",
        "priceUnit": "one two-tier organizer",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/HOMLUX-2-Tier-14-in-W-x-18-in-D-Silver-Metal-Individual-Pull-Out-Cabinet-Organizer-418142X-Double-basket/322952093",
        "referenceKey": "cabinet_organizer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Carton with motorcycle wording",
        "marker": [
          80,
          14
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "MOTORCYCLE and red-colour text are visible, but the exact product identity is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Carton marked SCH090-DBL",
        "marker": [
          66,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The code is readable; product type is not shown on this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-41-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #41 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #41 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642991943935",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-41-liquidation-pallet-wholesale-medium-general-merchandise-41-liquidation-pallet-wholesale-liquidationdeals-ca-1255270429.jpg?v=1787250609",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-41-liquidation-pallet-wholesale-medium-general-merchandise-41-liquidation-pallet-wholesale-liquidationdeals-ca-1255270429.jpg?v=1787250609",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "MAYESAR handmade stainless-steel sink",
        "marker": [
          19,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "The carton pictures a single-bowl sink; dimensions and mounting style are not confirmed.",
        "price": 150.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Karl home 30-inch stainless-steel single-bowl drop-in sink",
        "comparisonNote": "Bowl dimensions, gauge, mounting method and accessories may differ.",
        "priceUnit": "one kitchen sink",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Karl-home-30-in-Drop-In-Single-Bowl-Stainless-Steel-Kitchen-Sink-K1G23000411/331381624",
        "referenceKey": "kitchen_sink",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "EAGLE PEAK 13 × 13-foot canopy",
        "marker": [
          88,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "EAGLE PEAK Canopy 13 ft × 13 ft is printed; accessories and exact model need confirmation.",
        "price": 179.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "EAGLE PEAK 13 × 13-foot pop-up canopy with privacy curtain, grey",
        "comparisonNote": "Comparison includes one curtain; colour and accessories in the pictured carton are not confirmed.",
        "priceUnit": "one canopy kit",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/ip/EAGLE-PEAK-13x13-Pop-up-Outdoor-Canopy-Tent-Instant-Folding-Shelter-with-One-Privacy-Curtain-Gray/5447257513",
        "referenceKey": "eagle_canopy",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "MRBIN ROME 36-litre bin",
        "marker": [
          46,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "ROME 36L and a pedal-bin drawing are visible; code HROME0211 is printed.",
        "price": 72.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Innovaze 30-litre rectangular stainless-steel step bin",
        "comparisonNote": "Pictured MRBIN ROME carton is marked 36 litres; different size and brand.",
        "priceUnit": "one 30-litre bin",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Innovaze-8-Gal-30-Liter-Fingerprint-Free-Stainless-Steel-Rectangular-Kitchen-Step-on-Trash-Can-MGCS-AS1902/314092400",
        "referenceKey": "pedal_bin",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "YHTAUTO-branded carton",
        "marker": [
          44,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The brand is visible, but the specific automotive part/fitment is hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Other labelled shipping cartons",
        "marker": [
          48,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Shipping labels and model codes are visible without clear product names; no contents or value inferred.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-40-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #40 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #40 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642991649023",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-40-liquidation-pallet-wholesale-medium-general-merchandise-40-liquidation-pallet-wholesale-liquidationdeals-ca-1255270430.jpg?v=1787250638",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-40-liquidation-pallet-wholesale-medium-general-merchandise-40-liquidation-pallet-wholesale-liquidationdeals-ca-1255270430.jpg?v=1787250638",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Liberty Basics model 512 wall-mounted hose reel",
        "marker": [
          76,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Model 512 and Wall Mounted Hose Reel with Shelf are printed; bronze colour is listed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "LAQUAL 10-gallon glass fish tank",
        "marker": [
          75,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "LAQUAL 10-Gallon Glass Fish Tank is printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ingenuity Keep Cozy 3-in-1 baby seat",
        "marker": [
          51,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Keep Cozy 3-in-1 Grow With Me bouncer/rocker packaging is readable.",
        "price": 79.88,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Ingenuity Keep Cozy 3-in-1 bounce and rock seat, Spruce",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Ingenuity-Keep-Cozy-3-in-1-Grow-with-Me-Bounce-Rock-Seat-Spruce/4XS9SW5JILKS",
        "referenceKey": "ingenuity_bouncer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "SPRDENG D01 office chair",
        "marker": [
          29,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "D01 OFFICE CHAIR and the mesh-chair illustration are visible.",
        "price": 65.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "edx mid-back ergonomic mesh desk chair, black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/edx-Mid-Back-Ergonomic-Desk-Chair-with-Wheels-Lumbar-Support-for-Home-Office-Bedroom-Black/5W8HGB8BHWCP",
        "referenceKey": "office_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "MORKPRISM office chair",
        "marker": [
          31,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Office Chair and an upholstered rolling chair are pictured; exact model is unclear.",
        "price": 65.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "edx mid-back ergonomic mesh desk chair, black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/edx-Mid-Back-Ergonomic-Desk-Chair-with-Wheels-Lumbar-Support-for-Home-Office-Bedroom-Black/5W8HGB8BHWCP",
        "referenceKey": "office_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "VIQUA UV water-treatment system",
        "marker": [
          25,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The carton describes a UV water system with prefiltration; model, flow rating and included components are not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "San Jamar touchless-dispenser carton",
        "marker": [
          77,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Touchless Dispenser and San Jamar branding are visible; the exact dispenser type/model needs confirmation.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "VEVOR-branded carton",
        "marker": [
          57,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Only the brand is readable on the narrow carton.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-36-liquidation-pallet-wholesale-copy-1": {
    "title": "Medium General Merchandise #37 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #37 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642990960895",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-37-liquidation-pallet-wholesale-medium-general-merchandise-37-liquidation-pallet-wholesale-liquidationdeals-ca-1255270433.jpg?v=1787250731",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-37-liquidation-pallet-wholesale-medium-general-merchandise-37-liquidation-pallet-wholesale-liquidationdeals-ca-1255270433.jpg?v=1787250731",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "LANMOUNTAIN padded folding camping chair",
        "marker": [
          65,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Folding Hard Arm Padded Camping Chair is printed with an illustration.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "LUNDERG raised toilet seat with handles",
        "marker": [
          25,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Raised Toilet Seat with Handles, Standard and LUNDERG are readable.",
        "price": 69.2,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Carex toilet-seat elevator with handles for standard toilets",
        "comparisonNote": "Comparison is the standard-toilet version with handles; bowl shape and features may differ.",
        "priceUnit": "one product",
        "source": "Carex US",
        "url": "https://carex.com/products/carex-toilet-seat-elevator-with-handles-standard",
        "referenceKey": "carex_elevator",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Standing desk",
        "marker": [
          83,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Standing Desk is printed; the label lists a roughly 47.2 × 23.6-inch top.",
        "price": 125.75,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "WONDER COMFORT 48 × 24-inch electric standing desk, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/WONDER-COMFORT-48-x-24-in-Electric-White-Adjustable-Height-Rising-Standing-Desk-with-Splice-Board-2-Hook-and-Wire-Hole-TN-ELT4824-WT/339664175",
        "referenceKey": "standing_desk",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Wall mirror",
        "marker": [
          49,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "WALL MIRROR is printed; shape and dimensions are not established.",
        "price": 40.04,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "XRAMFY 24 × 36-inch black framed rectangular wall mirror",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/XRAMFY-24-in-W-x-36-in-H-Rectangular-Aluminum-Alloy-Framed-Rounded-Black-Wall-Mirror-BRTRC2436-BLACK/323214930",
        "referenceKey": "wall_mirror",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Multipurpose portable shelf/stand",
        "marker": [
          24,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The product category is printed, but the style, size and assembly configuration are hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Flat cartons with covered product labels",
        "marker": [
          42,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Codes and colour information are visible without a clear product name.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-35-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #35 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #35 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642990698751",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-35-liquidation-pallet-wholesale-medium-general-merchandise-35-liquidation-pallet-wholesale-liquidationdeals-ca-1255270434.jpg?v=1787250757",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-35-liquidation-pallet-wholesale-medium-general-merchandise-35-liquidation-pallet-wholesale-liquidationdeals-ca-1255270434.jpg?v=1787250757",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Portable evaporative air coolers",
        "marker": [
          49,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "AIR COOLER and wheeled evaporative-cooler drawings appear on three cartons; capacities/models are not clear.",
        "quantityLabel": "3 illustrated cartons shown",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax portable evaporative air cooler with remote and wheels",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Portable-Evaporative-Air-Cooler-Fan-Humidifier-w-Remote-Control-Wheels/4ZEYN5AISOHZ",
        "referenceKey": "evaporative_cooler",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "MUCHENGHY 10-foot offset patio umbrella",
        "marker": [
          21,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "10 FT OFFSET HANGING UMBRELLA is printed.",
        "price": 90.73,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "PASAMIC 10-foot offset patio umbrella, navy, base included",
        "comparisonNote": "Fabric, mechanism and included base can differ.",
        "priceUnit": "one umbrella with base",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/PASAMIC-10-ft-Aluminum-Offset-Cantilever-Patio-Umbrella-with-Base-Included-and-Infinite-Tilt-in-Navy-Blue-A0BB13D0-B1B01/330087072",
        "referenceKey": "patio_umbrella",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "150 × 180 playpen kit",
        "marker": [
          43,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Playpen Suite 150 × 180 is printed; the unit and included accessories need confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Office chair",
        "marker": [
          74,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Office Chair and a rolling-chair drawing are visible.",
        "price": 65.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "edx mid-back ergonomic mesh desk chair, black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/edx-Mid-Back-Ergonomic-Desk-Chair-with-Wheels-Lumbar-Support-for-Home-Office-Bedroom-Black/5W8HGB8BHWCP",
        "referenceKey": "office_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Appliance carton marked KYS-30-105Y",
        "marker": [
          74,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "The code and 45W rating are readable; the exact appliance type is not shown on this face.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-33-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #33 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #33 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642990305535",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-33-liquidation-pallet-wholesale-medium-general-merchandise-33-liquidation-pallet-wholesale-liquidationdeals-ca-1255270436.jpg?v=1787250817",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-33-liquidation-pallet-wholesale-medium-general-merchandise-33-liquidation-pallet-wholesale-liquidationdeals-ca-1255270436.jpg?v=1787250817",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "SHW heavy-duty clothes-rack carton",
        "marker": [
          74,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "SHW Heavy-Duty Clothes Rack is printed on the narrow carton; configuration and size require confirmation.",
        "price": 71.26,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "SKYSHALO double-rod heavy-duty garment rack, black, 300 lb",
        "comparisonNote": "Different brand; rod layout, size and load rating may differ.",
        "priceUnit": "one clothes rack",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/SKYSHALO-Heavy-Duty-Clothes-Rack-Double-Hanging-Rods-Clothing-Garment-Rack-with-Bottom-Storage-Tier-Hold-Up-to-300lbs-Black-JYKCYJ2838122UE86V0-1018/333202821",
        "referenceKey": "clothes_rack",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Carton labelled Ultrathin Body Slimmer",
        "marker": [
          87,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "The wording is visible, but the model and mechanism are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Flat-pack carton with walnut colour selected",
        "marker": [
          25,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "The colour selection and carton code are readable; furniture type is not identified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Cartons marked T3005 / LJ1S001BS0W",
        "marker": [
          70,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "These model codes are visible, but the product identities are not established.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "safe-box-electronics-pallet-120-liquidation-pallet-wholesale-copy": {
    "title": "Overstock Safe Box Electronics Pallet #116 | Liquidation Pallet Wholesale",
    "shortTitle": "Overstock Safe Box Electronics Pallet #116 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642986963199",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me",
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-safe-box-electronics-pallet-116-liquidation-pallet-wholesale-overstock-safe-box-electronics-pallet-116-liquidation-pallet-wholesale-liquidationdeals-ca-1255270440.jpg?v=1787250936",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-safe-box-electronics-pallet-116-liquidation-pallet-wholesale-overstock-safe-box-electronics-pallet-116-liquidation-pallet-wholesale-liquidationdeals-ca-1255270440.jpg?v=1787250936",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Electronic keypad-safe cartons",
        "marker": [
          50,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Safe illustrations appear across the visible face. Brand, capacity and the number of units inside are not established.",
        "quantityLabel": "Multiple cartons shown",
        "price": 90.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 1.2-cu.-ft. keypad home safe, single door",
        "comparisonNote": "Capacity and lock configuration of the photographed cartons are not confirmed. Retailer currently marks this configuration out of stock.",
        "priceUnit": "one safe",
        "source": "VEVOR US",
        "url": "https://www.vevor.com/electronic-safes-c_10271/vevor-safe-1-2-cubic-feet-home-safe-steel-for-cash-gold-15-8x11-8x13-8-inch-p_010910855833",
        "referenceKey": "electronic_safe",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "safe-box-electronics-pallet-liquidation-pallet-wholesale-copy": {
    "title": "Overstock Safe Box Electronics Pallet #119 | Liquidation Pallet Wholesale",
    "shortTitle": "Overstock Safe Box Electronics Pallet #119 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642985160959",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me",
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-safe-box-electronics-pallet-119-liquidation-pallet-wholesale-overstock-safe-box-electronics-pallet-119-liquidation-pallet-wholesale-liquidationdeals-ca-1255270442.jpg?v=1787250996",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-safe-box-electronics-pallet-119-liquidation-pallet-wholesale-overstock-safe-box-electronics-pallet-119-liquidation-pallet-wholesale-liquidationdeals-ca-1255270442.jpg?v=1787250996",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Electronic keypad-safe cartons",
        "marker": [
          50,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Safe illustrations appear across the visible face. Brand, capacity and the number of units inside are not established.",
        "quantityLabel": "Multiple cartons shown",
        "price": 90.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 1.2-cu.-ft. keypad home safe, single door",
        "comparisonNote": "Capacity and lock configuration of the photographed cartons are not confirmed. Retailer currently marks this configuration out of stock.",
        "priceUnit": "one safe",
        "source": "VEVOR US",
        "url": "https://www.vevor.com/electronic-safes-c_10271/vevor-safe-1-2-cubic-feet-home-safe-steel-for-cash-gold-15-8x11-8x13-8-inch-p_010910855833",
        "referenceKey": "electronic_safe",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "medium-general-merchandise-28-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #27 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #27 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642256859391",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-27-liquidation-pallet-wholesale-medium-general-merchandise-27-liquidation-pallet-wholesale-liquidationdeals-ca-1255051999.jpg?v=1787171711",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-27-liquidation-pallet-wholesale-medium-general-merchandise-27-liquidation-pallet-wholesale-liquidationdeals-ca-1255051999.jpg?v=1787171711",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Pair of upholstered counter stools",
        "marker": [
          62,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Two fixed-leg counter-height chairs are pictured; brand, upholstery and seat height are not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Intex Jump-O-Lene inflatable play centre",
        "marker": [
          29,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "INTEX Jump-O-Lene and an inflatable castle-style play centre are pictured.",
        "price": 93.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Intex Jump-O-Lene inflatable play tent with 100 balls",
        "comparisonNote": "Comparison includes play balls; pictured edition and supplied accessories are not confirmed.",
        "priceUnit": "one bouncer and 100-ball set",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Intex-Inflatable-Jump-O-Lene-Ball-Pit-Bouncer-Bounce-House-Play-Tent-with-100-Play-Balls-48260EP-49600EP-HD/339032696",
        "referenceKey": "jumpolene",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electric ceiling TV mount",
        "marker": [
          13,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Electric ceiling TV mount is printed; screen-size and weight limits are unreadable.",
        "price": 219.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Mount-It MI-4223 motorized ceiling TV mount",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/mount-it-Motorized-Ceiling-TV-Wall-Mount-MI-4223/319147813",
        "referenceKey": "ceiling_tv_mount",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Wall-mounted storage rack",
        "marker": [
          65,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A wall shelf/rack with hooks is pictured; exact use and dimensions need confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Flat-pack furniture cartons",
        "marker": [
          67,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Model codes, black colour and metal-frame wording are visible, but product types are not established.",
        "quantityLabel": "Several cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-electronics-113-liquidation-pallet-wholesale-copy": {
    "title": "Medium Electronics #113 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #113 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642245914879",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-113-liquidation-pallet-wholesale-medium-electronics-113-liquidation-pallet-wholesale-liquidationdeals-ca-1255052005.jpg?v=1787171891",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-113-liquidation-pallet-wholesale-medium-electronics-113-liquidation-pallet-wholesale-liquidationdeals-ca-1255052005.jpg?v=1787171891",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "BISSELL Little Green ProHeat portable cleaner",
        "marker": [
          81,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Little Green ProHeat and model 2513B are printed.",
        "price": 159.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL Little Green ProHeat Deluxe portable carpet cleaner, 25137 bundle",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "bissell_little_green",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "STARRYBOT portable carpet cleaners",
        "marker": [
          50,
          62
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "STARRYBOT and two portable cleaner illustrations are visible; exact model and cleaning mode need confirmation.",
        "quantityLabel": "2 cartons shown",
        "price": 99.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "STARRYBOT 18kPa portable carpet cleaner with steam and heating",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/browse/home/portable-carpet-cleaners/starrybot/4044_90548_4047_7022571_5993576/YnJhbmQ6U3RhcnJ5Ym90",
        "referenceKey": "starrybot_cleaner",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Mayaki MFSP12L-03 backpack sprayer",
        "marker": [
          51,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Mayaki, MFSP12L-03 and a backpack sprayer with trigger/wand are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Polar Revive one-HP water chiller",
        "marker": [
          75,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "1HP WATER CHILLER and Polar Revive are printed; accessory completeness is not checked.",
        "price": 999.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Polar Revive 1 HP cold-plunge chiller with hoses and pump",
        "comparisonNote": "Pictured horsepower and supplied accessories are not confirmed; comparison selects the 1 HP version.",
        "priceUnit": "one chiller kit",
        "source": "Polar Revive",
        "url": "https://polarrevive.com/products/polar-revive-chiller-for-ice-bath-and-cold-plunges-including-all-hoses-and-pumps-1-3-hp-2-3-hp-1-hp-models",
        "referenceKey": "polar_chiller",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Weston sous-vide water oven",
        "marker": [
          47,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "WESTON, sous-vide wording and a countertop water-bath cooker are pictured; exact model is not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Shiatsu foot massager",
        "marker": [
          25,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "SHIATSU FOOT MASSAGER is printed; brand/model is not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "HONZIN recessed LED ceiling lights",
        "marker": [
          80,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "12 PACK, six-inch, 12W and 1050LM are printed. Contents have not been counted.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Artika CandyGlobe pendant light",
        "marker": [
          23,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "CandyGlobe Pendant Light and a globe-cluster light are pictured.",
        "price": 79.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Artika Champagne Globe LED pendant, black and gold",
        "comparisonNote": "Different Artika globe-pendant model; not an exact CandyGlobe price.",
        "priceUnit": "one product",
        "source": "Artika US",
        "url": "https://artika.com/products/champagne-globe-modern-led-pendant-light",
        "referenceKey": "artika_candy",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Shallow-well pump carton",
        "marker": [
          24,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Shallow-well-pump wording is partly visible on the blue/white carton; model/rating is obscured.",
        "price": 79.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "LANCHEZ 1.2 HP / 2,100 GPH shallow-well pump. Reference listing does not confirm the same model/flow rating.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/ip/LANCHEZ-1-2-HP-Stainless-Steel-Shallow-Well-Pump-115V-2100-GPH-Water-Booster-Jet-Pump/20147259225",
        "referenceKey": "jet_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Coffee-equipment carton",
        "marker": [
          83,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Pour-over/cold-brew wording is visible, but the specific coffee product is not identified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-electronics-29-liquidation-pallet-wholesale-copy": {
    "title": "Medium Electronics #24 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #24 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642240344319",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-24-liquidation-pallet-wholesale-medium-electronics-24-liquidation-pallet-wholesale-liquidationdeals-ca-1255043577.jpg?v=1787164330",
    "photoWidth": 3024,
    "photoHeight": 4032,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-24-liquidation-pallet-wholesale-medium-electronics-24-liquidation-pallet-wholesale-liquidationdeals-ca-1255043577.jpg?v=1787164330",
        "width": 3024,
        "height": 4032
      }
    ],
    "items": [
      {
        "label": "PXN V3-series gaming racing wheel",
        "marker": [
          26,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "PXN branding and an orange/black racing wheel with pedals are pictured; exact model suffix is partly obscured.",
        "price": 115.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "PXN V900 Gen2 wheel and pedal bundle",
        "comparisonNote": "Generation, compatibility and supplied pedals may differ.",
        "priceUnit": "one wheel and pedal set",
        "source": "PXN",
        "url": "https://shop.e-pxn.com/products/pxn-v900-gen2-steering-wheel",
        "referenceKey": "pxn_v900",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Herdio eight-inch indoor/outdoor speakers",
        "marker": [
          33,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Eight-inch two-way waterproof indoor/outdoor speakers and paired power ratings are printed; kit contents are unverified.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Toshiba 0.9-cu.-ft. microwave",
        "marker": [
          33,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "ML-EM25P(SS)/CA and 0.9 CU.FT. are printed; 1300W is the listed electrical rating.",
        "price": 99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach 1.1-cu.-ft. stainless-steel microwave",
        "comparisonNote": "Model, size and included accessories may differ from the photographed carton.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Hamilton-Beach-Microwave-1-1-cu-ft-Stainless-Steel/6000200630082",
        "referenceKey": "hamilton_microwave",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Hermitlux HDW5CW01 countertop dishwasher",
        "marker": [
          33,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Hermitlux, countertop-dishwasher wording and HDW5CW01 are printed.",
        "price": 249.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "AIRMSEN AE-TDQR03 countertop dishwasher, white/black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/ip/AIRMSEN-Portable-Countertop-Dishwasher-with-5-Liter-Built-in-Water-Tank-and-Air-Dry-Function-5-Washing-Programs-Mini-Dishwasher-AE-TDQR03/256074875",
        "referenceKey": "airmsen_dishwasher",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electronic safe cartons",
        "marker": [
          47,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Two keypad-safe illustrations are visible; capacities/models may differ.",
        "quantityLabel": "2 cartons shown",
        "price": 90.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 1.2-cu.-ft. keypad home safe, single door",
        "comparisonNote": "Capacity and lock configuration of the photographed cartons are not confirmed. Retailer currently marks this configuration out of stock.",
        "priceUnit": "one safe",
        "source": "VEVOR US",
        "url": "https://www.vevor.com/electronic-safes-c_10271/vevor-safe-1-2-cubic-feet-home-safe-steel-for-cash-gold-15-8x11-8x13-8-inch-p_010910855833",
        "referenceKey": "electronic_safe",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Slow juicer",
        "marker": [
          69,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "A vertical squeezing auger and juice bowl are pictured; brand/model is not visible.",
        "price": 159.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Anybear/Amumu 250W cold-press juicer with 4.3-inch chute. Listed sold out; model match needs confirmation.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Anybear U.S. store",
        "url": "https://anybear.com/products/1",
        "referenceKey": "slow_juicer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "TVD steam cleaner",
        "marker": [
          58,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "TVD STEAM CLEANER is readable; exact model is partly hidden.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Neretva sewing machine",
        "marker": [
          73,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "The carton pictures a sewing machine with stitch controls; exact model is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "100-foot retractable garden hose reel",
        "marker": [
          60,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Garden hose length 100 ft and half-inch diameter are printed.",
        "price": 143.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Giraffe Tools 1/2-inch × 100-foot retractable garden hose reel",
        "comparisonNote": "Retailer labels this comparison as pre-order. Hose length, diameter and mounting hardware may differ.",
        "priceUnit": "one product",
        "source": "Giraffe Tools US",
        "url": "https://giraffetools.com/products/retractable-garden-hose-reel-1-2in-100ft",
        "referenceKey": "retractable_hose",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Range hood",
        "marker": [
          73,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Range Hood is printed; installation dimensions, vent configuration and model need confirmation.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale-copy-8": {
    "title": "Medium Electronics #29 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #29 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642240049407",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-29-liquidation-pallet-wholesale-medium-electronics-29-liquidation-pallet-wholesale-liquidationdeals-ca-1255043578.jpg?v=1787164358",
    "photoWidth": 3024,
    "photoHeight": 4032,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-29-liquidation-pallet-wholesale-medium-electronics-29-liquidation-pallet-wholesale-liquidationdeals-ca-1255043578.jpg?v=1787164358",
        "width": 3024,
        "height": 4032
      }
    ],
    "items": [
      {
        "label": "AQUASTRONG two-HP variable-speed pool pump",
        "marker": [
          35,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Two HP, variable speed and PSP200PM are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Giraffe Tools Grandfalls pressure washer",
        "marker": [
          68,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "GRANDFALLS PRESSURE WASHER and Giraffe Tools are readable; exact version is unclear.",
        "price": 629.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Giraffe Tools Grandfalls Pro 3700 PSI wall-mounted pressure washer",
        "comparisonNote": "Pro-series comparison; photographed generation, hose length and pressure rating may differ.",
        "priceUnit": "one product",
        "source": "Giraffe Tools US",
        "url": "https://giraffetools.com/products/grandfalls-pressure-washer-pro",
        "referenceKey": "grandfalls",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "POWERSMITH pressure washer",
        "marker": [
          39,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "POWERSMITH and PRESSURE WASHER are printed; rating/model is not readable.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "FOTING stainless-steel sump pump",
        "marker": [
          77,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "FOTING Stainless Steel Sump Pump is printed; exact capacity is not visible.",
        "price": 40.49,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Renogy 200W solar panel",
        "marker": [
          55,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Renogy, 200W and solar-panel wording are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "COOLMUSIC AC20 guitar amplifier",
        "marker": [
          76,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "AC20 Multifunctional Guitar Amplifier is printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Bonsaii C283-A paper shredder",
        "marker": [
          34,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Bonsaii C283-A US and paper-shredder artwork are visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Wall-pack lighting carton",
        "marker": [
          73,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "WALL PACK LIGHT and four-piece carton wording are printed; wattage is not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Cordless pole saw",
        "marker": [
          17,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "CORDLESS POLE SAW is printed; bar length, voltage and batteries are not confirmed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Countertop cooking-appliance carton",
        "marker": [
          77,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Cooking-appliance artwork is visible; exact type/model and capacity are unclear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-electronics-111-liquidation-pallet-wholesale-copy-1": {
    "title": "Medium Electronics #105 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #105 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642239787263",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-105-liquidation-pallet-wholesale-medium-electronics-105-liquidation-pallet-wholesale-liquidationdeals-ca-1255043579.jpg?v=1787164389",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-105-liquidation-pallet-wholesale-medium-electronics-105-liquidation-pallet-wholesale-liquidationdeals-ca-1255043579.jpg?v=1787164389",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "INOVIVA S21 frozen-drink maker",
        "marker": [
          48,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Slushie, Frozen Drink Maker and model S21 are printed.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Momcozy bottle-care appliance",
        "marker": [
          17,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Momcozy and a bottle-care chamber are pictured; exact washing/sterilising model is not confirmed.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Frigidaire countertop ice maker",
        "marker": [
          15,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "FRIGIDAIRE and ICE MAKER are readable; exact model/ice output is not clear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "AIRMSEN countertop dishwasher",
        "marker": [
          47,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "AIRMSEN DISHWASHER and a compact glass-door unit are pictured; exact model is unclear.",
        "price": 249.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "AIRMSEN AE-TDQR03 countertop dishwasher, white/black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/ip/AIRMSEN-Portable-Countertop-Dishwasher-with-5-Liter-Built-in-Water-Tank-and-Air-Dry-Function-5-Washing-Programs-Mini-Dishwasher-AE-TDQR03/256074875",
        "referenceKey": "airmsen_dishwasher",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "DEKO DSP900C1-US one-HP sump pump",
        "marker": [
          79,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "DEKO, DSP900C1-US and 1HP SUMP PUMP are printed.",
        "price": 40.49,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "FOTING 1/4 HP / 1,500 GPH pump. The pictured pump’s rating is not confirmed.",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart U.S. marketplace",
        "url": "https://www.walmart.com/browse/foting/YnJhbmQ6Rk9USU5H",
        "referenceKey": "submersible_pump",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "IKROOO steam cleaner",
        "marker": [
          51,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "IKROOO STEAM CLEANER and the canister-cleaner illustration are visible.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electric centrifugal juicer",
        "marker": [
          79,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Electric Juicer and a feed-chute/strainer appliance are pictured; exact model is not clear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Portable evaporative air cooler",
        "marker": [
          80,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Air cooler and a wheeled evaporative cooler are pictured; tank/cooling specifications are unclear.",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax portable evaporative air cooler with remote and wheels",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Portable-Evaporative-Air-Cooler-Fan-Humidifier-w-Remote-Control-Wheels/4ZEYN5AISOHZ",
        "referenceKey": "evaporative_cooler",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Slide-out heat press",
        "marker": [
          79,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "SLIDE OUT HEAT PRESS and the pink colour selection are printed; platen dimensions are unclear.",
        "price": 197.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 15 × 15-inch swing-away 5-in-1 heat press",
        "comparisonNote": "Comparison includes five attachments; platen size and included attachments on the pictured carton are not confirmed.",
        "priceUnit": "one press kit",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VEVOR-15-in-x-15-in-Pro-Heat-Press-Machine-5-in-1-Combo-360-Swing-Away-Digital-Sublimation-Vinyl-Transfer-Printer-Blue-TJWHYXKLP8038N8U4V1/318963499",
        "referenceKey": "heat_press",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Cigar-humidor cabinet",
        "marker": [
          22,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Cigar Humidor Cabinet and a windowed cabinet are pictured; capacity and climate-control specifications are unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Decorative pendant-light carton",
        "marker": [
          46,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Pendant-light artwork is visible; brand, diameter and bulb configuration are unclear.",
        "price": 69,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Artika Imperium single pendant light, brushed nickel",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Artika US",
        "url": "https://artika.com/products/imperium-2",
        "referenceKey": "artika_imperium",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale-copy-6": {
    "title": "Medium Electronics #109 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #109 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642239197439",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-109-liquidation-pallet-wholesale-medium-electronics-109-liquidation-pallet-wholesale-liquidationdeals-ca-1255043582.jpg?v=1787164481",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-109-liquidation-pallet-wholesale-medium-electronics-109-liquidation-pallet-wholesale-liquidationdeals-ca-1255043582.jpg?v=1787164481",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "BISSELL Revolution HydroSteam carpet cleaner",
        "marker": [
          28,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Revolution HydroSteam and BISSELL are printed; exact model/bundle is not readable.",
        "price": 329.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "BISSELL Revolution HydroSteam carpet cleaner 4123",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "BISSELL US",
        "url": "https://www.bissell.com/en-us/product/revolution-hydrosteam-upright-carpet-upholstery-cleaner-4123.html",
        "referenceKey": "bissell_hydrosteam",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Waterdrop countertop reverse-osmosis dispenser",
        "marker": [
          27,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Waterdrop Countertop Reverse Osmosis Water Dispenser is printed; exact model is not shown.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "AIRMSEN TDQR03 countertop dishwasher",
        "marker": [
          69,
          84
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "AIRMSEN Portable Countertop Dishwasher TDQR03 is printed.",
        "price": 249.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "AIRMSEN AE-TDQR03 countertop dishwasher, white/black",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart US marketplace",
        "url": "https://www.walmart.com/ip/AIRMSEN-Portable-Countertop-Dishwasher-with-5-Liter-Built-in-Water-Tank-and-Air-Dry-Function-5-Washing-Programs-Mini-Dishwasher-AE-TDQR03/256074875",
        "referenceKey": "airmsen_dishwasher",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "STEELITE 18-inch electric tiller",
        "marker": [
          79,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "STEELITE 18 INCH ELECTRIC TILLER and DG551 are printed.",
        "price": 149.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe TJ604E 13.5A 16-inch electric tiller/cultivator",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-13-5-Amp-16-in-Electric-Tiller-Cultivator-with-5-5-in-Wheels-TJ604E/206429581",
        "referenceKey": "electric_tiller",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "500W electric ice crusher",
        "marker": [
          60,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "ICE CRUSHER and 500W are printed; hopper size/model is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric griddle",
        "marker": [
          56,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Electric Griddle is printed; surface dimensions and controls are not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Retractable garden hose reel",
        "marker": [
          27,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Garden Hose Reel / Automatic Retractable wording is readable; hose length is partly hidden.",
        "price": 143.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Giraffe Tools 1/2-inch × 100-foot retractable garden hose reel",
        "comparisonNote": "Retailer labels this comparison as pre-order. Hose length, diameter and mounting hardware may differ.",
        "priceUnit": "one product",
        "source": "Giraffe Tools US",
        "url": "https://giraffetools.com/products/retractable-garden-hose-reel-1-2in-100ft",
        "referenceKey": "retractable_hose",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Ceiling fan with LED light",
        "marker": [
          86,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "CEILING FAN WITH LIGHT, remote control and 18W LED light are printed; diameter/model is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Cooling-fan assembly carton",
        "marker": [
          39,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "COOLING FAN ASSEMBLY is printed; vehicle/application and part number are not visible.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale-copy-5": {
    "title": "Medium Electronics #108 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #108 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642238640383",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-108-liquidation-pallet-wholesale-medium-electronics-108-liquidation-pallet-wholesale-liquidationdeals-ca-1255043583.jpg?v=1787164511",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-108-liquidation-pallet-wholesale-medium-electronics-108-liquidation-pallet-wholesale-liquidationdeals-ca-1255043583.jpg?v=1787164511",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "ZIPEAK patio-heater carton",
        "marker": [
          45,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "ZIPEAK and Patio Heater are visible; this is a rectangular heater, not the hanging ceiling model.",
        "price": 207.33,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "EnerG+ HEA-21545 1500W wall-mounted infrared heater",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/EnerG-1500-Watt-Infrared-Wall-Mounted-Electric-Outdoor-Heater-with-Remote-HEA-21545/313730792",
        "referenceKey": "patio_heater",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Air-cooler carton",
        "marker": [
          20,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "A wheeled air cooler is pictured. Brand and capacity are unclear.",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Gymax portable evaporative air cooler with remote and wheels",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Gymax-Portable-Evaporative-Air-Cooler-Fan-Humidifier-w-Remote-Control-Wheels/4ZEYN5AISOHZ",
        "referenceKey": "evaporative_cooler",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Waitbird CB-03A steam-cleaner carton",
        "marker": [
          44,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Waitbird branding and CB-03A are visible.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Vibration-plate carton",
        "marker": [
          58,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "A vibration exercise platform is pictured; model is unclear.",
        "price": 199.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Lifepro Waver vibration plate",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Lifepro",
        "url": "https://lifeprofitness.com/products/the-waver-vibration-platform",
        "referenceKey": "vibration_plate",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "KEENRAY towel-warmer carton",
        "marker": [
          79,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "KEENRAY and ComfortLife 1 are visible.",
        "price": 93.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "SKYSHALO 20-litre electric towel-warmer bucket with timer",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/SKYSHALO-Towel-Warmer-20-L-Towel-Warmer-Bucket-with-Timer-Electric-Plug-In-in-White-Child-Lock-LED-Screen-and-U-Shaped-Light-MJJRTBS20LLCA39O3V1/327746302",
        "referenceKey": "towel_warmer_bucket",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "2000 PSI pressure-washer carton",
        "marker": [
          21,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "High Pressure Washer, 2000 PSI and article 610030 are printed on the box.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Kärcher SC 3 EasyFix steam-cleaner carton",
        "marker": [
          24,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Kärcher branding and SC 3 EasyFix are visible.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "ECOVACS WINBOT W2S OMNI carton",
        "marker": [
          78,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "The ECOVACS window-cleaner model is readable.",
        "price": 599.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "ECOVACS WINBOT W2S OMNI window-cleaning robot with station",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one robot and station set",
        "source": "ECOVACS US",
        "url": "https://www.ecovacs.com/us/shop/winbot-window-cleaning-robot/winbot-w2s-omni",
        "referenceKey": "winbot_w2s",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Automatic cat-litter-box carton",
        "marker": [
          60,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Smart Cat Litter Box and a dome-shaped unit are pictured; brand is unclear.",
        "price": 288,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut 72L automatic self-cleaning cat litter box",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "PawHut Canada",
        "url": "https://pawhutstore.com/en-ca/products/self-cleaning-litter-box-automatic-cat-litter-box-for-multi-cats-extra-large-72l-app-control-safety-sensor-odor",
        "referenceKey": "automatic_litter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Artika Oly lighting cartons",
        "marker": [
          55,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Artika and Oly are visible on two fixture cartons.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "WiXL carton",
        "marker": [
          77,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "The brand is visible, but the product type is not clear enough to price.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-147-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #147 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #147 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642131161343",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-147-liquidation-pallet-wholesale-medium-general-merchandise-147-liquidation-pallet-wholesale-liquidationdeals-ca-1255043593.jpg?v=1787164812",
    "photoWidth": 3024,
    "photoHeight": 4032,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-147-liquidation-pallet-wholesale-medium-general-merchandise-147-liquidation-pallet-wholesale-liquidationdeals-ca-1255043593.jpg?v=1787164812",
        "width": 3024,
        "height": 4032
      }
    ],
    "items": [
      {
        "label": "Electronic price platform scale",
        "marker": [
          51,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "ELECTRONIC PRICE PLATFORM SCALE is printed; weighing capacity and exact model are not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "FBSPORT inflatable gymnastics mat",
        "marker": [
          34,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Inflatable Gymnastics Mat and FBSPORT are printed; length and kit contents are not readable.",
        "price": 249.9,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "FBSPORT 13-foot × 8-inch-thick inflatable gymnastics mat with pump",
        "comparisonNote": "Pictured mat dimensions and included pump are not confirmed.",
        "priceUnit": "one mat and pump kit",
        "source": "FBSPORT US",
        "url": "https://www.fb-sport.com/products/13ft-air-track-8in-thick-usa",
        "referenceKey": "airtrack",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "VSUN trolling-motor carton",
        "marker": [
          44,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "VSUN TROLLING MOTOR is printed; thrust, voltage and shaft length require confirmation.",
        "price": 158,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 12V 55-lb-thrust electric trolling motor, 30-inch shaft",
        "comparisonNote": "Pictured VSUN motor's thrust, voltage and shaft length are not confirmed.",
        "priceUnit": "one trolling motor",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VEVOR-Electric-Trolling-Motor-Transom-Mounted-Outboard-Boat-Motors-12V-55-lbs-Thrust-8-Speed-Battery-Indicator-30-in-Shaft-SDKTDMD12V55PQZUV001V0-251023/339540173",
        "referenceKey": "trolling_motor",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Plastic planter cartons",
        "marker": [
          60,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "PLASTIC PLANTER / PLANTERS & POTS and planter illustrations are visible; dimensions and pack quantity are unclear.",
        "price": 8.75,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Bloem Dayton 12-inch blue plastic planter with saucer",
        "comparisonNote": "Pictured pot dimensions and carton pack count are not confirmed.",
        "priceUnit": "one planter",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Bloem-Dayton-12-in-Blue-Plastic-Planter-with-Saucer-DAY1271-6/315735209",
        "referenceKey": "planter",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Artificial decorative plants",
        "marker": [
          75,
          51
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "ARTIFICIAL PLANTS is printed; the plant species, height and number inside are unclear.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "NATOTELA drainage-channel kit carton",
        "marker": [
          72,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Grated drainage channels, connectors and end caps are pictured; exact dimensions and kit quantity are unclear.",
        "price": 79.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "U.S. TRENCH DRAIN 9.8-foot channel drain kit with black grates",
        "comparisonNote": "Pictured NATOTELA kit's total length, depth and load rating are not established.",
        "priceUnit": "one three-section kit",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/U-S-TRENCH-DRAIN-Deep-Series-5-4-in-W-x-5-4-in-D-x-39-4-in-L-Trench-and-Channel-Drain-Kit-with-Black-Grate-3-Pack-9-8-ft-83300-3/302782501",
        "referenceKey": "drain_channel",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "EAGLE PEAK outdoor-shelter carton",
        "marker": [
          44,
          13
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "EAGLE PEAK branding is readable, but the precise shelter type and dimensions are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "HOME FLOURISH carton",
        "marker": [
          80,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Brand and item code are visible without a readable product description.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-145-liquidation-pallet-wholesale-copy": {
    "title": "Medium General Merchandise #145 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium General Merchandise #145 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9642130768127",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-145-liquidation-pallet-wholesale-medium-general-merchandise-145-liquidation-pallet-wholesale-liquidationdeals-ca-1255043595.jpg?v=1787164873",
    "photoWidth": 3024,
    "photoHeight": 4032,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-145-liquidation-pallet-wholesale-medium-general-merchandise-145-liquidation-pallet-wholesale-liquidationdeals-ca-1255043595.jpg?v=1787164873",
        "width": 3024,
        "height": 4032
      }
    ],
    "items": [
      {
        "label": "Convertible children's high chair",
        "marker": [
          30,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Chaise Haute and multiple high-chair/booster configurations are pictured; brand/model is unclear.",
        "price": 79.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Cosco Simple Fold high chair",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Goldtex Canada",
        "url": "https://goldtex.ca/products/cosco-simple-fold-high-chair",
        "referenceKey": "high_chair",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Folding utility wagon",
        "marker": [
          67,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "A four-wheel folding wagon is pictured; model P12 and blue colour are printed.",
        "price": 95.33,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Pure Garden collapsible utility wagon HW1500116",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Pure-Garden-Collapsible-Utility-Wagon-with-Telescoping-Handle-HW1500116/308712310",
        "referenceKey": "folding_wagon",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Luxury Rugs carton",
        "marker": [
          50,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Luxury Rugs is printed; rug size, material and style are not visible.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CANAC carton",
        "marker": [
          28,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The retailer name and room checkboxes are visible, but no product name is established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Other covered-label cartons",
        "marker": [
          36,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The larger cartons have covered or unreadable product labels; no contents or value inferred.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-infant-socks-24-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #24 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #24 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628129624319",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913090.jpg?v=1786487469",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913090.jpg?v=1786487469",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913089.jpg?v=1786487437",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913088.jpg?v=1786487411",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913087.jpg?v=1786487380",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-24-liquidation-wholesale-pallet-overstock-infant-socks-24-liquidation-wholesale-pallet-liquidationdeals-ca-1253913086.jpg?v=1786487350",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George assorted infant tights cartons",
        "marker": [
          48,
          43
        ],
        "photoIndex": 5,
        "position": "Photo 5 · middle centre",
        "note": "The close-up label matches George assorted infant hosiery item 1518959: GEO INF RHUMBA/OP SOLID TI P3, 0–9 months. Other views include a separate pallet number, so no whole-pallet quantity is inferred.",
        "quantityLabel": "3-piece retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-23-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #23 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #23 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628121235711",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-23-liquidation-wholesale-pallet-overstock-infant-socks-23-liquidation-wholesale-pallet-liquidationdeals-ca-1253913093.jpg?v=1786487558",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-23-liquidation-wholesale-pallet-overstock-infant-socks-23-liquidation-wholesale-pallet-liquidationdeals-ca-1253913093.jpg?v=1786487558",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-23-liquidation-wholesale-pallet-overstock-infant-socks-23-liquidation-wholesale-pallet-liquidationdeals-ca-1253913092.jpg?v=1786487530",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-23-liquidation-wholesale-pallet-overstock-infant-socks-23-liquidation-wholesale-pallet-liquidationdeals-ca-1253913091.jpg?v=1786487499",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant white microfibre tights cartons",
        "marker": [
          52,
          48
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The label says George, white, 3–12 months and GEO INF MICROFIBER TI P2.",
        "quantityLabel": "2-pair retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-22-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #22 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #22 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628094267647",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-22-liquidation-wholesale-pallet-overstock-infant-socks-22-liquidation-wholesale-pallet-liquidationdeals-ca-1253913096.jpg?v=1786487648",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-22-liquidation-wholesale-pallet-overstock-infant-socks-22-liquidation-wholesale-pallet-liquidationdeals-ca-1253913096.jpg?v=1786487648",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-22-liquidation-wholesale-pallet-overstock-infant-socks-22-liquidation-wholesale-pallet-liquidationdeals-ca-1253913095.jpg?v=1786487618",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-22-liquidation-wholesale-pallet-overstock-infant-socks-22-liquidation-wholesale-pallet-liquidationdeals-ca-1253913094.jpg?v=1786487591",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant microfibre ribbed tights cartons",
        "marker": [
          57,
          70
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom centre",
        "note": "The close-up label says GEO Microfibre Ribbed Tight 2P, assorted, 3–12 months. It describes tights even though the listing is titled socks.",
        "quantityLabel": "2-pair retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-21-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #21 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #21 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628087451903",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-21-liquidation-wholesale-pallet-overstock-infant-socks-21-liquidation-wholesale-pallet-liquidationdeals-ca-1253913099.jpg?v=1786487738",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-21-liquidation-wholesale-pallet-overstock-infant-socks-21-liquidation-wholesale-pallet-liquidationdeals-ca-1253913099.jpg?v=1786487738",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-21-liquidation-wholesale-pallet-overstock-infant-socks-21-liquidation-wholesale-pallet-liquidationdeals-ca-1253913098.jpg?v=1786487710",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-21-liquidation-wholesale-pallet-overstock-infant-socks-21-liquidation-wholesale-pallet-liquidationdeals-ca-1253913097.jpg?v=1786487677",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant cotton-blend tights packs",
        "marker": [
          50,
          53
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The photographed retail packs say George infant cotton-blend tights, 3–12 months, 2 pairs per pack.",
        "quantityLabel": "2-pair retail packs shown",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "George assorted infant hosiery cartons",
        "marker": [
          55,
          51
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The second photo shows a separate assorted 0–9 month label with 3 pieces per pack. Its exact style needs confirmation.",
        "quantityLabel": "3-piece packs indicated",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-infant-socks-20-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #20 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #20 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628080505087",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-20-liquidation-wholesale-pallet-overstock-infant-socks-20-liquidation-wholesale-pallet-liquidationdeals-ca-1253913102.jpg?v=1786487829",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-20-liquidation-wholesale-pallet-overstock-infant-socks-20-liquidation-wholesale-pallet-liquidationdeals-ca-1253913102.jpg?v=1786487829",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-20-liquidation-wholesale-pallet-overstock-infant-socks-20-liquidation-wholesale-pallet-liquidationdeals-ca-1253913101.jpg?v=1786487797",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-20-liquidation-wholesale-pallet-overstock-infant-socks-20-liquidation-wholesale-pallet-liquidationdeals-ca-1253913100.jpg?v=1786487771",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant rhumba-and-opaque tights packs",
        "marker": [
          49,
          48
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The enlarged retail-pack photo says George infant rhumba & opaque tights, 0–9 months: 1 rhumba pair plus 2 opaque pairs.",
        "quantityLabel": "3-pair retail packs shown",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-17-liquidation-wholesale-pallet-copy-1": {
    "title": "Overstock Infant Socks #18 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #18 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628074377471",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-18-liquidation-wholesale-pallet-overstock-infant-socks-18-liquidation-wholesale-pallet-liquidationdeals-ca-1253913106.jpg?v=1786487948",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-18-liquidation-wholesale-pallet-overstock-infant-socks-18-liquidation-wholesale-pallet-liquidationdeals-ca-1253913106.jpg?v=1786487948",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-18-liquidation-wholesale-pallet-overstock-infant-socks-18-liquidation-wholesale-pallet-liquidationdeals-ca-1253913105.jpg?v=1786487916",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-18-liquidation-wholesale-pallet-overstock-infant-socks-18-liquidation-wholesale-pallet-liquidationdeals-ca-1253913104.jpg?v=1786487888",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-18-liquidation-wholesale-pallet-overstock-infant-socks-18-liquidation-wholesale-pallet-liquidationdeals-ca-1253913103.jpg?v=1786487857",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Cartons labelled Infant Socks",
        "marker": [
          46,
          62
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The department label says Infant Socks. No retail-pack close-up establishes whether these cartons contain socks or tights, their size, or the pack count.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-infant-socks-17-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #17 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #17 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628063236351",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-17-liquidation-wholesale-pallet-overstock-infant-socks-17-liquidation-wholesale-pallet-liquidationdeals-ca-1253913110.jpg?v=1786488068",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-17-liquidation-wholesale-pallet-overstock-infant-socks-17-liquidation-wholesale-pallet-liquidationdeals-ca-1253913110.jpg?v=1786488068",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-17-liquidation-wholesale-pallet-overstock-infant-socks-17-liquidation-wholesale-pallet-liquidationdeals-ca-1253913109.jpg?v=1786488039",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-17-liquidation-wholesale-pallet-overstock-infant-socks-17-liquidation-wholesale-pallet-liquidationdeals-ca-1253913108.jpg?v=1786488009",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-17-liquidation-wholesale-pallet-overstock-infant-socks-17-liquidation-wholesale-pallet-liquidationdeals-ca-1253913107.jpg?v=1786487977",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant grey/black cotton tights cartons",
        "marker": [
          61,
          53
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The close-up label says grey/black, 3–12 months, GEO INF COTTON TI P2.",
        "quantityLabel": "2-pair retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "George infant cream/pink cotton tights cartons",
        "marker": [
          52,
          68
        ],
        "photoIndex": 3,
        "position": "Photo 3 · bottom centre",
        "note": "A second close-up label says cream/pink, 3–12 months, GEO INF COTTON TI P2.",
        "quantityLabel": "2-pair retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-16-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #16 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #16 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628057239807",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-16-liquidation-wholesale-pallet-overstock-infant-socks-16-liquidation-wholesale-pallet-liquidationdeals-ca-1253913113.jpg?v=1786488157",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-16-liquidation-wholesale-pallet-overstock-infant-socks-16-liquidation-wholesale-pallet-liquidationdeals-ca-1253913113.jpg?v=1786488157",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-16-liquidation-wholesale-pallet-overstock-infant-socks-16-liquidation-wholesale-pallet-liquidationdeals-ca-1253913112.jpg?v=1786488133",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-16-liquidation-wholesale-pallet-overstock-infant-socks-16-liquidation-wholesale-pallet-liquidationdeals-ca-1253913111.jpg?v=1786488096",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant grey/black cotton tights cartons",
        "marker": [
          44,
          58
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The close-up label says grey/black, 3–12 months, GEO INF COTTON TI P2.",
        "quantityLabel": "2-pair retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-14-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #15 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #15 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9628040233215",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-15-liquidation-wholesale-pallet-overstock-infant-socks-15-liquidation-wholesale-pallet-liquidationdeals-ca-1253913116.jpg?v=1786488248",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-15-liquidation-wholesale-pallet-overstock-infant-socks-15-liquidation-wholesale-pallet-liquidationdeals-ca-1253913116.jpg?v=1786488248",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-15-liquidation-wholesale-pallet-overstock-infant-socks-15-liquidation-wholesale-pallet-liquidationdeals-ca-1253913115.jpg?v=1786488220",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-15-liquidation-wholesale-pallet-overstock-infant-socks-15-liquidation-wholesale-pallet-liquidationdeals-ca-1253913114.jpg?v=1786488193",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George assorted infant tights cartons",
        "marker": [
          44,
          41
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The close-up label reads GEO INF RHUMBA/OP SOLID TI P3, assorted, 0–9 months. The label indicates three garments per retail pack.",
        "quantityLabel": "3-piece retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-miscellaneous-14-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #14 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #14 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9627990196479",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-14-liquidation-wholesale-pallet-overstock-infant-socks-14-liquidation-wholesale-pallet-liquidationdeals-ca-1253913121.jpg?v=1786488335",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-14-liquidation-wholesale-pallet-overstock-infant-socks-14-liquidation-wholesale-pallet-liquidationdeals-ca-1253913121.jpg?v=1786488335",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-14-liquidation-wholesale-pallet-overstock-infant-socks-14-liquidation-wholesale-pallet-liquidationdeals-ca-1253913120.jpg?v=1786488309",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-14-liquidation-wholesale-pallet-overstock-infant-socks-14-liquidation-wholesale-pallet-liquidationdeals-ca-1253913119.jpg?v=1786488277",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant microfibre tights cartons",
        "marker": [
          58,
          50
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "The close-up label says GEO INF MICROFIBER TI 2P, black, size 2–4. The carton label describes tights rather than socks.",
        "quantityLabel": "2-pair retail packs indicated",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-mixed-electronics-13-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Miscellaneous #13 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Miscellaneous #13 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9627978957055",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-miscellaneous-13-liquidation-wholesale-pallet-overstock-miscellaneous-13-liquidation-wholesale-pallet-liquidationdeals-ca-1253913125.jpg?v=1786488455",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-miscellaneous-13-liquidation-wholesale-pallet-overstock-miscellaneous-13-liquidation-wholesale-pallet-liquidationdeals-ca-1253913125.jpg?v=1786488455",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-miscellaneous-13-liquidation-wholesale-pallet-overstock-miscellaneous-13-liquidation-wholesale-pallet-liquidationdeals-ca-1253913124.jpg?v=1786488430",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-miscellaneous-13-liquidation-wholesale-pallet-overstock-miscellaneous-13-liquidation-wholesale-pallet-liquidationdeals-ca-1253913123.jpg?v=1786488396",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-miscellaneous-13-liquidation-wholesale-pallet-overstock-miscellaneous-13-liquidation-wholesale-pallet-liquidationdeals-ca-1253913122.jpg?v=1786488370",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "LED illuminated mirror-cabinet cartons",
        "marker": [
          49,
          49
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The carton gives item 10MSLFMC02GR. Photo 3's instructions say LED Illuminated Aluminium Cabinets; photo 4 shows a mirrored cabinet front.",
        "quantityLabel": "Multiple cartons shown",
        "price": 420,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "ExBrite 24 × 32-inch aluminium LED medicine cabinet with clock",
        "comparisonNote": "Comparison includes a clock; dimensions, door arrangement and electrical features may differ.",
        "priceUnit": "one mirror cabinet",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/ExBrite-24-in-W-x-32-in-H-Silver-Aluminum-Recessed-or-Surface-Mount-Left-Medicine-Cabinet-with-Mirror-LED-and-Clock-DHMC2432V6LX/325091446",
        "referenceKey": "mirror_cabinet",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Mirrored cabinet shown inside an opened carton",
        "marker": [
          48,
          54
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "The opened-box photo shows the mirror and touch-control area. It is another view of the cabinet product, not an additional unit count.",
        "quantityLabel": "Detail view",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-mixed-electronics-12-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #12 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Mixed Electronics #12 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9627972993279",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-12-liquidation-wholesale-pallet-overstock-mixed-electronics-12-liquidation-wholesale-pallet-liquidationdeals-ca-1253913128.jpg?v=1786488548",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-12-liquidation-wholesale-pallet-overstock-mixed-electronics-12-liquidation-wholesale-pallet-liquidationdeals-ca-1253913128.jpg?v=1786488548",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-12-liquidation-wholesale-pallet-overstock-mixed-electronics-12-liquidation-wholesale-pallet-liquidationdeals-ca-1253913127.jpg?v=1786488516",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-12-liquidation-wholesale-pallet-overstock-mixed-electronics-12-liquidation-wholesale-pallet-liquidationdeals-ca-1253913126.jpg?v=1786488490",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Aipsun lighting cartons",
        "marker": [
          52,
          25
        ],
        "photoIndex": 3,
        "position": "Photo 3 · top centre",
        "note": "Aipsun branding and Light Up Your Life are visible. The fixture type, length and model are not readable.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Other sealed cartons",
        "marker": [
          45,
          58
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The lower boxes do not reveal a reliable product identification.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-mixed-electronics-11-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #11 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Mixed Electronics #11 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9627957231871",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-11-liquidation-wholesale-pallet-overstock-mixed-electronics-11-liquidation-wholesale-pallet-liquidationdeals-ca-1253913132.jpg?v=1786488638",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-11-liquidation-wholesale-pallet-overstock-mixed-electronics-11-liquidation-wholesale-pallet-liquidationdeals-ca-1253913132.jpg?v=1786488638",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-11-liquidation-wholesale-pallet-overstock-mixed-electronics-11-liquidation-wholesale-pallet-liquidationdeals-ca-1253913131.jpg?v=1786488611",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-11-liquidation-wholesale-pallet-overstock-mixed-electronics-11-liquidation-wholesale-pallet-liquidationdeals-ca-1253913130.jpg?v=1786488576",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Flower Rain LED ceiling-light carton",
        "marker": [
          42,
          57
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 has a white carton labelled Flower Rain LED Ceiling Light. Its size and wattage are not clear.",
        "price": 89.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Genoci 23.62-inch 48W flower-shaped LED ceiling light, black",
        "comparisonNote": "Shape, finish, size and wattage may differ from the Flower Rain carton.",
        "priceUnit": "one ceiling light",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Genoci-23-62-in-48-Watt-Modern-Black-Integrated-LED-Flush-Mount-Dimmable-Flower-Shape-Ceiling-Light-for-Living-Room-Bedroom-TT-L6045-5B/337724954",
        "referenceKey": "ceiling_light",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Crystal vanity-light carton",
        "marker": [
          19,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Crystal Vanity Light is printed on the white carton at the back. Brand and lamp count are unclear.",
        "price": 109.14,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "ZHLWIN 28.34-inch four-light crystal vanity fixture, sand nickel",
        "comparisonNote": "The pictured fixture's width and light count are not established.",
        "priceUnit": "one four-light fixture",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/ZHLWIN-Home-Lighting-28-34-in-4-Light-SandNickel-Modern-Crystal-Vanity-Lights-Wall-Sconces-for-Bathroom-JW-002-JW-002-4-SandNickel/339716998",
        "referenceKey": "vanity_light",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Other cartons marked Lighting",
        "marker": [
          52,
          43
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The remaining cartons are marked Lighting by hand, without readable fixture specifications.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "amz-clothing-03-1000pcs-liquidation-wholesale-pallet-copy": {
    "title": "Amz Clothing #03 - 1000pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/amz-clothing-03-1000pcs-liquidation-wholesale-pallet-amz-clothing-03-1000pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1253592822.jpg?v=1786141838",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Open gaylord with wrapped contents; individual garments not distinguishable",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-mixed-electronics-10-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #10 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Mixed Electronics #10 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9622252650751",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-10-liquidation-wholesale-pallet-overstock-mixed-electronics-10-liquidation-wholesale-pallet-liquidationdeals-ca-1253592854.jpg?v=1786142677",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-10-liquidation-wholesale-pallet-overstock-mixed-electronics-10-liquidation-wholesale-pallet-liquidationdeals-ca-1253592854.jpg?v=1786142677",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-10-liquidation-wholesale-pallet-overstock-mixed-electronics-10-liquidation-wholesale-pallet-liquidationdeals-ca-1253592853.jpg?v=1786142649",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-10-liquidation-wholesale-pallet-overstock-mixed-electronics-10-liquidation-wholesale-pallet-liquidationdeals-ca-1253592852.jpg?v=1786142616",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-10-liquidation-wholesale-pallet-overstock-mixed-electronics-10-liquidation-wholesale-pallet-liquidationdeals-ca-1253592851.jpg?v=1786142588",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Cartons marked ZS-DY-20098",
        "marker": [
          45,
          43
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "The close-up labels show ZS-DY-20098. The photos do not show the product itself or a clear product name.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Large sealed cartons",
        "marker": [
          57,
          65
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "Only shipping warnings are readable on the large cartons. A retail comparison would require a product label or an opened-box photo.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-bath-body-works-fragrance-refills-8-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Mixed Electronics #9 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Mixed Electronics #9 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9622218703103",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-9-liquidation-wholesale-pallet-overstock-mixed-electronics-9-liquidation-wholesale-pallet-liquidationdeals-ca-1253592857.jpg?v=1786142771",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-9-liquidation-wholesale-pallet-overstock-mixed-electronics-9-liquidation-wholesale-pallet-liquidationdeals-ca-1253592857.jpg?v=1786142771",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-9-liquidation-wholesale-pallet-overstock-mixed-electronics-9-liquidation-wholesale-pallet-liquidationdeals-ca-1253592856.jpg?v=1786142738",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-mixed-electronics-9-liquidation-wholesale-pallet-overstock-mixed-electronics-9-liquidation-wholesale-pallet-liquidationdeals-ca-1253592855.jpg?v=1786142711",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "SIHOO XJJ679 carton",
        "marker": [
          54,
          55
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "SIHOO branding and XJJ679 are visible on the top carton. The product configuration needs confirmation.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Assorted sealed cartons",
        "marker": [
          50,
          52
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The remaining cartons show partial diagrams and shipping labels without a reliably readable product name.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-sauna-blankets-7-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Grow Bags #7 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Grow Bags #7 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9622212509951",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-grow-bags-7-liquidation-wholesale-pallet-overstock-grow-bags-7-liquidation-wholesale-pallet-liquidationdeals-ca-1253585568.jpg?v=1786134791",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-grow-bags-7-liquidation-wholesale-pallet-overstock-grow-bags-7-liquidation-wholesale-pallet-liquidationdeals-ca-1253585568.jpg?v=1786134791",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-grow-bags-7-liquidation-wholesale-pallet-overstock-grow-bags-7-liquidation-wholesale-pallet-liquidationdeals-ca-1253585562.jpg?v=1786134760",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-grow-bags-7-liquidation-wholesale-pallet-overstock-grow-bags-7-liquidation-wholesale-pallet-liquidationdeals-ca-1253585547.jpg?v=1786134732",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-grow-bags-7-liquidation-wholesale-pallet-overstock-grow-bags-7-liquidation-wholesale-pallet-liquidationdeals-ca-1253585556.jpg?v=1786134697",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Lumo-X premium fabric grow bags",
        "marker": [
          51,
          44
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The retail insert in photo 2 says Lumo-X Premium Fabric Grow Bags. Bag capacity and pack count are obscured.",
        "quantityLabel": "Multiple packs shown",
        "price": 17.98,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Farm Plastic Supply 5-gallon fabric grow bags, 10-pack",
        "comparisonNote": "Capacity and pack size of the photographed Lumo-X bags are not readable.",
        "priceUnit": "one 10-bag pack",
        "source": "Farm Plastic Supply US",
        "url": "https://farmplasticsupply.com/5-gallon-grow-bag",
        "referenceKey": "grow_bags",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Grass Stopper weed-control discs",
        "marker": [
          48,
          46
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows the Grass Stopper name and a 5-piece pack label.",
        "quantityLabel": "5-piece packs indicated",
        "price": 13.98,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Weed-control cloth rings, 5-inch diameter, 12-pack",
        "comparisonNote": "The photographed Grass Stopper pack contains 5 larger pieces. Size, material and pack count differ; this is a category comparison.",
        "priceUnit": "one 12-piece pack",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/Control-Anti-Grass-Cloth-Weed-Mat-12Pcs-5In-Diameter-Covering-Ring/40Y5DBMQ9OC5",
        "referenceKey": "weed_discs",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-gloves-6-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Sauna Blankets #6 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Sauna Blankets #6 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9622210543871",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-sauna-blankets-6-liquidation-wholesale-pallet-overstock-sauna-blankets-6-liquidation-wholesale-pallet-liquidationdeals-ca-1253585559.jpg?v=1786134877",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-sauna-blankets-6-liquidation-wholesale-pallet-overstock-sauna-blankets-6-liquidation-wholesale-pallet-liquidationdeals-ca-1253585559.jpg?v=1786134877",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-sauna-blankets-6-liquidation-wholesale-pallet-overstock-sauna-blankets-6-liquidation-wholesale-pallet-liquidationdeals-ca-1253585566.jpg?v=1786134849",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-sauna-blankets-6-liquidation-wholesale-pallet-overstock-sauna-blankets-6-liquidation-wholesale-pallet-liquidationdeals-ca-1253585564.jpg?v=1786134818",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Purple sauna blanket",
        "marker": [
          52,
          43
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "A purple zip-up sauna blanket with a reflective lining is visible on top. Brand, power rating and included controller are not shown.",
        "quantityLabel": "1 unboxed blanket shown",
        "price": 261.89,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEVOR 75 × 35-inch infrared sauna blanket",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VEVOR-Sauna-Blanket-for-Detoxification-1-to-6-Level-Temp-1-Person-Indoor-Fabric-Frame-Infrared-Sauna-75-in-x-35-in-Sauna-Bag-HWSNTNJB3575UT4UDV1/329151998",
        "referenceKey": "sauna_blanket",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Matching sealed cartons",
        "marker": [
          52,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The cartons below show shipping dimensions but no readable product labels. Their contents and unit count are not established.",
        "quantityLabel": "Multiple cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "overstock-gloves-3-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Pillow Cases #3 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Pillow Cases #3 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9622101491967",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-pillow-cases-3-liquidation-wholesale-pallet-overstock-pillow-cases-3-liquidation-wholesale-pallet-liquidationdeals-ca-1253585551.jpg?v=1786135238",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-pillow-cases-3-liquidation-wholesale-pallet-overstock-pillow-cases-3-liquidation-wholesale-pallet-liquidationdeals-ca-1253585551.jpg?v=1786135238",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-pillow-cases-3-liquidation-wholesale-pallet-overstock-pillow-cases-3-liquidation-wholesale-pallet-liquidationdeals-ca-1253585553.jpg?v=1786135210",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-pillow-cases-3-liquidation-wholesale-pallet-overstock-pillow-cases-3-liquidation-wholesale-pallet-liquidationdeals-ca-1253585550.jpg?v=1786135178",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-pillow-cases-3-liquidation-wholesale-pallet-overstock-pillow-cases-3-liquidation-wholesale-pallet-liquidationdeals-ca-1253585552.jpg?v=1786135150",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "Orange textured cushion covers",
        "marker": [
          53,
          48
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 shows orange covers with raised leaf-like motifs. The box label says Kevin Textile, rust, 30 × 50 cm, 2 pieces; design text is truncated.",
        "quantityLabel": "2-piece packs indicated",
        "price": 15.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "suxuMhao 18 × 18-inch orange-red cushion covers, two-pack",
        "comparisonNote": "Comparison covers have a different fabric/texture; pictured dimensions and pack quantity are not confirmed.",
        "priceUnit": "one two-cover pack",
        "source": "Walmart Canada marketplace",
        "url": "https://www.walmart.ca/en/ip/suxuMhao-Decorative-Pillow-Covers-2-Pack-18-18in-Light-Orange-Red-Square-Cushion-Covers-Soft-Throw-Couch-Decorative-Pillows-Suitable-Living-Room-Bedr/27P4X5QWQH0C",
        "referenceKey": "cushion_covers",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "overstock-infant-socks-1-liquidation-wholesale-pallet-copy": {
    "title": "Overstock Infant Socks #1 | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Infant Socks #1 | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9622085501183",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585579.jpg?v=1786135478",
    "photoWidth": 1152,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585579.jpg?v=1786135478",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585578.jpg?v=1786135450",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585577.jpg?v=1786135420",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585576.jpg?v=1786135393",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-infant-socks-1-liquidation-wholesale-pallet-overstock-infant-socks-1-liquidation-wholesale-pallet-liquidationdeals-ca-1253585575.jpg?v=1786135357",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "George infant cotton-blend tights packs",
        "marker": [
          49,
          51
        ],
        "photoIndex": 4,
        "position": "Photo 4 · middle centre",
        "note": "Photo 4 shows George infant cotton-blend tights, 3–12 months, with cream and pink garments. The shipping label indicates 2-pair packs.",
        "quantityLabel": "2-pair retail packs shown",
        "price": 10,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "George baby girls' cotton-blend tights, 2-pack",
        "comparisonNote": "Pack size, fabric and age/colour variant may differ; the retailer shows some sizes out of stock.",
        "priceUnit": "one 2-pair pack",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/George-Baby-Girls-Cotton-Blend-Tights-2-Pack/6000206461487",
        "referenceKey": "infant_tights",
        "priceReviewedAt": "2026-09-06"
      }
    ]
  },
  "high-count-fc-01-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #01 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-01-wholesale-liquidation-pallet-high-count-fc-01-wholesale-liquidation-pallet-liquidationdeals-ca-1253144487.jpg?v=1785976598",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed gaylord; individual items not visible",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "highcount-lpn-pallet-30-liquidation-pallet-wholesale-copy": {
    "title": "Highcount LPN Pallet #30 — FREE SHIPPING ELIGIBLE — Liquidation Pallet Wholesale",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/highcount-lpn-pallet-30-liquidation-pallet-wholesale-highcount-lpn-pallet-30-liquidation-pallet-wholesale-liquidationdeals-ca-1249110924.jpg?v=1784061519",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Closed gaylord; individual items not visible",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-66-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #66 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-66-wholesale-liquidation-pallet-high-count-fc-66-wholesale-liquidation-pallet-liquidationdeals-ca-1244089495.jpg?v=1781303498",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Packaged textiles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-63-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #63 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-63-wholesale-liquidation-pallet-high-count-fc-63-wholesale-liquidation-pallet-liquidationdeals-ca-1244089501.jpg?v=1781303677",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Packaged textiles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-61-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #61 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-61-wholesale-liquidation-pallet-high-count-fc-61-wholesale-liquidation-pallet-liquidationdeals-ca-1244089505.jpg?v=1781303797",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Packaged textiles",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Assorted small cartons",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-26-900pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #26- 300pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-26-300pcs-liquidation-wholesale-pallet-miscellaneous-clothing-26-300pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243970491.jpg?v=1781202636",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Denim jeans",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Graphic T-shirts",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Striped tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-25-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #25- 900pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-25-900pcs-liquidation-wholesale-pallet-miscellaneous-clothing-25-900pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243970493.jpg?v=1781202697",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Graphic T-shirts",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-24-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #24- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-24-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-24-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800639.jpg?v=1781195439",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Striped tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded light-coloured garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded trousers",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #23- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800640.jpg?v=1781195499",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Printed tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded dark garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-22-400pcs-liquidation-wholesale-pallet-copy": {
    "title": "Miscellaneous Clothing #22- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-22-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-22-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800635.jpg?v=1781116240",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Printed and striped tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded garments",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "miscellaneous-clothing-23-400pcs-liquidation-wholesale-pallet": {
    "title": "Miscellaneous Clothing #21- 400pcs | Liquidation Wholesale Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/miscellaneous-clothing-21-400pcs-liquidation-wholesale-pallet-miscellaneous-clothing-21-400pcs-liquidation-wholesale-pallet-liquidationdeals-ca-1243800637.jpg?v=1781116297",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Graphic T-shirts",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      },
      {
        "label": "Folded tops",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "high-count-fc-39-wholesale-liquidation-pallet-copy": {
    "title": "High Count FC - #40 — FREE SHIPPING ELIGIBLE — Wholesale Liquidation Pallet",
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/high-count-fc-40-wholesale-liquidation-pallet-high-count-fc-40-wholesale-liquidation-pallet-liquidationdeals-ca-1238248569.jpg?v=1778697335",
    "reviewedAt": "2026-09-06",
    "items": [
      {
        "label": "Wrapped soft goods at the top of the gaylord",
        "price": null,
        "note": "Exact model, quantity and individual retail price unverified."
      }
    ]
  },
  "overstock-christmas-tree-pallet-liquidation-wholesale-pallet": {
    "title": "Overstock Christmas Tree Pallet | Liquidation Wholesale Pallet",
    "shortTitle": "Overstock Christmas Tree Pallet | Liquidation Wholesale Pallet",
    "productId": "gid://shopify/Product/9297336238335",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "overstock"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-christmas-tree-pallet-liquidation-wholesale-pallet-overstock-christmas-tree-pallet-liquidation-wholesale-pallet-liquidationdeals-ca-1210916311.jpg?v=1765478089",
    "photoWidth": 1536,
    "photoHeight": 2048,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-christmas-tree-pallet-liquidation-wholesale-pallet-overstock-christmas-tree-pallet-liquidation-wholesale-pallet-liquidationdeals-ca-1210916311.jpg?v=1765478089",
        "width": 1536,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-christmas-tree-pallet-liquidation-wholesale-pallet-overstock-christmas-tree-pallet-liquidation-wholesale-pallet-liquidationdeals-ca-1210916310.jpg?v=1765478102",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-christmas-tree-pallet-liquidation-wholesale-pallet-overstock-christmas-tree-pallet-liquidation-wholesale-pallet-liquidationdeals-ca-1210916309.jpg?v=1765478098",
        "width": 1152,
        "height": 2048
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/overstock-christmas-tree-pallet-liquidation-wholesale-pallet-overstock-christmas-tree-pallet-liquidation-wholesale-pallet-liquidationdeals-ca-1210916308.jpg?v=1765478104",
        "width": 1152,
        "height": 2048
      }
    ],
    "items": [
      {
        "label": "6.5-foot pre-lit flocked Frisco pine carton",
        "marker": [
          44,
          12
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The height, Frisco pine name and pre-lit flocked description are readable.",
        "price": 149,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "VEIKOUS 6.5-foot flocked pre-lit tree with multicolour lights",
        "comparisonNote": "Different tree brand and light specification.",
        "priceUnit": "one 6.5-foot tree",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/VEIKOUS-6-5-ft-Pre-Lit-LED-Flocked-Artificial-Christmas-Tree-with-Multi-Color-Light-HP1001-22/320425976",
        "referenceKey": "christmas_tree_flocked",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "7-foot pre-lit Duncan fir carton",
        "marker": [
          55,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The carton says 7-foot Duncan fir with colour-changing lights.",
        "price": 314.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "National Tree Company 7-foot Dunhill Fir pre-lit tree, clear lights",
        "comparisonNote": "Different tree model; branch shape, light count and footprint differ.",
        "priceUnit": "one 7-foot tree",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/National-Tree-Company-7-ft-Dunhill-Fir-Artificial-Christmas-Tree-with-Clear-Lights-DUH-70LO/207183155",
        "referenceKey": "christmas_tree_7",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Member's Mark 9-foot Augusta pine carton",
        "marker": [
          45,
          35
        ],
        "photoIndex": 3,
        "position": "Photo 3 · middle centre",
        "note": "Photo 3 shows Member's Mark, 9 Ft Pre-Lit Augusta Pine Tree and LED lighting.",
        "quantityLabel": "1 carton shown",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Rockford super-slim pine carton",
        "marker": [
          38,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Rockford Super Slim Pine Tree is visible; the height is partly obscured.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "7.5-foot Liberty cashmere pine carton",
        "marker": [
          59,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The carton says 7.5-foot pre-lit Liberty Cashmere Pine with colour-changing lights.",
        "price": 229,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Best Choice Products 7.5-foot flocked pre-lit pine with 550 clear lights",
        "comparisonNote": "Different brand, foliage and light specification; reference is a flocked tree.",
        "priceUnit": "one 7.5-foot tree",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Best-Choice-Products-7-5-ft-Flocked-Pre-Lit-Pine-Artificial-Christmas-Tree-with-550-Incandescent-Warm-White-Clear-Lights-Pine-Cones-Berry-SKY5881/315170756",
        "referenceKey": "christmas_tree_75",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "7.5-foot Stamford pine carton",
        "marker": [
          52,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The bottom carton says 7.5-foot pre-lit Stamford pine.",
        "price": 229,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Best Choice Products 7.5-foot flocked pre-lit pine with 550 clear lights",
        "comparisonNote": "Different brand, foliage and light specification; reference is a flocked tree.",
        "priceUnit": "one 7.5-foot tree",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Best-Choice-Products-7-5-ft-Flocked-Pre-Lit-Pine-Artificial-Christmas-Tree-with-550-Incandescent-Warm-White-Clear-Lights-Pine-Cones-Berry-SKY5881/315170756",
        "referenceKey": "christmas_tree_75",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Lionel Polar Express train-set carton",
        "marker": [
          50,
          46
        ],
        "photoIndex": 2,
        "position": "Photo 2 · middle centre",
        "note": "The Polar Express and Lionel branding are visible. The precise set and scale are not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Holiday Time pre-lit tree carton",
        "marker": [
          39,
          80
        ],
        "photoIndex": 2,
        "position": "Photo 2 · bottom centre",
        "note": "A green-and-white artificial-tree package is visible; the exact model is unclear.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "bulk-electronics-195": {
    "title": "Bulk Electronics #194 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #194",
    "productId": "gid://shopify/Product/9662352163071",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-06",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-194-free-shipping-eligible-bulk-electronics-194-free-shipping-eligible-liquidationdeals-ca-1256833063.jpg?v=1788380953",
    "photoWidth": 1080,
    "photoHeight": 1440,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-194-free-shipping-eligible-bulk-electronics-194-free-shipping-eligible-liquidationdeals-ca-1256833063.jpg?v=1788380953",
        "width": 1080,
        "height": 1440
      }
    ],
    "items": [
      {
        "label": "Senville oscillating tower fan",
        "marker": [
          79,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Senville and 36/42-inch oscillating tower-fan packaging are visible; confirm which size is inside.",
        "price": 89.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Senville SENTF-19JRA 42-inch oscillating tower fan",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Senville Canada",
        "url": "https://senville.ca/42-oscillating-tower-fan-3-speed-remote-control-sentf-19jra/",
        "referenceKey": "senville_fan",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "TVD SW608-A steam cleaner",
        "marker": [
          68,
          33
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "STEAM CLEANER and SW608-A are printed.",
        "price": 249.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Kärcher SC3 multi-purpose canister steam cleaner, white",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Amazon Canada",
        "url": "https://www.amazon.ca/K%C3%A4rcher-Cleaner-Attachments-Purpose-Steamer/dp/B0CNBK7BQL",
        "referenceKey": "karcher_sc3",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "MaxLander electric tiller",
        "marker": [
          34,
          58
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "MaxLander Electric Tiller is printed; width and motor rating are unclear.",
        "price": 149.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe TJ604E 13.5A 16-inch electric tiller/cultivator",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-13-5-Amp-16-in-Electric-Tiller-Cultivator-with-5-5-in-Wheels-TJ604E/206429581",
        "referenceKey": "electric_tiller",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Electric pressure washer",
        "marker": [
          29,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Pressure Washer and a wheeled washer are pictured; the exact model is unclear.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000, 2030 max PSI, 1.2 GPM electric pressure washer",
        "comparisonNote": "Pressure, flow and accessory set differ or are unreadable on the photographed carton.",
        "priceUnit": "one product",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "Retractable hose reel",
        "marker": [
          37,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Retractable Hose Reel and several possible NW-series model choices are printed; selected model is unclear.",
        "price": 143.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Giraffe Tools 1/2-inch × 100-foot retractable garden hose reel",
        "comparisonNote": "Retailer labels this comparison as pre-order. Hose length, diameter and mounting hardware may differ.",
        "priceUnit": "one product",
        "source": "Giraffe Tools US",
        "url": "https://giraffetools.com/products/retractable-garden-hose-reel-1-2in-100ft",
        "referenceKey": "retractable_hose",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "AKICON exhaust fan with LED light",
        "marker": [
          63,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "AKICON Exhaust Fan with LED Light is printed; model/airflow rating is not readable.",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric-heater carton marked EF28B",
        "marker": [
          64,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "EF28B, black colour, 1500W heating power and 120V are printed; exact heater style needs confirmation.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Countertop cooking-appliance carton",
        "marker": [
          29,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "A countertop cooking appliance and food are pictured; exact brand/model and capacity are not established.",
        "price": 79.97,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Hamilton Beach Sure-Crisp 31403JC air-fryer toaster oven",
        "comparisonNote": "Check the pictured carton against this comparison for model, size and included accessories.",
        "priceUnit": "one product",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/hamilton-beach-sure-crisp-air-fryer-toaster-oven-31403c-stainless-steel/6000202678916",
        "referenceKey": "air_fryer_oven",
        "priceReviewedAt": "2026-09-06"
      },
      {
        "label": "SPNOD-branded cartons",
        "marker": [
          63,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Branding is visible on two white cartons; the product names are not shown.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-electronics-01-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #01 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #01 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668138828031",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-01-watermarked.png?v=1788895828",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-01-watermarked.png?v=1788895828",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "BLACK+DECKER rice cooker / steamer",
        "marker": [
          51,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "BLACK+DECKER branding and a rice cooker are pictured. Capacity and model are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Wallbox EV charger carton",
        "marker": [
          81,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Wallbox branding and Smart EV Charger printing are visible. Amperage, connector and exact model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DEKO airless paint sprayer",
        "marker": [
          20,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "DEKO and DKPAPSX300C1 are printed beside the sprayer illustration. Contents and accessories are not visible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ninja pods-and-grounds coffee maker",
        "marker": [
          22,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The upside-down carton shows Ninja branding and Pods & Grounds wording. The precise model and bundle are obscured.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "KEENRAY towel warmer",
        "marker": [
          23,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "KEENRAY and CL1 Plus / Comfort Life wording appear on the tall carton. Capacity and included accessories need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Dyson stick-vacuum carton",
        "marker": [
          49,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Dyson branding and a stick-vacuum illustration are visible. The series/model label is not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "AURAKICH bottle washer",
        "marker": [
          78,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "AURAKICH, Bottle Washer and 8L are printed on the box. The carton illustration is not proof of contents.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Laresar L6 Pro robot vacuum",
        "marker": [
          76,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Laresar L6 Pro printing and a robot with a docking station are visible.",
        "quantityLabel": "1 carton",
        "price": 399.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Dreame D20 Plus robot vacuum with auto-empty base, white",
        "comparisonNote": "Different-brand/model comparison for the Laresar L6 Pro. Navigation, cleaning features, base station and included consumables may differ.",
        "priceUnit": "one robot and auto-empty base system",
        "source": "Dreame Canada",
        "url": "https://ca.dreametech.com/products/d20-plus-robot-vacuum",
        "referenceKey": "robot_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Eureka RapidWash wet/dry floor cleaner",
        "marker": [
          24,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Eureka RapidWash and a wet/dry upright floor-cleaner image are visible. The model suffix is too small to confirm.",
        "quantityLabel": "1 carton",
        "price": 299,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Tineco FLOOR ONE STRETCH S6 wet/dry vacuum, FW420100US",
        "comparisonNote": "Different-brand/model comparison for the Eureka RapidWash carton. Cleaning features, accessories and battery specifications differ. US dollars.",
        "priceUnit": "one wet/dry floor-cleaning vacuum",
        "source": "Tineco US",
        "url": "https://store.tineco.com/products/tineco-floor-one-stretch-s6-wet-dry-vacuum-cleaner",
        "referenceKey": "wetdry_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Electric tiller carton",
        "marker": [
          49,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "The carton depicts a wheeled electric tiller/cultivator. Brand, working width and power rating are not reliably legible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Self-cleaning cat litter-box carton",
        "marker": [
          74,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "A rounded automatic litter box is illustrated with Self-Cleaning Cat Litter Box wording. Brand, capacity and model are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-02-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #02 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #02 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668138893567",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-02-watermarked.png?v=1788895754",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-02-watermarked.png?v=1788895754",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Dyson stick-vacuum carton",
        "marker": [
          11,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "The tall left carton shows Dyson branding and a stick vacuum. Exact series and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Pyle PDWR40B outdoor speaker carton",
        "marker": [
          63,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Pyle, PDWR40B and Outdoor Waterproof Speakers are visible. Confirm the speaker count inside; a printed pair is not an inventory count.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BELLA three-tier food steamer",
        "marker": [
          88,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "BELLA branding and a three-tier food steamer are pictured. Exact model and capacity are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "7500W hardwired electric heater carton",
        "marker": [
          34,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Hardwired Electric Heater and 7500W are printed on the large carton. Brand/model, wiring requirements and contents require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Nespresso Vertuo Next coffee machine",
        "marker": [
          63,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Vertuo Next and DeLonghi branding are visible. Colour and any milk-frother bundle are not established.",
        "quantityLabel": "1 carton",
        "price": 229,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Next by DeLonghi ENV120GY, dark grey",
        "comparisonNote": "Same Vertuo Next family; colour, suffix and bundle may differ. This price excludes an Aeroccino milk frother.",
        "priceUnit": "one capsule coffee machine, without milk frother",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/capsules-coffee-machines/nespresso-machines",
        "referenceKey": "vertuo_next_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Air purifier carton",
        "marker": [
          87,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Air-purifier/filter information is printed on the right-hand carton. The exact brand and model are not reliably legible.",
        "quantityLabel": "1 carton",
        "price": 74.96,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Levoit Core 200S-P smart air purifier, HEAPAPLVSUS0165Y",
        "comparisonNote": "Different-brand/model comparison only. The compact Core 200S-P is not an equivalent-size or equivalent-capacity substitute for larger Shark/Blueair units; filter life and room coverage differ. US dollars.",
        "priceUnit": "one air purifier",
        "source": "Levoit US",
        "url": "https://levoit.com/products/core-200s-p-smart-air-purifier",
        "referenceKey": "air_purifier_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "DeLonghi Dedica Duo espresso machine",
        "marker": [
          58,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "DeLonghi and Dedica Duo are readable beside the espresso-machine image. Confirm the model suffix.",
        "quantityLabel": "1 carton",
        "price": 349.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "DeLonghi Dedica Duo EC890M espresso machine, stainless steel",
        "comparisonNote": "Same Dedica Duo family; verify the carton model suffix, colour and included accessories.",
        "priceUnit": "one espresso machine",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/manual-espresso-machines",
        "referenceKey": "dedica_duo_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Shark StainStriker portable cleaner",
        "marker": [
          80,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Shark StainStriker branding and a hose-equipped portable spot cleaner are pictured. Exact model and accessory set are unclear.",
        "quantityLabel": "1 carton",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "BISSELL Little Green ProHeat Deluxe 25137 exclusive bundle",
        "comparisonNote": "Category comparison, not an exact model match. Model 25137 differs from Max Pet, CleanSlate and StainStriker; included tools/formula and brand may differ.",
        "priceUnit": "one portable cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "spot_cleaner_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Narwal Freo Pro robot vacuum and mop",
        "marker": [
          30,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Narwal Freo Pro branding and the robot/base station are pictured. Sealed packaging does not establish completeness.",
        "quantityLabel": "1 carton",
        "price": 999.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Narwal Freo Pro robot vacuum and mop with base station",
        "comparisonNote": "Freo Pro name matches the carton. Actual robot, station and included consumables inside the packaging are not verified.",
        "priceUnit": "one robot and base-station system",
        "source": "Narwal Canada",
        "url": "https://ca.narwal.com/products/narwal-freo-pro-robot-vacuum-mop",
        "referenceKey": "narwal_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Blueair Blue Signature air purifier",
        "marker": [
          64,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Blueair Blue Signature is printed on the tall carton. Exact colour/model suffix and filters inside are not visible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Pittman rear-seat truck air mattress",
        "marker": [
          59,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Pittman branding and a mattress across a pickup's rear seat are pictured. Vehicle fit and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Amazon Fire TV soundbar carton",
        "marker": [
          89,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Fire TV Soundbar is visible on the slim right-hand carton. Generation, speaker dimensions and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-03-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #03 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #03 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668139188479",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-03-liquidation-pallet-wholesale-medium-electronics-03-liquidation-pallet-wholesale-liquidationdeals-ca-1257520996.png?v=1788900098",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-03-liquidation-pallet-wholesale-medium-electronics-03-liquidation-pallet-wholesale-liquidationdeals-ca-1257520996.png?v=1788900098",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Cuisinart ice-cream maker carton",
        "marker": [
          12,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Cuisinart branding and an ice-cream maker image are visible. Capacity and exact model are obscured.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ultimate S20A soundbar",
        "marker": [
          54,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Ultimate Soundbar, S20A and 40W are printed on the long carton. Connections and accessories inside are not visible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Nespresso Vertuo Next coffee machine",
        "marker": [
          22,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Vertuo Next branding is readable on the coffee-machine carton. Colour and bundle require confirmation.",
        "quantityLabel": "1 carton",
        "price": 229,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Next by DeLonghi ENV120GY, dark grey",
        "comparisonNote": "Same Vertuo Next family; colour, suffix and bundle may differ. This price excludes an Aeroccino milk frother.",
        "priceUnit": "one capsule coffee machine, without milk frother",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/capsules-coffee-machines/nespresso-machines",
        "referenceKey": "vertuo_next_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Champion ParaLINK parallel kit",
        "marker": [
          56,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Champion and ParaLINK Parallel Kit wording are visible. This is packaging for a generator-linking accessory, not evidence of a generator.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BLACK+DECKER four-slice toaster",
        "marker": [
          55,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "BLACK+DECKER branding and 4 Slice Toaster wording are visible. Exact model and finish require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Logitech Z625 speaker system",
        "marker": [
          83,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Logitech Z625, 2.1 speaker-system imagery and 400W peak wording are visible. Printed peak power is not continuous output.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric pressure washer carton",
        "marker": [
          28,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "A pressure washer with hose and spray lance is illustrated. Brand, model and pressure rating are not clear.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Intex Dura-Beam queen air mattress",
        "marker": [
          56,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Intex Dura-Beam and 10-inch queen wording are visible. Pump inclusion and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Pittman rear-seat truck air mattress",
        "marker": [
          82,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Pittman branding and a rear-seat truck mattress are pictured. Vehicle fit and included pump are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Greenworks 16-inch corded lawn mower",
        "marker": [
          23,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Greenworks, 16-inch and 10A are printed beside the mower picture. Confirm the exact model and accessories.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Tineco FLOOR ONE STRETCH S6",
        "marker": [
          49,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Tineco FLOOR ONE and STRETCH S6 series wording are visible on the tall carton. Regional suffix and accessories are not readable.",
        "quantityLabel": "1 carton",
        "price": 299,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Tineco FLOOR ONE STRETCH S6 wet/dry vacuum, FW420100US",
        "comparisonNote": "STRETCH S6 family comparison; confirm the carton suffix, regional version and accessories. The comparison is the US model, priced in US dollars.",
        "priceUnit": "one wet/dry vacuum",
        "source": "Tineco US",
        "url": "https://store.tineco.com/products/tineco-floor-one-stretch-s6-wet-dry-vacuum-cleaner",
        "referenceKey": "tineco_s6_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Davivy automatic bread maker",
        "marker": [
          76,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Davivy, BM8906 and 3.3LB are printed beside the bread-maker image. Contents and accessories are not inspected.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "5.3-quart deep fryer carton",
        "marker": [
          77,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Deep Fryer, 5.3QT and TSAF400D are printed on the lower carton. Brand lettering is not clear enough to confirm.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-04-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #04 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #04 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668157473023",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-04-liquidation-pallet-wholesale-medium-electronics-04-liquidation-pallet-wholesale-liquidationdeals-ca-1257521021.png?v=1788900071",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-04-liquidation-pallet-wholesale-medium-electronics-04-liquidation-pallet-wholesale-liquidationdeals-ca-1257521021.png?v=1788900071",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Pittman rear-seat truck air mattress",
        "marker": [
          31,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Pittman branding and a full-size truck rear-seat mattress are pictured. Confirm vehicle compatibility and pump inclusion.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "ThermoMate tankless water heater",
        "marker": [
          79,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "ThermoMate Tankless Water Heater wording is visible. Electrical rating and exact model are too small/obscured to verify.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Intex Dura-Beam air-mattress cartons",
        "marker": [
          37,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Two separate Intex Dura-Beam cartons are visible side by side. A 10-inch queen label is readable on one; do not assume both are the same size or contain complete mattresses.",
        "quantityLabel": "2 visible cartons",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DY003 drywall sander carton",
        "marker": [
          34,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Drywall Sander and DY003 are printed on the carton. Exact brand, motor rating and dust-collection accessories need confirmation.",
        "quantityLabel": "1 carton",
        "price": 139.9,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "VEVOR 850W folding electric drywall sander with LED light and vacuum bag",
        "comparisonNote": "Different-brand/model comparison for the DY003 carton. The retailer's current title states 850W despite the older URL text; motor and kit contents may differ.",
        "priceUnit": "one sander kit",
        "source": "VEVOR Canada",
        "url": "https://www.vevor.ca/electric-drywall-sander-c_11011/vevor-drywall-sander-electric-foldable-sander-750w-with-led-light-and-vacuum-bag-p_010906349725",
        "referenceKey": "drywall_sander_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "CRAFTSMAN V20 drill kit carton",
        "marker": [
          72,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "CRAFTSMAN V20 and Brushless wording appear with a drill picture. Battery count/capacity and exact kit number are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Intex C330 filter pump",
        "marker": [
          89,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Intex and C330 are visible with a cartridge-filter pump illustration. Hoses and cartridges inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Bonsaii C233-BUS shredder",
        "marker": [
          31,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Bonsaii C233-BUS and auto/manual-feed micro-cut shredder information are printed. Sheet capacity and contents require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "TALOSBO C1 robotic pool cleaner",
        "marker": [
          69,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "TALOSBO C1 and a pool-cleaning robot are pictured. This is not a household floor vacuum.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "A-Premium turbocharger carton",
        "marker": [
          91,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A-Premium branding and Turbocharger wording are visible. No reliable vehicle/application or part number can be read.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Waykar dehumidifier carton",
        "marker": [
          65,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Waykar branding and JD025CE120 are visible on the large carton. Capacity and actual contents need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DEKO electric pressure washer",
        "marker": [
          34,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "DEKO and DKEHPW180C1 are printed with an electric pressure-washer image.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Ryobi ONE+ 18V fogger",
        "marker": [
          72,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Ryobi ONE+ 18V and a handheld fogger are pictured. Battery/charger inclusion and exact kit number are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Artika LED ceiling-light carton",
        "marker": [
          92,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Artika branding and LED ceiling-light information are visible on the tall right carton. Fixture size and model are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-05-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #05 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #05 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668164288767",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-05-watermarked.png?v=1788895855",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-05-watermarked.png?v=1788895855",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Shark Steam & Scrub mop",
        "marker": [
          36,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Shark Steam & Scrub branding and a twin-pad steam mop are pictured. Exact model and pad/accessory set are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ninja Crispi cooking system",
        "marker": [
          85,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Ninja Crispi branding and glass cooking containers are pictured. Container sizes, colour and bundle are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric pressure washer carton",
        "marker": [
          26,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "An electric pressure washer and spray lance are pictured. Brand lettering and performance ratings are not sufficiently clear.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "SMEG four-slice toaster",
        "marker": [
          60,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "SMEG branding and a four-slot toaster with two control sets are pictured. Exact model and colour need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DOMEM digital air fryer",
        "marker": [
          84,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "DOMEM Digital Air Fryer and RA461D are printed on the tall carton. Capacity is not reliably legible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DeLonghi TrueBrew coffee maker",
        "marker": [
          29,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "DeLonghi TrueBrew and Bean Extract Technology are visible; a thermal carafe is pictured. Exact model suffix is not legible.",
        "quantityLabel": "1 carton",
        "price": 699.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "DeLonghi TrueBrew CAM51035M with thermal carafe",
        "comparisonNote": "Thermal-carafe version selected to match the pictured format. Confirm CAM51035M and the actual accessories on the carton; contents are not verified.",
        "priceUnit": "one coffee maker with thermal carafe",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/drip-coffee-makers",
        "referenceKey": "truebrew_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "BUYDEEM DT640 four-slice toaster",
        "marker": [
          59,
          52
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "BUYDEEM DT640 and a four-slice toaster are pictured. Colour and included parts require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Kärcher K2 pressure washer",
        "marker": [
          82,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Kärcher and K2 are visible. The exact K2 edition and accessory package are obscured.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "CUCKOO CR-0675F rice cooker",
        "marker": [
          58,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "CUCKOO and CR-0675F are visible on the carton. Confirm colour suffix and accessories.",
        "quantityLabel": "1 carton",
        "price": 139.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "CUCKOO CR-0675F Micom rice cooker, 6 cups uncooked / 12 cups cooked, grey",
        "comparisonNote": "Same-brand family comparison; confirm the model suffix, colour and uncooked capacity on the carton. US dollars.",
        "priceUnit": "one 6-cup-uncooked rice cooker",
        "source": "CUCKOO America",
        "url": "https://cuckooamerica.com/products/cr-0675f",
        "referenceKey": "cuckoo_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "AUTOOL programming power supply",
        "marker": [
          27,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "AUTOOL and Inverter Programming Power Supply / EM355 are printed. This is not evidence of a generator or household battery.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "ThermoMate 6.5-gallon mini-tank water heater",
        "marker": [
          29,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "ThermoMate and 6.5-gallon mini-tank water-heater wording are visible. Exact model/electrical label needs confirmation.",
        "quantityLabel": "1 carton",
        "price": 239.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "ThermoMate ES700 6.5-gallon 120V mini-tank water heater",
        "comparisonNote": "Same-brand and capacity comparison. Confirm ES700, voltage and connection details; this is a tank model, not a tankless heater. US dollars.",
        "priceUnit": "one 6.5-gallon water heater",
        "source": "ThermoMate US",
        "url": "https://thermomate.com/products/es700-tank-electric-water-heater",
        "referenceKey": "thermomate_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "AIRMSEN stand-mixer carton",
        "marker": [
          59,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "AIRMSEN branding and a bowl/stand mixer with mixing attachments are pictured. Bowl capacity and model are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Range-hood carton",
        "marker": [
          79,
          84
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Range Hood is printed on the lower-right box. Width, ventilation type and full model number are not legible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-06-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #06 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #06 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668164387071",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-06-liquidation-pallet-wholesale-medium-electronics-06-liquidation-pallet-wholesale-liquidationdeals-ca-1257521020.png?v=1788900010",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-06-liquidation-pallet-wholesale-medium-electronics-06-liquidation-pallet-wholesale-liquidationdeals-ca-1257521020.png?v=1788900010",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "BOSS Audio BRT26A soundbar",
        "marker": [
          60,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "BOSS Audio BRT26A and a 26-inch ATV/UTV soundbar are printed. Mounting hardware and accessories inside are not visible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "HEPA air purifier carton",
        "marker": [
          19,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "HEPA air-purifier information and a cylindrical appliance are pictured. Exact brand and model are unclear.",
        "quantityLabel": "1 carton",
        "price": 74.96,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Levoit Core 200S-P smart air purifier, HEAPAPLVSUS0165Y",
        "comparisonNote": "Different-brand/model comparison only. The compact Core 200S-P is not an equivalent-size or equivalent-capacity substitute for larger Shark/Blueair units; filter life and room coverage differ. US dollars.",
        "priceUnit": "one air purifier",
        "source": "Levoit US",
        "url": "https://levoit.com/products/core-200s-p-smart-air-purifier",
        "referenceKey": "air_purifier_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Pyle PLMR82 marine speakers",
        "marker": [
          21,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Pyle PLMR82 and 8-inch marine-speaker information are visible. Confirm the number of speakers inside and installation parts.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CUCKOO rice cooker carton",
        "marker": [
          43,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "CUCKOO branding and a rice cooker are pictured. The model and capacity are not readable from this angle.",
        "quantityLabel": "1 carton",
        "price": 139.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "CUCKOO CR-0675F Micom rice cooker, 6 cups uncooked / 12 cups cooked, grey",
        "comparisonNote": "Same-brand family comparison; confirm the model suffix, colour and uncooked capacity on the carton. US dollars.",
        "priceUnit": "one 6-cup-uncooked rice cooker",
        "source": "CUCKOO America",
        "url": "https://cuckooamerica.com/products/cr-0675f",
        "referenceKey": "cuckoo_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Shark NeverChange Air Purifier MAX",
        "marker": [
          68,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Shark NeverChange Air Purifier MAX and 140 m² coverage wording are printed. Exact model and filter contents require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "APC Back-UPS battery backup",
        "marker": [
          29,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "APC Back-UPS and 1500VA / 900W are printed. Exact model and battery condition are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "TALOSBO C1 robotic pool cleaner",
        "marker": [
          68,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "TALOSBO C1 branding and a pool robot are pictured. This is a pool cleaner, not an indoor robot vacuum.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BISSELL PowerClean TurboBrush Pet carpet cleaner",
        "marker": [
          28,
          66
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "BISSELL PowerClean TurboBrush Pet is visible on the carton. Exact model and attachments are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Safe-box carton",
        "marker": [
          69,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "SAFE BOX wording and a door/keypad illustration are visible. Brand, capacity, model and access keys are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DeLonghi drip coffee-maker carton",
        "marker": [
          30,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "DeLonghi branding and a drip coffee maker with carafe are pictured. The exact model is not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CRAFTSMAN V20 seven-tool combo kit",
        "marker": [
          68,
          84
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "CRAFTSMAN V20 and 7 Tool Combo Kit wording are visible. The photo does not verify that all seven tools, batteries or charger are inside.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-07-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #07 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #07 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668181885183",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-07-watermarked.png?v=1788895798",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-07-watermarked.png?v=1788895798",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Vibration-plate carton",
        "marker": [
          10,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Vibration Plate wording is visible on the slim left-hand carton. Brand, platform size and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Canister-vacuum carton",
        "marker": [
          60,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A canister vacuum with hose and floor head is pictured on the teal box. Brand/model labels are covered or unreadable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ultimate Ears HYPERBOOM speaker",
        "marker": [
          30,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Ultimate Ears HYPERBOOM is visible with a black speaker pictured. Colour and accessories inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Braun BrewSense coffee maker",
        "marker": [
          88,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Braun BrewSense and KF7150 are visible with a drip-coffee machine. Confirm the regional model suffix and carafe.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Auto-lifting touchscreen toaster carton",
        "marker": [
          59,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Auto-lifting and touchscreen-toaster wording are visible. The exact brand, slot count and model are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "QESOO 20V cordless tiller",
        "marker": [
          86,
          50
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "QESOO, 20V and Brushless Cordless Tiller are printed. Battery count, charger and working width are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Singer SE9180 sewing and embroidery machine",
        "marker": [
          28,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Singer SE9180 and Sewing & Embroidery are visible. The carton does not prove the machine, hoops or other accessories are complete.",
        "quantityLabel": "1 carton",
        "price": 799.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Singer SE9180 sewing and embroidery machine",
        "comparisonNote": "SE9180 model matches the visible printing. Price is for the new machine, not a pallet condition assessment; verify embroidery accessories. US dollars.",
        "priceUnit": "one sewing and embroidery machine",
        "source": "Singer US",
        "url": "https://www.singer.com/products/singer-se9180-sewing-and-embroidery-machine",
        "referenceKey": "singer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "SmartBidet bidet-seat carton",
        "marker": [
          59,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "SmartBidet and Advanced Bidet Seat wording are printed. Model, seat shape and fitting requirements are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Rowenta steamer carton",
        "marker": [
          18,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Rowenta branding and Steamer wording are visible on the small lower carton. The exact model and tank size are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Semi-automatic espresso-machine carton",
        "marker": [
          19,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Semi-Automatic Espresso Machine wording and a portafilter-style machine are pictured. Brand/model are not clear.",
        "quantityLabel": "1 carton",
        "price": 199.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "DeLonghi Classic EM450M manual espresso machine",
        "comparisonNote": "Different-brand/model category comparison for a manual espresso machine. The pictured machine's specifications and accessories are not established.",
        "priceUnit": "one espresso machine",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/manual-espresso-machines",
        "referenceKey": "espresso_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Folding foot-spa massager",
        "marker": [
          49,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "A folding foot-spa basin is pictured with Foot Spa Massager wording. Brand/model and heating functions need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "STEELITE DG934 walk-behind sweeper",
        "marker": [
          83,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "STEELITE DG934 and walk-behind hand-sweeper wording are visible. This is a push sweeper, not a powered lawn mower.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-08-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #08 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #08 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668181950719",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-08-liquidation-pallet-wholesale-medium-electronics-08-liquidation-pallet-wholesale-liquidationdeals-ca-1257521018.png?v=1788899950",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-08-liquidation-pallet-wholesale-medium-electronics-08-liquidation-pallet-wholesale-liquidationdeals-ca-1257521018.png?v=1788899950",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Nespresso Vertuo Up coffee machine",
        "marker": [
          28,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Nespresso Vertuo Up and DeLonghi are printed on the carton. Colour/model suffix and any frother bundle are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 299.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Up by DeLonghi ENV200W, white",
        "comparisonNote": "Same Vertuo Up family; verify the colour, model suffix and any frother bundle on the pictured carton.",
        "priceUnit": "one capsule coffee machine",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/capsules-coffee-machines/nespresso-machines",
        "referenceKey": "vertuo_up_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Dreame D20 Plus robot vacuum",
        "marker": [
          64,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Dreame D20 Plus is visible with a robot and base station. Actual contents and completeness are not established.",
        "quantityLabel": "1 carton",
        "price": 399.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Dreame D20 Plus robot vacuum with auto-empty base, white",
        "comparisonNote": "D20 Plus family comparison; confirm colour and regional bundle. Packaging does not prove the robot, base or accessories are inside.",
        "priceUnit": "one robot and auto-empty base system",
        "source": "Dreame Canada",
        "url": "https://ca.dreametech.com/products/d20-plus-robot-vacuum",
        "referenceKey": "dreame_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "ARC135PRO welder carton",
        "marker": [
          91,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "ARC135PRO and voltage markings are visible on the small top-right carton. Brand and complete electrical specifications are not reliably legible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "LONPOO LP-128CD micro hi-fi system",
        "marker": [
          91,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "LONPOO, LP-128CD and Micro System wording are visible. Speaker count and accessories inside are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ninja Detect BlendSense kitchen system",
        "marker": [
          29,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Ninja Detect and BlendSense are visible with a blender and food-processing vessels. Exact model and included vessel bundle need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "IRIS Woozoo pedestal fan",
        "marker": [
          65,
          58
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "IRIS Woozoo branding and an oscillating pedestal fan are pictured. Exact model, height and remote inclusion are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Air-fryer carton",
        "marker": [
          29,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "An air-fryer illustration and a small RJ38-series label are visible on the brown carton. Full model, brand and capacity cannot be confirmed from the photo.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "iRobot Roomba Plus 505 Combo",
        "marker": [
          29,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Roomba Plus 505 Combo and AutoWash dock wording are visible. Contents, accessories and colour suffix are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Portable spot-cleaner carton",
        "marker": [
          64,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Portable Spot Cleaner wording and a hose-equipped cleaner are pictured. Brand, model and accessories are not readable.",
        "quantityLabel": "1 carton",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "BISSELL Little Green ProHeat Deluxe 25137 exclusive bundle",
        "comparisonNote": "Category comparison, not an exact model match. Model 25137 differs from Max Pet, CleanSlate and StainStriker; included tools/formula and brand may differ.",
        "priceUnit": "one portable cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "spot_cleaner_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "TALOSBO air-purifier carton",
        "marker": [
          63,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "TALOSBO and Air Purifier wording are visible. The model suffix and coverage rating are not clear.",
        "quantityLabel": "1 carton",
        "price": 74.96,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Levoit Core 200S-P smart air purifier, HEAPAPLVSUS0165Y",
        "comparisonNote": "Different-brand/model comparison only. The compact Core 200S-P is not an equivalent-size or equivalent-capacity substitute for larger Shark/Blueair units; filter life and room coverage differ. US dollars.",
        "priceUnit": "one air purifier",
        "source": "Levoit US",
        "url": "https://levoit.com/products/core-200s-p-smart-air-purifier",
        "referenceKey": "air_purifier_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "3D vibration-plate carton",
        "marker": [
          91,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "3D Vibration Plate wording is printed on the tall right-hand box. Exact brand/model and platform dimensions are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-09-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #09 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #09 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668182081791",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-09-liquidation-pallet-wholesale-medium-electronics-09-liquidation-pallet-wholesale-liquidationdeals-ca-1257521016.png?v=1788899916",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-09-liquidation-pallet-wholesale-medium-electronics-09-liquidation-pallet-wholesale-liquidationdeals-ca-1257521016.png?v=1788899916",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Stick-vacuum carton",
        "marker": [
          26,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "A stick vacuum is illustrated on the upper-left box. Brand and exact model are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BISSELL branded carton",
        "marker": [
          60,
          25
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "BISSELL and A New Breed of Clean branding are visible. The product type and model are not established on the exposed face.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "WORX WG322 cordless chainsaw",
        "marker": [
          84,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "WORX, 20V, 10-inch and WG322 are printed on the carton. Battery and charger inclusion are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "AQUASTRONG swimming-pool pump",
        "marker": [
          28,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "AQUASTRONG and 1.5HP Swimming Pool Pump are printed. Voltage, fittings and exact model are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BLACK+DECKER ten-speed blender",
        "marker": [
          83,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "BLACK+DECKER and 10 Speed Blender are visible. Jar capacity and model number are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "1600W electric pressure washer",
        "marker": [
          23,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Electric Pressure Washer and 1600W are printed with a wheeled washer illustration. Brand, pressure and flow ratings are not established.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "HTVRONT automatic heat press",
        "marker": [
          61,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "HTVRONT and Auto Heat Press are printed on the lower carton. Generation, platen dimensions and bundle are not visible.",
        "quantityLabel": "1 carton",
        "price": 236,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "HTVRONT Auto Heat Press 15 × 15 inches, standard kit, white",
        "comparisonNote": "Same-brand comparison; the carton does not establish the generation, platen size, colour or bundle. Price is for the original 15 × 15-inch standard kit, not Auto Heat Press 2. US dollars.",
        "priceUnit": "one standard heat-press kit",
        "source": "HTVRONT US",
        "url": "https://www.htvront.com/products/auto-heat-press-machine-15-x-15-110v-2-colors",
        "referenceKey": "heat_press_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Infrared countertop-cooker cartons",
        "marker": [
          88,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Two distinct slim cartons show countertop hotplates and Infrared Cooker wording. Brand, burner rating and exact models are not clear.",
        "quantityLabel": "2 visible cartons",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "SIMDER MIG250 multi-process welder",
        "marker": [
          27,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "SIMDER, MIG250 and 5-in-1 welding/cutting information are visible. Torch, leads and other components inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Panasonic microwave carton",
        "marker": [
          60,
          83
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Panasonic NN-SC669SC, 1.3 cu. ft. and 1200W are visible. Condition and accessories inside cannot be assessed from the closed carton.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-10-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #10 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #10 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668185686271",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-10-liquidation-pallet-wholesale-medium-electronics-10-liquidation-pallet-wholesale-liquidationdeals-ca-1257521008.png?v=1788899889",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-10-liquidation-pallet-wholesale-medium-electronics-10-liquidation-pallet-wholesale-liquidationdeals-ca-1257521008.png?v=1788899889",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "BX204 portable folding keyboard",
        "marker": [
          32,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "BX204 and portable folding-keyboard wording are visible on the long top carton. Brand, key count and included stand are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BISSELL Little Green Max Pet",
        "marker": [
          80,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "BISSELL Little Green Max Pet and model 3860B are visible. The tool/formula bundle inside is not confirmed.",
        "quantityLabel": "1 carton",
        "price": 119.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL Little Green ProHeat Deluxe 25137 exclusive bundle",
        "comparisonNote": "Category comparison, not an exact model match. Model 25137 differs from Max Pet, CleanSlate and StainStriker; included tools/formula and brand may differ.",
        "priceUnit": "one portable cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "spot_cleaner_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Ryobi 40V HP carton",
        "marker": [
          33,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Ryobi 40V HP branding is visible, but the exposed face does not establish which tool is packaged. Do not infer a mower or battery kit.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Hoover CleanSlate Pet portable cleaner",
        "marker": [
          35,
          45
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Hoover CleanSlate Pet and a hose-equipped portable cleaner are pictured. Exact model and accessory bundle are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "BISSELL Little Green ProHeat Deluxe 25137 exclusive bundle",
        "comparisonNote": "Category comparison, not an exact model match. Model 25137 differs from Max Pet, CleanSlate and StainStriker; included tools/formula and brand may differ.",
        "priceUnit": "one portable cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "spot_cleaner_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "BLACK+DECKER four-slice toaster oven",
        "marker": [
          71,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "BLACK+DECKER Natural Convection and 4 Slice Toaster Oven are printed. Exact model and included tray/rack are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Midea Cube dehumidifier",
        "marker": [
          26,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Midea Cube and 20 pints/day are printed on the carton. Exact model suffix and drainage accessories need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Magic Bullet personal blender",
        "marker": [
          48,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Magic Bullet branding and a compact blender/cup are pictured. Model and cup/accessory count inside are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "40 oz tumbler heat-press carton",
        "marker": [
          72,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A pink tumbler press and 40 oz wording are visible. Brand/model and included heating attachments are not readable.",
        "quantityLabel": "1 carton",
        "price": 139.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "HTVRONT Auto Tumbler Heat Press 120V, standard kit, pink, 10–30 oz",
        "comparisonNote": "Different-brand/model and capacity comparison: the pictured carton says 40 oz; this comparison is a 10–30 oz automatic press. Do not assume 40 oz compatibility. US dollars.",
        "priceUnit": "one standard tumbler-press kit",
        "source": "HTVRONT US",
        "url": "https://www.htvront.com/products/auto-tumbler-heat-press-machine-1",
        "referenceKey": "tumbler_press_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Portable speaker JYH10 carton",
        "marker": [
          67,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Portable Speaker and JYH10 are printed on the lower brown carton. Brand, power rating and accessories are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "HMX-DW03 countertop dishwasher",
        "marker": [
          32,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "A countertop dishwasher is pictured with an HMX-DW03 model label. Brand lettering, capacity and water-supply setup are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Shark PowerFins cordless vacuum",
        "marker": [
          89,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Shark PowerFins and 40-minute runtime wording appear on the tall right carton. Exact model and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-general-merchandise-01-free-shipping-eligible": {
    "title": "Medium General Merchandise #01 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #01",
    "productId": "gid://shopify/Product/9668240343295",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-01-free-shipping-eligible-medium-general-merchandise-01-free-shipping-eligible-liquidationdeals-ca-1257521014.png?v=1788899856",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-01-free-shipping-eligible-medium-general-merchandise-01-free-shipping-eligible-liquidationdeals-ca-1257521014.png?v=1788899856",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "VEVOR branded carton",
        "marker": [
          49,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "The large upper carton shows VEVOR branding, but its exposed face does not identify the product. Tape and wrapping conceal other faces.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Zurn Wilkins backflow-preventer carton",
        "marker": [
          81,
          30
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Zurn Wilkins branding, a backflow-preventer illustration, 975XL-series text and a 3/4-inch size mark are visible. The exact suffix and fittings are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vileda EasyWring Power mop-system cartons",
        "marker": [
          30,
          41
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Three separate Vileda EasyWring Power microfibre spin-mop-system cartons are visible: two across the middle and one lower right. TSU 183418 is printed; the boxes do not prove three complete systems inside.",
        "quantityLabel": "3 visible cartons",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Rolling-luggage carton",
        "marker": [
          31,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "A wheeled suitcase with telescoping handle is illustrated on the tall lower-left carton. Brand, suitcase size and any set count are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CONDOMOUNTS labelled box",
        "marker": [
          74,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "CONDOMOUNTS and CLAMMAN2022 are printed on the black box. The exposed face does not establish the mount type or full kit contents.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "AeroFlex branded carton",
        "marker": [
          71,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "AeroFlex branding is visible on the bottom-right carton. The packaged product and model are not identified on the exposed face.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-02-free-shipping-eligible": {
    "title": "Medium General Merchandise #02 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #02",
    "productId": "gid://shopify/Product/9668240703743",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-02-free-shipping-eligible-medium-general-merchandise-02-free-shipping-eligible-liquidationdeals-ca-1257521013.png?v=1788899829",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-02-free-shipping-eligible-medium-general-merchandise-02-free-shipping-eligible-liquidationdeals-ca-1257521013.png?v=1788899829",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Drinking-glass set carton",
        "marker": [
          19,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Printing lists six 12-oz glasses, six 15-oz glasses, six glass straws, a straw-cleaning brush and a cup-cleaning tool. These are packaging claims, not a verified count of intact contents.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "KRIDDO KB013 balance bike",
        "marker": [
          45,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "KRIDDO, KB013 and Kids Balance Bike are visible. The colour label says white; included parts and condition are not inspected.",
        "quantityLabel": "1 carton",
        "price": 64.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "KRIDDO Dual Bearing Balance Bike, white, SKU 253213-WH",
        "comparisonNote": "Same-brand comparison, not a verified KB013 model match. Wheel size, bearings, frame and included accessories may differ. US dollars.",
        "priceUnit": "one balance bike",
        "source": "KRIDDO US",
        "url": "https://www.kriddo.com/products/dual-bearing-balance-bike",
        "referenceKey": "kriddo_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Mediflow water pillow",
        "marker": [
          72,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Mediflow and The Water Pillow are visible on the long upside-down box. The filling type and pack size are not established.",
        "quantityLabel": "1 carton",
        "price": 89.25,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Mediflow Original Down Alternative Water Pillow, single pillow",
        "comparisonNote": "Same-brand comparison; the carton does not establish the filling or pack count. This price is for one down-alternative pillow, not memory foam, down or a two-pack.",
        "priceUnit": "one pillow, not a twin pack",
        "source": "Mediflow Canada",
        "url": "https://www.mediflow.ca/products/the-water-pillow-by-mediflow-down-alternative",
        "referenceKey": "mediflow_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "ShelterAuger anchoring kit",
        "marker": [
          34,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "ShelterAuger 15/6 and canopy-anchoring-system wording are visible. Confirm anchor dimensions and kit count on the carton.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "JOYIN basketball-hoop carton",
        "marker": [
          72,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "JOYIN branding, a basketball hoop and adjustable-height wording are visible on the narrow red box. Size, exact model and included balls are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Twin five-inch memory-foam mattress",
        "marker": [
          37,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "DM505-T and 5-inch Twin Size Memory Foam Mattress are printed. Brand, cover and mattress condition inside are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "VEVOR branded carton",
        "marker": [
          40,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "VEVOR branding is visible on the tall central box, but no specific product can be identified from the exposed panel.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-03-free-shipping-eligible": {
    "title": "Medium General Merchandise #03 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #03",
    "productId": "gid://shopify/Product/9668241129727",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-03-free-shipping-eligible-medium-general-merchandise-03-free-shipping-eligible-liquidationdeals-ca-1257521004.png?v=1788899797",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-03-free-shipping-eligible-medium-general-merchandise-03-free-shipping-eligible-liquidationdeals-ca-1257521004.png?v=1788899797",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Bench-labelled carton",
        "marker": [
          58,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Bench is readable on the wide upper carton, while stickers and the pallet sign cover identifying details. Bench type, dimensions and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Trash-can carton",
        "marker": [
          81,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Product Name: Trash Can, item 1128B and 1 pc are printed on the right carton. Material, opening mechanism and volume are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Cat-tree carton",
        "marker": [
          30,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Cat Tree and SKU CTE168LG01 are printed on the large lower-left carton. Brand, height and configuration are not visible.",
        "quantityLabel": "1 carton",
        "price": 82.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut D30-566V00GY 55-inch cat tree, grey",
        "comparisonNote": "Different-brand/model category comparison. This 55-inch tower's height, platforms, hammocks and construction may differ from the pictured carton.",
        "priceUnit": "one cat tree",
        "source": "Aosom Canada",
        "url": "https://www.aosom.ca/item/pawhut-55-cat-tree-for-indoor-cats-cat-tower-kitty-activity-center-with-cat-bed-ramp-condo-hammocks-hanging-ball-toys~1AR68GR839801.html",
        "referenceKey": "cat_tree_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Flat-pack carton LET013B56",
        "marker": [
          25,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "LET013B56 is readable on a flat brown carton. This code alone does not establish what is inside; the other identifying faces are concealed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-04-free-shipping-eligible": {
    "title": "Medium General Merchandise #04 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #04",
    "productId": "gid://shopify/Product/9668241785087",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-04-free-shipping-eligible-medium-general-merchandise-04-free-shipping-eligible-liquidationdeals-ca-1257521005.png?v=1788899769",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-04-free-shipping-eligible-medium-general-merchandise-04-free-shipping-eligible-liquidationdeals-ca-1257521005.png?v=1788899769",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Inline-skate box",
        "marker": [
          40,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Inline Skate branding and skate graphics are visible on the black box. Size, brand and exact model are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CAP flat exercise bench",
        "marker": [
          17,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "CAP branding and Banc Plat / flat-bench information are visible on the tall left carton. Exact bench model and load rating are not reliably legible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Oversized folding moon chair",
        "marker": [
          49,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Oversized Folding Moon Chair and 400-lb maximum-load wording are visible with a chair illustration. Brand and exact model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Queen box spring",
        "marker": [
          85,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Box Spring and Queen Size / TTYT-BS05-Q are printed on the tall grey carton. Assembly parts and finished height require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Castle bouncer with slide",
        "marker": [
          74,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Castle Bouncer with Slide wording and an inflatable play structure are pictured. Dimensions, blower inclusion and exact brand/model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Flat-pack frame carton",
        "marker": [
          67,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A rectangular frame with legs is illustrated on the narrow carton. The picture alone does not establish the finished item's purpose or dimensions.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-05-free-shipping-eligible": {
    "title": "Medium General Merchandise #05 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #05",
    "productId": "gid://shopify/Product/9668242145535",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-05-free-shipping-eligible-medium-general-merchandise-05-free-shipping-eligible-liquidationdeals-ca-1257521012.png?v=1788899739",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-05-free-shipping-eligible-medium-general-merchandise-05-free-shipping-eligible-liquidationdeals-ca-1257521012.png?v=1788899739",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Graco Pack 'n Play portable playard",
        "marker": [
          18,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Graco Pack 'n Play and Portable Playard are visible. A playard is pictured; exact model, attachments and completeness are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "RETRUE Ride Helper air-spring kit",
        "marker": [
          59,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "RETRUE Ride Helper and RAS 2582 are visible beside a pickup and air-spring illustration. Vehicle fit and kit contents require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "FEANDREA cat tree",
        "marker": [
          51,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "FEANDREA by SONGMICS HOME, Cat Tree and PCT15WV1 are visible. The height and all included platforms/accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 82.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "PawHut D30-566V00GY 55-inch cat tree, grey",
        "comparisonNote": "Different-brand/model category comparison. This 55-inch tower's height, platforms, hammocks and construction may differ from the pictured carton.",
        "priceUnit": "one cat tree",
        "source": "Aosom Canada",
        "url": "https://www.aosom.ca/item/pawhut-55-cat-tree-for-indoor-cats-cat-tower-kitty-activity-center-with-cat-bed-ramp-condo-hammocks-hanging-ball-toys~1AR68GR839801.html",
        "referenceKey": "cat_tree_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "43-inch tower fan HTF1004",
        "marker": [
          39,
          62
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "43-inch Tower Fan, HTF1004 and app/remote-control wording are printed. Brand and included remote are not established.",
        "quantityLabel": "1 carton",
        "price": 64.98,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Honeywell HYF260BC QuietSet 5 40-inch tower fan",
        "comparisonNote": "Different-brand/model and height comparison: 40 inches versus the pictured 43-inch HTF1004. App control, airflow and speed settings differ.",
        "priceUnit": "one tower fan",
        "source": "Walmart Canada",
        "url": "https://www.walmart.ca/en/ip/Honeywell-HYF260BC-QuietSet-5-Whole-Room-40-Tower-Fan/6000196572574",
        "referenceKey": "tower_fan_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Bill Nye VR science kit",
        "marker": [
          82,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Bill Nye's VR Science Kit and virtual-reality activity-set wording are visible. Components and exact edition are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Intex Dura-Beam queen air mattress",
        "marker": [
          80,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Intex Dura-Beam Standard and Queen wording are visible on the slim right-hand box. Height, pump and exact model are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Artificial palm-tree carton",
        "marker": [
          21,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Artificial Palm Tree wording is readable on the lower-left carton. Height, material and pot inclusion are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "POOLPURE branded carton",
        "marker": [
          64,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "POOLPURE branding and a partly obscured product code are visible. The exposed face does not establish the filter type, dimensions or pack count.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-06-free-shipping-eligible": {
    "title": "Medium General Merchandise #06 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #06",
    "productId": "gid://shopify/Product/9668242735359",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-06-free-shipping-eligible-medium-general-merchandise-06-free-shipping-eligible-liquidationdeals-ca-1257521011.png?v=1788899710",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-06-free-shipping-eligible-medium-general-merchandise-06-free-shipping-eligible-liquidationdeals-ca-1257521011.png?v=1788899710",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Classic Accessories DryGuard boat cover",
        "marker": [
          41,
          25
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Classic Accessories, DryGuard and Boat Cover wording are visible. Boat length, fit and included straps are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Amazon Basics multipurpose copy paper",
        "marker": [
          36,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Amazon Basics, 8.5 × 11 inches, 92 brightness and 5,000 sheets are printed. This is one visible case; paper condition and completeness inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Adjustable bar-stool carton",
        "marker": [
          74,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A pedestal bar stool with backrest and footrest is illustrated; SKU YNK-2411 is printed. Brand, seat dimensions and pack count are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "DPROSS inflatable stand-up paddleboard",
        "marker": [
          39,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "DPROSS, Inflatable Stand Up Paddle Board and AT-PB26-04B are visible. Board dimensions, pump, paddle and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Transport wheelchair carton",
        "marker": [
          72,
          74
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Transport Wheelchair, model DH01413 and 1 pc are printed with a chair illustration. Brand, seat width, load rating and completeness are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "FBSPORT branded cartons",
        "marker": [
          20,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Two separate FBSPORT cartons are visible along the left edge. The exposed faces do not identify their product type; do not infer gymnastics mats or paddleboards.",
        "quantityLabel": "2 visible cartons",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-07-free-shipping-eligible": {
    "title": "Medium General Merchandise #07 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #07",
    "productId": "gid://shopify/Product/9668243128575",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-07-free-shipping-eligible-medium-general-merchandise-07-free-shipping-eligible-liquidationdeals-ca-1257521006.png?v=1788899678",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-07-free-shipping-eligible-medium-general-merchandise-07-free-shipping-eligible-liquidationdeals-ca-1257521006.png?v=1788899678",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Full-motion TV wall-mount carton",
        "marker": [
          55,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Full-Motion TV Wall Mount wording is printed on the long upper carton. Brand, screen-size range and weight rating are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Cat litter-box carton",
        "marker": [
          74,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Cat Litter Box and a cat graphic are printed on the upper-right box. No automatic-cleaning mechanism, size or brand can be established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Five-drawer chest dresser",
        "marker": [
          19,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "5 Tall Drawers Chest Dresser and DRW-115-RB are printed on the left carton. Material, dimensions and hardware completeness are not visible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Corelle dinnerware carton",
        "marker": [
          35,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Corelle branding and dishware packaging are visible. Pattern, model and the number of pieces inside are not reliably readable.",
        "quantityLabel": "1 carton",
        "price": 64.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Corelle Winter Frost White 16-piece mugless dinnerware set, service for four",
        "comparisonNote": "Same-brand comparison only; the pictured box does not establish the pattern or piece count. Do not assume it contains this 16-piece set. US dollars.",
        "priceUnit": "one 16-piece dinnerware set",
        "source": "Corelle US",
        "url": "https://www.corelle.com/products/corelle-winter-frost-white-16-piece-mugless-dinnerware-set-service-for-4",
        "referenceKey": "corelle_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Ingenuity Baby Base 2-in-1 seat",
        "marker": [
          64,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Ingenuity and Baby Base 2-in-1 are printed with a feeding/floor seat and tray. Exact colour/model and straps inside are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Queen mattress-topper carton",
        "marker": [
          51,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Mattress Topper Queen is printed on the narrow middle carton. Brand, thickness and foam/material type are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "TADASHI swivel bar-stool carton",
        "marker": [
          77,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "TADASHI Washiora and Swivel Barstool wording are visible. Seat height, colour and any multi-pack count require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-general-merchandise-08-free-shipping-eligible": {
    "title": "Medium General Merchandise #08 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #08",
    "productId": "gid://shopify/Product/9668243783935",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-08-free-shipping-eligible-medium-general-merchandise-08-free-shipping-eligible-liquidationdeals-ca-1257521003.png?v=1788899649",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-08-free-shipping-eligible-medium-general-merchandise-08-free-shipping-eligible-liquidationdeals-ca-1257521003.png?v=1788899649",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "All-terrain rollator walker",
        "marker": [
          55,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "All Terrain Rollator Walker, A42031W8 and a four-wheel walker with seat are visible. Exact brand lettering and dimensions are not clear.",
        "quantityLabel": "1 carton",
        "price": 174.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Helavo H1070 2-in-1 rollator / transport-chair combo, black",
        "comparisonNote": "Different-brand/model category comparison. H1070 also converts to a transport chair; that feature is not established for the pictured A42031W8. Wheels, fit and load rating differ. US dollars.",
        "priceUnit": "one rollator / transport-chair combination",
        "source": "Helavo US",
        "url": "https://helavo-mobility.com/products/2-in-1-rollator-wheelchair-combo-h1070-black",
        "referenceKey": "rollator_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "AMERISUN nine-foot patio umbrella",
        "marker": [
          87,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "AMERISUN, 9 FT and Patio Umbrella are printed on the tall right carton. Colour, tilt mechanism and base inclusion are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Aluminium folding-chair carton",
        "marker": [
          48,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "An aluminium-alloy specification and a folding-chair illustration are visible on the horizontal carton. Brand, seat dimensions and exact model are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Comfee branded cartons",
        "marker": [
          48,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Two slim Comfee cartons are visible across the upper middle. Their exposed faces show branding but do not identify a specific appliance.",
        "quantityLabel": "2 visible cartons",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "STRICH frame carton",
        "marker": [
          55,
          81
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "STRICH branding and a frame/stand illustration are visible on the bottom carton. The product type, dimensions and hardware are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-09-free-shipping-eligible": {
    "title": "Medium General Merchandise #09 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #09",
    "productId": "gid://shopify/Product/9668244111615",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-09-free-shipping-eligible-medium-general-merchandise-09-free-shipping-eligible-liquidationdeals-ca-1257521010.png?v=1788899618",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-09-free-shipping-eligible-medium-general-merchandise-09-free-shipping-eligible-liquidationdeals-ca-1257521010.png?v=1788899618",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Helavo H1011 rollator",
        "marker": [
          69,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Helavo and Rollator H1011 are printed with a four-wheel seated walker. Seat width and accessories inside are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 174.9,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Helavo H1070 2-in-1 rollator / transport-chair combo, black",
        "comparisonNote": "Different model and functionality: H1070 is a rollator/transport-chair combination; the pictured H1011 is not confirmed to have that function. Fit, wheels and load rating may differ. US dollars.",
        "priceUnit": "one rollator / transport-chair combination",
        "source": "Helavo US",
        "url": "https://helavo-mobility.com/products/2-in-1-rollator-wheelchair-combo-h1070-black",
        "referenceKey": "helavo_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Seven-zone memory-foam mattress carton",
        "marker": [
          30,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "7 Zone Foam Mattress and a mattress diagram are visible. Brand lettering, thickness and bed size are not reliably readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Dream On Me Nest portable playard",
        "marker": [
          39,
          62
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Dream On Me, Nest and Portable Playard are printed on the horizontal carton. Exact model/colour and contents need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "304 stainless-steel kitchen sink",
        "marker": [
          84,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Kitchen Sink and 304 Stainless Steel are visible with a sink illustration. Bowl size, mounting dimensions and accessories are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Geekpure reverse-osmosis filtration system",
        "marker": [
          55,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Geekpure and Reverse Osmosis Water Filtration System are visible. The specific stage count, capacity and filter bundle are not established.",
        "quantityLabel": "1 carton",
        "price": 149.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Geekpure five-stage 75-GPD reverse-osmosis water-filter system",
        "comparisonNote": "Same-brand comparison; the carton does not establish stage count, daily capacity or bundle. This is the standard five-stage 75-GPD system, not an extra-filter or UV bundle. US dollars.",
        "priceUnit": "one five-stage filtration system",
        "source": "Geekpure US",
        "url": "https://www.geekpure.cc/products/5-stage-reverse-osmosis-water-filter-system-75gpd",
        "referenceKey": "geekpure_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "HET03SDGY carton",
        "marker": [
          30,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "HET03SDGY and a printed quantity are visible, but the exposed face does not identify the product. Printed carton quantity is not a verified contents count.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-10-free-shipping-eligible": {
    "title": "Medium General Merchandise #10 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #10",
    "productId": "gid://shopify/Product/9668244865279",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-10-free-shipping-eligible-medium-general-merchandise-10-free-shipping-eligible-liquidationdeals-ca-1257521009.png?v=1788899590",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-10-free-shipping-eligible-medium-general-merchandise-10-free-shipping-eligible-liquidationdeals-ca-1257521009.png?v=1788899590",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Fabric wardrobe carton",
        "marker": [
          30,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Fabric Wardrobe wording is visible. Brand, assembled dimensions and interior layout are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Interactive cat-shelf carton",
        "marker": [
          73,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Interactive Cat Shelves and cat graphics are printed. Brand lettering is partly obscured; shelf count, layout and mounting hardware are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ninja slackline and hanging obstacles",
        "marker": [
          29,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Ninja Slackline & Hanging Obstacles and hanging-grip illustrations are visible. Length, included obstacle count and exact model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Warmplants artificial tree",
        "marker": [
          55,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Warmplants and Artificial Tree are printed on the broad middle carton. Species, height and pot inclusion are not visible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "All-terrain rollator walker",
        "marker": [
          32,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "All Terrain Rollator Walker, A42031W8 and a seated four-wheel walker are pictured. Confirm brand, seat width and accessories.",
        "quantityLabel": "1 carton",
        "price": 174.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Helavo H1070 2-in-1 rollator / transport-chair combo, black",
        "comparisonNote": "Different-brand/model category comparison. H1070 also converts to a transport chair; that feature is not established for the pictured A42031W8. Wheels, fit and load rating differ. US dollars.",
        "priceUnit": "one rollator / transport-chair combination",
        "source": "Helavo US",
        "url": "https://helavo-mobility.com/products/2-in-1-rollator-wheelchair-combo-h1070-black",
        "referenceKey": "rollator_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Orthopaedic dog-bed carton",
        "marker": [
          58,
          58
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Orthopedic Dog Bed and egg-crate foam wording are visible. The size/colour checkboxes are too small to confirm.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "maXpeedingrods air-spring kit",
        "marker": [
          73,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "maXpeedingrods and Air Spring are visible with a truck image. Vehicle application, model and the kit's components are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Geekpure reverse-osmosis filtration system",
        "marker": [
          30,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Geekpure Reverse Osmosis Water Filtration System is visible. Stage count and included filter/tank bundle are not established.",
        "quantityLabel": "1 carton",
        "price": 149.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Geekpure five-stage 75-GPD reverse-osmosis water-filter system",
        "comparisonNote": "Same-brand comparison; the carton does not establish stage count, daily capacity or bundle. This is the standard five-stage 75-GPD system, not an extra-filter or UV bundle. US dollars.",
        "priceUnit": "one five-stage filtration system",
        "source": "Geekpure US",
        "url": "https://www.geekpure.cc/products/5-stage-reverse-osmosis-water-filter-system-75gpd",
        "referenceKey": "geekpure_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Stool-frame carton",
        "marker": [
          64,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Two stool-shaped frames are illustrated on one carton. Brand, model, pack count and finished seat height are not established; drawings do not prove two complete stools inside.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-general-merchandise-11-free-shipping-eligible": {
    "title": "Medium General Merchandise #11 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Medium General Merchandise #11",
    "productId": "gid://shopify/Product/9668290248959",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-11-free-shipping-eligible-medium-general-merchandise-11-free-shipping-eligible-liquidationdeals-ca-1257521007.png?v=1788899563",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-11-free-shipping-eligible-medium-general-merchandise-11-free-shipping-eligible-liquidationdeals-ca-1257521007.png?v=1788899563",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "HUANUO keyboard tray",
        "marker": [
          67,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "HUANUO and Keyboard Tray are visible on the long top carton. Tray width, mounting type and exact model are not readable.",
        "quantityLabel": "1 carton",
        "price": 79,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "HUANUO 25-inch All-Motion Keyboard Tray HNKB03W-US, white",
        "comparisonNote": "Same-brand comparison; mounting type, width and colour on the carton are not established. This is the white 25-inch all-motion model. US dollars.",
        "priceUnit": "one keyboard-tray assembly",
        "source": "HUANUO US",
        "url": "https://www.huanuo.com/products/25-all-motion-keyboard-tray",
        "referenceKey": "keyboard_tray_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "VEVOR acrylic dog playpen",
        "marker": [
          63,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "VEVOR and Acrylic Transparent Dog Playpen Panels are printed with a panel illustration. Panel count, enclosure dimensions and hardware inside are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "YOUNIKE YNK-1911 carton",
        "marker": [
          44,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "YOUNIKE and SKU YNK-1911 are printed, but no finished-product illustration or description is visible. Do not infer a specific chair or stool from the code.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "VEVOR branded carton",
        "marker": [
          60,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "A second VEVOR box shows branding and support text without a visible product description. Its contents remain unidentified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-general-merchandise-12-free-shipping-eligible": {
    "title": "Medium General Merchandise #12 — FREE SHIPPING ELIGIBLE",
    "shortTitle": "Medium General Merchandise #12",
    "productId": "gid://shopify/Product/9668420108543",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "gm"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-12-watermarked.png?v=1788895463",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-general-merchandise-12-watermarked.png?v=1788895463",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Electronic-safe cartons",
        "marker": [
          62,
          52
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Six distinct cartons depict keypad safes: two at upper/middle left and four in the right-hand two-by-two group. Brand, dimensions, keys and actual contents are not established.",
        "quantityLabel": "6 visible cartons",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Folding pet crate",
        "marker": [
          71,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Folding Pet Crate, size L and 30 × 21 × 21 inches are printed. Brand, material and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "HUANUO FlowLift monitor arm",
        "marker": [
          70,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "HUANUO FlowLift Desk Monitor Arm is visible, with a 17–32-inch monitor range. Exact model and mounting hardware are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 49.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "HUANUO FlowLift Pro single monitor arm, HNDMA118B-SS",
        "comparisonNote": "Same-brand comparison; the carton says FlowLift, while this listing is FlowLift Pro. Confirm model, monitor weight range and mounting hardware. Not a dual-arm pack. US dollars.",
        "priceUnit": "one single-monitor arm assembly",
        "source": "HUANUO US",
        "url": "https://www.huanuo.com/products/huanuo-single-monitor-arm-flowlift-pro",
        "referenceKey": "monitor_arm_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "CH401 cornhole-set cartons",
        "marker": [
          39,
          68
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Four separate slim cartons are labelled Cornhole Sets CH401. Do not count the printed set contents as verified boards or beanbags.",
        "quantityLabel": "4 visible cartons",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Maxwalk rollator carton",
        "marker": [
          74,
          80
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Maxwalk branding and a four-wheel rollator with seat are pictured. Model, dimensions and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 174.9,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Helavo H1070 2-in-1 rollator / transport-chair combo, black",
        "comparisonNote": "Different-brand/model category comparison. H1070 also converts to a transport chair; that feature is not established for the pictured A42031W8. Wheels, fit and load rating differ. US dollars.",
        "priceUnit": "one rollator / transport-chair combination",
        "source": "Helavo US",
        "url": "https://helavo-mobility.com/products/2-in-1-rollator-wheelchair-combo-h1070-black",
        "referenceKey": "rollator_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Colorado Eagle branded carton",
        "marker": [
          18,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Colorado Eagle branding is visible on the tall left carton, but the exposed panel does not identify a product.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "medium-electronics-11-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #11 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #11 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668379476223",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-11-liquidation-pallet-wholesale-medium-electronics-11-liquidation-pallet-wholesale-liquidationdeals-ca-1257521002.png?v=1788899533",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-11-liquidation-pallet-wholesale-medium-electronics-11-liquidation-pallet-wholesale-liquidationdeals-ca-1257521002.png?v=1788899533",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Cordless handheld-vacuum carton",
        "marker": [
          8,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Cordless Handheld Vacuum wording and a vacuum illustration are visible on the upper-left carton. Brand/model and accessories are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Herdio in-wall / in-ceiling speakers",
        "marker": [
          49,
          19
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Herdio and in-wall/in-ceiling-speaker wording are visible with a round speaker illustration. Exact model and speaker count inside are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "AIRMSEN Dual Brew coffee maker",
        "marker": [
          20,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "AIRMSEN Dual Brew Coffee Maker, capsules/powder and 1000W are printed. Exact model and capsule compatibility need confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Under-desk elliptical trainer",
        "marker": [
          48,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "An elliptical-trainer illustration with two foot platforms and a remote is visible. Brand, resistance specification and model are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Heated throw carton",
        "marker": [
          65,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Heated Throw wording is printed on the narrow green box. Brand lettering, blanket size and controller are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vibration plate EFR1802",
        "marker": [
          85,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Vibration Plate Exercise Machine and EFR1802 are visible. Brand, platform size and resistance accessories are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Turbo outdoor-heater carton",
        "marker": [
          76,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Turbo branding and a rectangular heater with control accessories are pictured. Wattage, mounting type and exact model are obscured.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Miele Blizzard CX1 canister vacuum",
        "marker": [
          34,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Miele Blizzard CX1 is visible with a canister vacuum. Exact edition, floor heads and other accessories inside are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Arcatool V308 fuel-injector cleaner / tester",
        "marker": [
          24,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Arcatool V308 Fuel Injector Cleaner & Tester is readable. The pictured equipment does not establish the adapter set or working condition.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Grindora espresso machine",
        "marker": [
          48,
          73
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Grindora, 1500W and a grinder-equipped espresso machine are pictured. Exact model and included tools are not established.",
        "quantityLabel": "1 carton",
        "price": 199.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "DeLonghi Classic EM450M manual espresso machine, without integrated grinder",
        "comparisonNote": "Different brand/model and feature set: the pictured Grindora has an integrated grinder; this DeLonghi comparison does not. It is not an equivalent complete grinder-machine system.",
        "priceUnit": "one espresso machine, no grinder",
        "source": "DeLonghi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/manual-espresso-machines",
        "referenceKey": "espresso_grinder_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Steam cleaner CE07A",
        "marker": [
          82,
          71
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Steam Cleaner and CE07A are printed beside a canister-style steamer with hose. Exact brand and accessory set are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Tool Daily electric pressure washer",
        "marker": [
          37,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Tool Daily Electric Pressure Washer and a washer with hose and fittings are pictured. Pressure/flow ratings and accessory count inside are not established.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "A/C vacuum-pump and gauge-kit carton",
        "marker": [
          79,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "A/C Vacuum Pump and gauge-kit wording and components are pictured. This is service equipment, not a complete air conditioner.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-12-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #12 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #12 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668380066047",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-12-liquidation-pallet-wholesale-medium-electronics-12-liquidation-pallet-wholesale-liquidationdeals-ca-1257520995.png?v=1788899497",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-12-liquidation-pallet-wholesale-medium-electronics-12-liquidation-pallet-wholesale-liquidationdeals-ca-1257520995.png?v=1788899497",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Breville Luxe toaster carton",
        "marker": [
          18,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Breville Luxe and a countertop toaster are visible. The precise model and slice capacity are not reliably legible.",
        "quantityLabel": "1 carton",
        "price": 269.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Breville BTA840 Die-Cast four-slice Smart Toaster",
        "comparisonNote": "Same-brand comparison, not an exact Luxe model match. Four-slot capacity, controls, housing and finish may differ from the pictured carton.",
        "priceUnit": "one four-slice toaster",
        "source": "Breville Canada",
        "url": "https://www.breville.com/en-ca/product/bta840",
        "referenceKey": "breville_toaster_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Candle-warmer carton",
        "marker": [
          21,
          15
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Candle Warmers wording is visible on the small upside-down carton. Lamp style, brand and model are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "STARRYBOT portable spot cleaner",
        "marker": [
          54,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "STARRYBOT branding and a portable cleaner with coiled hose are pictured. Exact model, heating functions and attachments are not established.",
        "quantityLabel": "1 carton",
        "price": 119.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "BISSELL Little Green ProHeat Deluxe 25137 exclusive bundle",
        "comparisonNote": "Category comparison, not an exact model match. Model 25137 differs from Max Pet, CleanSlate and StainStriker; included tools/formula and brand may differ.",
        "priceUnit": "one portable cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "spot_cleaner_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "A/C evaporator-core carton",
        "marker": [
          18,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "A/C Evaporator Core is printed beside a finned component illustration. Vehicle/application details are not visible; this is not a complete AC unit.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CAMPLUX tankless gas water heater",
        "marker": [
          83,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "CAMPLUX and Tankless Gas Water Heater wording are visible. Gas type, output, venting and exact model require confirmation.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vibration plate GR1802",
        "marker": [
          51,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Vibration Plate Exercise Machine and GR1802 are printed. Brand lettering, platform size and accessories are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Automatic trash-can carton",
        "marker": [
          25,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "An automatic trash can with lid controls is pictured. Brand, capacity, power source and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "EVAIROX X8 carton",
        "marker": [
          55,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "EVAIROX and X8 are printed with a box-shaped appliance illustration. The exposed face does not reliably establish the appliance type.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Waterdrop countertop RO system",
        "marker": [
          48,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Waterdrop and reverse-osmosis filtration wording are visible beside a countertop dispenser illustration. The WD-C1-series model suffix is too small to confirm.",
        "quantityLabel": "1 carton",
        "price": 199.99,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Waterdrop C2SL countertop mineral reverse-osmosis system with glass pitcher",
        "comparisonNote": "Different Waterdrop model/generation: C2SL is not the pictured WD-C1-series carton. Filtration stages, remineralization, capacity and included pitcher may differ. US dollars.",
        "priceUnit": "one countertop filtration system with pitcher",
        "source": "Waterdrop US",
        "url": "https://www.waterdropfilter.com/products/countertop-mineral-reverse-osmosis-system-c2sl",
        "referenceKey": "waterdrop_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Robotic pool cleaner carton",
        "marker": [
          80,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Robotic Pool Cleaner and a tracked pool-cleaning robot are pictured. Exact brand/model, cable and power supply are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "PXN V9 Gen2 gaming racing wheel",
        "marker": [
          78,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "PXN V9 Gen2 and 900° Gaming Racing Wheel are visible with wheel, pedals and shifter illustrations. Components inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vibration-plate carton",
        "marker": [
          19,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Vibration Plate is printed on the separate tall lower-left box. This is a second visible carton, not another view of the GR1802 box.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-13-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #13 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #13 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668380557567",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-13-liquidation-pallet-wholesale-medium-electronics-13-liquidation-pallet-wholesale-liquidationdeals-ca-1257521001.png?v=1788899470",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-13-liquidation-pallet-wholesale-medium-electronics-13-liquidation-pallet-wholesale-liquidationdeals-ca-1257521001.png?v=1788899470",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Steam-cleaner carton",
        "marker": [
          34,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Steam Cleaner wording and a canister steamer with hose are visible. Exact brand, model and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "GREENER leaf blower",
        "marker": [
          72,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "GREENER Leaf Blower and a cordless blower are pictured. Battery capacity, charger and exact model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Tineco FLOOR ONE i6 STRETCH",
        "marker": [
          47,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Tineco FLOOR ONE i6 STRETCH and Cordless Floor Washer are visible on the horizontal carton. Regional suffix and accessories are not established.",
        "quantityLabel": "1 carton",
        "price": 299,
        "currency": "USD",
        "match": "Same brand",
        "comparison": "Tineco FLOOR ONE STRETCH S6 wet/dry vacuum, FW420100US",
        "comparisonNote": "Different Tineco model: STRETCH S6 is a category comparison for the pictured i6 STRETCH, not the same series. Features, regional version and accessories may differ. US dollars.",
        "priceUnit": "one wet/dry floor-cleaning vacuum",
        "source": "Tineco US",
        "url": "https://store.tineco.com/products/tineco-floor-one-stretch-s6-wet-dry-vacuum-cleaner",
        "referenceKey": "tineco_i6_comparison_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "MaXlander 20V cordless tiller",
        "marker": [
          46,
          50
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "MaXlander 20V / 8-inch Cordless Tiller Cultivator and ASYTL05 are printed. Battery and charger inclusion are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric balance-wheel carton",
        "marker": [
          83,
          44
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Electric Balance Wheel, HS2.0 and a self-balancing board are pictured. Exact brand/model, battery and charger are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "ViewSonic VX3218C-2K gaming monitor",
        "marker": [
          52,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "ViewSonic Gaming, VX3218C-2K and QHD LED Backlit Display are visible. Stand, cables and panel condition are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Breville countertop oven",
        "marker": [
          34,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Breville branding and a countertop oven are pictured. The exact Smart Oven model and included trays are not readable.",
        "quantityLabel": "1 carton",
        "price": 599.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Breville BOV900 Smart Oven Air Fryer Pro, one-cu.-ft. capacity",
        "comparisonNote": "Same-brand comparison; the pictured oven's exact model is unreadable. Capacity, air-frying functions and tray bundle may differ from BOV900.",
        "priceUnit": "one countertop oven with its standard accessories",
        "source": "Breville Canada",
        "url": "https://www.breville.com/en-ca/product/bov900",
        "referenceKey": "breville_oven_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Vellgoo dehumidifier carton",
        "marker": [
          68,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Vellgoo and Energy Star Dehumidifier are printed. Pint capacity, exact model and drainage accessories are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Vibration-plate carton",
        "marker": [
          10,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Vibration Plate wording is printed on the tall left carton. Brand, model and platform size are not readable.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-14-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #14 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #14 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668381049087",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-14-liquidation-pallet-wholesale-medium-electronics-14-liquidation-pallet-wholesale-liquidationdeals-ca-1257521000.png?v=1788899440",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-14-liquidation-pallet-wholesale-medium-electronics-14-liquidation-pallet-wholesale-liquidationdeals-ca-1257521000.png?v=1788899440",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Hoverstar electric balance-wheel cartons",
        "marker": [
          34,
          18
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Two separate Hoverstar Electric Balance Wheel / HS2.0 cartons are visible: one across the top and one lower left. Colours differ; chargers and boards inside are not verified.",
        "quantityLabel": "2 visible cartons",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Shark Lift-Away ADV upright vacuum",
        "marker": [
          79,
          32
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Shark Lift-Away ADV and PowerFins HairPro wording are visible with an upright vacuum. Exact model and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BISSELL Little Green ProHeat",
        "marker": [
          25,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "BISSELL Little Green ProHeat and model 2513B are printed with a portable cleaner illustration. Tools and formula inside are not confirmed.",
        "quantityLabel": "1 carton",
        "price": 119.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "BISSELL Little Green ProHeat Deluxe 25137 exclusive bundle",
        "comparisonNote": "Category comparison, not an exact model match. Model 25137 differs from Max Pet, CleanSlate and StainStriker; included tools/formula and brand may differ.",
        "priceUnit": "one portable cleaner bundle",
        "source": "BISSELL Canada",
        "url": "https://www.bissell.com/en-ca/product/little-green-proheat-deluxe-portable-carpet-upholstery-cleaner-exclusive-bundle-25137.html",
        "referenceKey": "spot_cleaner_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Monster Sparkle high-power speaker",
        "marker": [
          55,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Monster Sparkle is readable beside a lighted speaker image. Exact power rating, battery and microphone bundle are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Quartz infrared portable heater",
        "marker": [
          25,
          57
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Quartz Infrared Portable Heater and CD9315BCW-3J are printed. Brand and electrical rating are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Wall-mounted split-AC indoor-unit carton",
        "marker": [
          72,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Air Conditioner / Wall-Mounted Split AC Indoor Unit is printed on the large right box. An outdoor unit and a complete matched system are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Canon PIXMA TR4720 printer",
        "marker": [
          43,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Canon PIXMA TR4720 and an all-in-one printer are pictured. Ink cartridges, cables and condition inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-15-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #15 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #15 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668381147391",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-15-liquidation-pallet-wholesale-medium-electronics-15-liquidation-pallet-wholesale-liquidationdeals-ca-1257520999.png?v=1788899413",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-15-liquidation-pallet-wholesale-medium-electronics-15-liquidation-pallet-wholesale-liquidationdeals-ca-1257520999.png?v=1788899413",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Rowenta high-pressure steam generator",
        "marker": [
          26,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Rowenta, High Pressure Steam Generator and 7.4-bar wording are visible with an iron and base. Exact model and accessories are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "GREENER electric pressure washer",
        "marker": [
          84,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "GREENER Electric Pressure Washer and a wheeled washer are pictured. Model, pressure and flow ratings are not clear.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "FOTING submersible water pump",
        "marker": [
          60,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "FOTING Submersible Water Pump is printed with a pump illustration. Exact model, flow rating and fittings are obscured.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Midea Cube 50-pint dehumidifier",
        "marker": [
          29,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Midea Cube Smart Dehumidifier and 50 pints/day are visible. Exact model suffix and drainage parts are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "BLACK+DECKER twelve-amp landscape edger",
        "marker": [
          59,
          52
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "BLACK+DECKER and 12 Amp 2-in-1 Landscape Edger and Trencher are printed. Exact model and blade/accessory condition are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Electric pressure-washer carton",
        "marker": [
          84,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A second pressure-washer carton shows a wheeled appliance and 8850 text. Brand and full model/rating labels are covered.",
        "quantityLabel": "1 carton",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded electric pressure washer, 2030 max PSI / 1.2 GPM",
        "comparisonNote": "Different-brand/model comparison. Pressure, flow rate, motor rating, hose and accessories may differ from the pictured carton. US dollars.",
        "priceUnit": "one electric pressure washer",
        "source": "The Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "pressure_washer_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Cuisinart gooseneck kettle",
        "marker": [
          41,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Cuisinart Gooseneck Kettle and one-litre capacity wording are visible. Exact model and finish are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Maytronics Dolphin E10 pool cleaner",
        "marker": [
          81,
          62
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Maytronics Dolphin E10 and Robotic Pool Cleaner are printed. Cable, power supply and filters inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Hoover PowerScrub Deluxe carpet cleaner",
        "marker": [
          49,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Hoover PowerScrub Deluxe and an upright carpet cleaner are visible. The model suffix, tools and formula bundle require confirmation.",
        "quantityLabel": "1 carton",
        "price": 249.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hoover PowerScrub Deluxe FH50150V carpet cleaner",
        "comparisonNote": "Same PowerScrub Deluxe family; verify the regional model suffix, tool set and cleaning-formula bundle on the carton. Contents are not inspected.",
        "priceUnit": "one upright carpet cleaner",
        "source": "Hoover Canada",
        "url": "https://hoover.ca/products/power-scrub-deluxe-carpet-cleaner",
        "referenceKey": "hoover_scrub_20260908",
        "priceReviewedAt": "2026-09-08"
      },
      {
        "label": "Gawfolk computer-monitor carton",
        "marker": [
          25,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Gawfolk and Computer LED Monitor are printed on the tall left carton. Screen size, resolution and model are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      }
    ]
  },
  "medium-electronics-16-liquidation-pallet-wholesale": {
    "title": "Medium Electronics #16 | Liquidation Pallet Wholesale",
    "shortTitle": "Medium Electronics #16 | Liquidation Pallet Wholesale",
    "productId": "gid://shopify/Product/9668420862207",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-08",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-16-watermarked.png?v=1788895468",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/medium-electronics-16-watermarked.png?v=1788895468",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "VTech Explore & Write Activity Desk",
        "marker": [
          28,
          14
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "VTech Explore & Write Activity Desk and desk/chalkboard/art-station modes are pictured. Activity cards and components inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "CRAFTSMAN V20 Brushless RP nailer carton",
        "marker": [
          75,
          11
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "CRAFTSMAN V20 Brushless RP, a nailer illustration and a 30-degree mark are visible. Exact model and battery/charger bundle are not confirmed.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Baby Brezza Formula Pro Advanced",
        "marker": [
          35,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Baby Brezza Formula Pro Advanced is visible with a formula-preparation appliance. Exact colour/model and components inside are not established.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "TICYACK water-pump carton",
        "marker": [
          8,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "TICYACK branding, pump specifications and aquarium-use pictures are visible. Exact model, flow rate and accessories are not reliably legible.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Winny B1 cordless robotic pool cleaner",
        "marker": [
          76,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Winny B1 and Cordless Robotic Pool Cleaner are printed. The robot and charging accessories inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "ECOVACS GOAT O1000 RTK-labelled carton",
        "marker": [
          28,
          53
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "ECOVACS GOAT O1000 RTK Care Kit wording and a robotic lawn-mower illustration are visible. The photo does not verify the mower, RTK equipment or complete kit contents.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "MAXXT electric edger carton",
        "marker": [
          49,
          51
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "MAXXT branding and an electric lawn-edger illustration are visible on the narrow box. Exact model and electrical rating are not clear.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Midea EasyDry 50-pint dehumidifier",
        "marker": [
          77,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Midea EasyDry, 50 pints/day and MAD50C1AWS are printed. Drainage components and condition inside are not verified.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Ninja FrostVault wheeled cooler",
        "marker": [
          30,
          78
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Ninja FrostVault, 30 QT / 28 L, all-terrain wheels and FB230CBL are printed. Colour, accessories and contents are not inspected.",
        "quantityLabel": "1 carton",
        "price": null,
        "reason": "A suitable new-retail price was not verified."
      },
      {
        "label": "Hoover PowerScrub Deluxe carpet cleaner",
        "marker": [
          74,
          77
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Hoover PowerScrub Deluxe and an upright carpet cleaner are pictured. Confirm the model suffix and included tools/formula.",
        "quantityLabel": "1 carton",
        "price": 249.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Hoover PowerScrub Deluxe FH50150V carpet cleaner",
        "comparisonNote": "Same PowerScrub Deluxe family; verify the regional model suffix, tool set and cleaning-formula bundle on the carton. Contents are not inspected.",
        "priceUnit": "one upright carpet cleaner",
        "source": "Hoover Canada",
        "url": "https://hoover.ca/products/power-scrub-deluxe-carpet-cleaner",
        "referenceKey": "hoover_scrub_20260908",
        "priceReviewedAt": "2026-09-08"
      }
    ]
  },
  "bulk-electronics-200-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #200 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #200",
    "productId": "gid://shopify/Product/9682401853695",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-200-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-200-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338125.png?v=1789065190",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-200-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-200-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338125.png?v=1789065190",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Xega-branded device carton",
        "marker": [
          49,
          14
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Xega branding and a product image are visible, but the device type, model and package contents are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Welov air-purifier carton",
        "marker": [
          18,
          37
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Welov branding and Air Quality Sensor, Low Noise, Child Safety and Sleep/Night feature text are visible; the exact model and filter size are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Bottle sterilizer/dryer carton",
        "marker": [
          49,
          34
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Bottle Sterilizer Dryer is readable on the centre carton; the brand suffix, model and capacity are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "De’Longhi Classic espresso-machine carton",
        "marker": [
          77,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "De’Longhi Classic branding and an espresso/cappuccino-machine image are visible; the exact regional model and included accessories are not readable.",
        "price": 199.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "De’Longhi Classic EM450M manual espresso machine",
        "comparisonNote": "Same Classic family; the pictured carton does not expose its regional model suffix. Verify EM450M, colour and accessory bundle before treating this as an exact match.",
        "priceUnit": "one espresso machine",
        "source": "De’Longhi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/manual-espresso-machines",
        "referenceKey": "delonghi_classic_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "1600W pressure-washer carton",
        "marker": [
          49,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "1600W, Heavy Duty and pressure-washer imagery are visible. Brand, rated pressure, flow and accessory kit are partly covered.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded pressure washer, 2030 max PSI and 1.2 GPM",
        "comparisonNote": "Different brand/model comparison. The pictured carton’s rated pressure, flow, motor power and accessory kit are not confirmed.",
        "priceUnit": "one pressure washer",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "sunjoe_pressure_washer_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Electric garage-heater carton",
        "marker": [
          20,
          60
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Electric Garage Heater and 4800W are readable; the brand, plug type and exact model are not confirmed.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Waterdrop X Series reverse-osmosis system",
        "marker": [
          30,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Waterdrop X Series and WD-X12 are visible on the large carton; filter bundle and package condition remain unverified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Kärcher K4 pressure-washer carton",
        "marker": [
          75,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Kärcher K4 branding is visible. The precise K4 variant, hose length and accessory bundle need confirmation.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-201-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #201 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #201",
    "productId": "gid://shopify/Product/9682402312447",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-201-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-201-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338124.png?v=1789065159",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-201-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-201-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338124.png?v=1789065159",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Roomie Tec robot-vacuum carton",
        "marker": [
          48,
          15
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Roomie Tec branding and a robot-vacuum illustration are visible; exact model and included dock/accessories are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Partly covered range-hood carton",
        "marker": [
          18,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "A range-hood product image and partial branding are visible, but the brand, width and airflow rating cannot be read.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Range Hood carton",
        "marker": [
          78,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Range Hood is printed on the carton; its specification panel is too small to verify size, airflow or model.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Smart ceiling-fan carton",
        "marker": [
          46,
          38
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "A ceiling fan is pictured with Tuya, Alexa and Google compatibility logos; brand spelling, diameter and model are not fully readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "LY-38 automatic trash-can carton",
        "marker": [
          25,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Automatic Trash Can, LY-38 and 60L are visible; exact brand and included power accessories are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Pressure-washer carton",
        "marker": [
          74,
          56
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "A pressure washer is pictured, but the brand, rated pressure, flow and accessory kit are unreadable.",
        "price": 169,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "Sun Joe SPX3000 corded pressure washer, 2030 max PSI and 1.2 GPM",
        "comparisonNote": "Different brand/model comparison. The pictured carton’s rated pressure, flow, motor power and accessory kit are not confirmed.",
        "priceUnit": "one pressure washer",
        "source": "Home Depot US",
        "url": "https://www.homedepot.com/p/Sun-Joe-2030-MAX-PSI-PWMA-Certified-1-2-GPM-13-Amp-Cold-Water-Corded-Electric-Pressure-Washer-SPX3000/204202850",
        "referenceKey": "sunjoe_pressure_washer_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "STEELITE electric dethatcher/scarifier",
        "marker": [
          27,
          72
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "STEELITE branding, 13-inch and electric dethatcher/scarifier wording are visible; the exact model suffix and collection-bag details are partly covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Keurig K-Duo Hot & Iced coffee maker",
        "marker": [
          22,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Keurig K-Duo Hot & Iced and Single Serve & Carafe Coffee Maker are visible; colour and package contents are not inspected.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "SWIPESMITH dethatcher/scarifier carton",
        "marker": [
          73,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "SWIPESMITH branding and dethatcher/scarifier imagery are visible; working width, power and model are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-202-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #202 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #202",
    "productId": "gid://shopify/Product/9682402377983",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-202-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-202-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338123.png?v=1789065131",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-202-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-202-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338123.png?v=1789065131",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Steam-spa foot-bath carton",
        "marker": [
          21,
          35
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Steam Spa Foot Bath and feature icons are visible; the brand, basin capacity and exact model are partly covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Ninja DualBrew coffee-system carton",
        "marker": [
          51,
          28
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Ninja DualBrew branding and a combination coffee-system image are visible; exact model, brewer sizes and accessory bundle are not readable.",
        "price": 349.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "De’Longhi All-in-One COM532M coffee and espresso maker",
        "comparisonNote": "Different brand and brewing system from the pictured Ninja DualBrew. Espresso functions, pod compatibility, carafe size and accessories differ.",
        "priceUnit": "one combination coffee and espresso maker",
        "source": "De’Longhi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/manual-espresso-machines",
        "referenceKey": "delonghi_allinone_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "PETLIBRO ONE RFID smart feeder",
        "marker": [
          81,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "PETLIBRO ONE RFID Smart Feeder is readable; capacity, tag count and exact package bundle are not confirmed.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "WYBOT robotic pool skimmer",
        "marker": [
          70,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "WYBOT branding and robotic pool-skimmer imagery are visible; exact model and included charging equipment are not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "WYBOT cordless robotic pool cleaner",
        "marker": [
          29,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "WYBOT and cordless robotic pool-cleaner imagery are visible; exact model, pool rating and charger are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "13-inch 10A electric snow shovel",
        "marker": [
          72,
          69
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "13-inch and 10A electric snow-shovel wording are visible; brand, clearing depth and model are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "20V snow-thrower carton",
        "marker": [
          27,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "20V and snow-thrower imagery are visible; the brand, battery count and exact model cannot be read.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-203-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #203 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #203",
    "productId": "gid://shopify/Product/9682402443519",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-203-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-203-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338122.png?v=1789065097",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-203-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-203-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338122.png?v=1789065097",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "ARCCAPTAIN inverter-welder carton",
        "marker": [
          27,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "ARCCAPTAIN, Inverter Welder and A3-D90 are visible; torch, leads and accessory contents remain unverified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "VEVOR glass-aquarium carton",
        "marker": [
          77,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "VEVOR and Glass Aquarium are readable. Multiple capacity markings appear on the carton, so the packed size is not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "SALAV EJM320B espresso-machine carton",
        "marker": [
          75,
          39
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "SALAV branding and model EJM320B are visible with an espresso-machine image; colour and included accessories are not inspected.",
        "price": 199.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "De’Longhi Classic EM450M manual espresso machine",
        "comparisonNote": "Same Classic family; the pictured carton does not expose its regional model suffix. Verify EM450M, colour and accessory bundle before treating this as an exact match.",
        "priceUnit": "one espresso machine",
        "source": "De’Longhi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/manual-espresso-machines",
        "referenceKey": "delonghi_classic_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Vibration-plate carton",
        "marker": [
          26,
          42
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "A vibration platform is pictured; brand, model, rated capacity and accessories are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Gaming-monitor carton",
        "marker": [
          44,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Gaming Monitor is readable, but the brand, screen size, refresh rate and model are hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Mifasol warm-steam humidifier cartons",
        "marker": [
          21,
          59
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Two separate cartons show Mifasol, Warm Steam Humidifier and model MFS-JSQ-01; actual contents are not inspected.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "CINO distiller cartons",
        "marker": [
          22,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Two separate CINO-branded cartons show distiller imagery; capacity, power and exact model are unreadable.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Ceiling exhaust-fan carton",
        "marker": [
          50,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "A ceiling exhaust fan is pictured on the white carton; brand, diameter and airflow rating are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Foot-massager carton",
        "marker": [
          82,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Foot-massager imagery and a small specification table are visible, but brand and model text cannot be verified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-204-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #204 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #204",
    "productId": "gid://shopify/Product/9682402476287",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-204-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-204-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338121.png?v=1789065070",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-204-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-204-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338121.png?v=1789065070",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "MONGSGA slow-juicer carton",
        "marker": [
          22,
          26
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "MONGSGA and Slow Juicer are readable; model suffix, feed-chute size and included accessories are partly covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Large brown product carton",
        "marker": [
          53,
          24
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A wheeled-product illustration is visible, but the product type, brand and model are too obscured to identify.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Zojirushi CD-LFC30 carton",
        "marker": [
          80,
          25
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Zojirushi and CD-LFC30 are visible; descriptive text is partly covered and package contents are not inspected.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "BISSELL CrossWave carton",
        "marker": [
          21,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "BISSELL CrossWave branding is visible; the exact CrossWave variant, model suffix and accessory bundle are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "TASALON professional bonnet hair dryer",
        "marker": [
          54,
          51
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "TASALON Professional Ionic Stand Bonnet Hair Dryer is readable; exact model and attachment bundle are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Green carton with waterfall imagery",
        "marker": [
          84,
          49
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Use-scene images are visible, but the product name, brand and model are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Direct-fit plug-and-play carton",
        "marker": [
          68,
          67
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Direct Fit and Plug & Play are readable with partial branding, but the product type and model are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Hermitlux HMX-DW03 dishwasher carton",
        "marker": [
          27,
          82
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Hermitlux branding, a glass-door countertop dishwasher image and model HMX-DW03 are visible; package contents remain unverified.",
        "price": 259.99,
        "currency": "USD",
        "match": "Comparison",
        "comparison": "AIRMSEN AE-TDQR03 countertop dishwasher with 5-litre tank",
        "comparisonNote": "Different brand/model comparison to the pictured Hermitlux HMX-DW03. Tank capacity, dimensions, wash programs and included hoses may differ.",
        "priceUnit": "one countertop dishwasher",
        "source": "Walmart US",
        "url": "https://www.walmart.com/ip/AIRMSEN-Portable-Countertop-Dishwasher-with-5-Liter-Built-in-Water-Tank-and-Air-Dry-Function-5-Washing-Programs-Mini-Dishwasher-AE-TDQR03/256074875",
        "referenceKey": "airmsen_dishwasher_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "32-inch display carton",
        "marker": [
          76,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "32-inch and HDMI icons are visible; the display type, brand, resolution and model are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-205-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #205 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #205",
    "productId": "gid://shopify/Product/9682402607359",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-205-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-205-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338120.png?v=1789065038",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-205-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-205-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338120.png?v=1789065038",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Tineco floor-cleaner station carton",
        "marker": [
          19,
          27
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Tineco-style Floor One station imagery is visible, but the exact brand line, model suffix and accessory bundle are partly obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Vibration-platform carton",
        "marker": [
          48,
          16
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A vibration platform is pictured; brand, model and rated capacity cannot be read.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Upper-right product carton",
        "marker": [
          77,
          21
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Product photos are printed on the black-and-white carton, but its brand and product description are too obscured to verify.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Small light-wood item carton",
        "marker": [
          53,
          31
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A light-wood product is pictured, but the product type, dimensions and brand are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Ninja Luxe Café espresso-machine carton",
        "marker": [
          62,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Ninja Luxe Café branding and an espresso-machine image are visible; the exact model and included accessories are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Electric bidet-seat carton",
        "marker": [
          33,
          47
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Electric Bidet Seat is readable; brand, bowl fit, controls and exact model are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Lefant robot-vacuum carton",
        "marker": [
          23,
          65
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Lefant branding and a robot-vacuum image are visible; exact model, navigation system and included dock are not readable.",
        "price": 399.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Dreame D20 Plus robot vacuum and mop with auto-empty base, 13,000 Pa",
        "comparisonNote": "Comparison model. Suction, mopping, navigation, base-station functions and included consumables differ from the photographed model.",
        "priceUnit": "one robot vacuum/mop and auto-empty base set",
        "source": "Dreame Canada",
        "url": "https://ca.dreametech.com/products/d20-plus-robot-vacuum",
        "referenceKey": "dreame_d20_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Mario Kart Rainbow Road track-set carton",
        "marker": [
          91,
          61
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Mario Kart Rainbow Road track-set branding is visible; exact edition and included pieces are not inspected.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Tineco FLOOR ONE S5 COMBO carton",
        "marker": [
          69,
          79
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Tineco FLOOR ONE S5 COMBO and onboard-handvac imagery are visible; exact regional suffix and accessory bundle are not confirmed.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Snow-thrower carton",
        "marker": [
          27,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "A snow thrower is pictured, but brand, voltage, battery bundle and model are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-206-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #206 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #206",
    "productId": "gid://shopify/Product/9682402672895",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-206-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-206-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338119.png?v=1789065012",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-206-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-206-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338119.png?v=1789065012",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "Long lighting-accessory carton",
        "marker": [
          26,
          13
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "Partial lighting-related branding is visible on the long carton; exact product type, fitment and model are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Remote-control vehicle carton",
        "marker": [
          82,
          17
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "A remote-control vehicle is pictured; brand, scale, battery and model are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Colour-option product carton",
        "marker": [
          55,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Colour checkboxes and a product outline are visible, but the product type and brand cannot be established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Upper-left appliance carton",
        "marker": [
          21,
          29
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "A product image and a red Canada sticker are visible; the product identity and model are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Pyramid Simple Smart carton",
        "marker": [
          76,
          36
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Pyramid Simple Smart branding is visible; the product description and model are not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Slushie-machine carton",
        "marker": [
          21,
          46
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Slushie Machine and beverage imagery are visible; brand, capacity and exact model are partly obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Logistics-labelled centre carton",
        "marker": [
          45,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Only logistics and unit markings are readable; the product type and contents are unknown.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Canon PIXMA G3270 MegaTank printer",
        "marker": [
          72,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Canon PIXMA G3270 MegaTank and wireless all-in-one printer wording are clearly visible; ink and paper contents are not inspected.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "ECOVACS DEEBOT robot-vacuum carton",
        "marker": [
          26,
          66
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "ECOVACS DEEBOT branding and a robot/base-station image are visible; the model suffix and included dock features are covered.",
        "price": 399.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Dreame D20 Plus robot vacuum and mop with auto-empty base, 13,000 Pa",
        "comparisonNote": "Comparison model. Suction, mopping, navigation, base-station functions and included consumables differ from the photographed model.",
        "priceUnit": "one robot vacuum/mop and auto-empty base set",
        "source": "Dreame Canada",
        "url": "https://ca.dreametech.com/products/d20-plus-robot-vacuum",
        "referenceKey": "dreame_d20_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Ninja Crispi portable cooking system",
        "marker": [
          63,
          66
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Ninja Crispi Portable Cooking System branding is visible; exact set size, container bundle and model are partly covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Litheli U20 snow-shovel carton",
        "marker": [
          30,
          84
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Litheli, 14-inch, U20 and 2 × 20V brushless snow-shovel wording are visible; battery capacities and bundle contents are not inspected.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Bottom-right outdoor-power carton",
        "marker": [
          77,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Outdoor-power-equipment imagery is visible, but brand, product type and model are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  },
  "bulk-electronics-207-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #207 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #207",
    "productId": "gid://shopify/Product/9682402738431",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-207-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-207-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338118.png?v=1789064977",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-207-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-207-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338118.png?v=1789064977",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "MOVA E30 Pro robot vacuum and mop",
        "marker": [
          23,
          20
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "MOVA E30 Pro and robot-vacuum-and-mop imagery are visible; dock contents and regional bundle are not inspected.",
        "price": 399.99,
        "currency": "CAD",
        "match": "Comparison",
        "comparison": "Dreame D20 Plus robot vacuum and mop with auto-empty base, 13,000 Pa",
        "comparisonNote": "Comparison model. Suction, mopping, navigation, base-station functions and included consumables differ from the photographed model.",
        "priceUnit": "one robot vacuum/mop and auto-empty base set",
        "source": "Dreame Canada",
        "url": "https://ca.dreametech.com/products/d20-plus-robot-vacuum",
        "referenceKey": "dreame_d20_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Large blue-and-black carton",
        "marker": [
          54,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "Most identifying text is covered; product type, brand and model cannot be established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Shark Cordless Pet Plus vacuum carton",
        "marker": [
          87,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Shark Cordless Pet Plus branding is visible; exact model suffix, battery count and tool bundle are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Partly labelled stainless-product carton",
        "marker": [
          28,
          40
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "A stainless product image and partial branding are visible; the exact product type, size and model cannot be verified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Large dark centre carton",
        "marker": [
          59,
          43
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "The carton face is mostly covered; product type and model are unknown.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Full-size rear-seat mattress carton",
        "marker": [
          83,
          55
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "Full-size truck/SUV rear-seat mattress imagery is visible; brand, dimensions and included pump/accessories are partly hidden.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Cordless mattress-vacuum carton",
        "marker": [
          20,
          63
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Cordless Mattress Vacuum is readable with partial branding; exact model, battery and filter bundle are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "NOMA SurfaceElite portable spot cleaner",
        "marker": [
          49,
          64
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "NOMA SurfaceElite Portable Spot Cleaner is readable; exact model and attachment/solution bundle are not established.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Crosley Voyager portable turntable",
        "marker": [
          20,
          75
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Crosley Voyager portable-turntable branding is visible; colour, regional model and included accessories are not confirmed.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Ninja Luxe Café espresso-machine carton",
        "marker": [
          24,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Ninja Luxe Café branding and espresso-machine imagery are visible; exact model and accessory bundle are unreadable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Cuisinart Griddler Deluxe carton",
        "marker": [
          60,
          86
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Cuisinart Griddler Deluxe and GR-150NAC are visible; the Canadian comparison uses GR-150C, so suffix and bundle differences must be checked.",
        "price": 269.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Cuisinart Griddler Deluxe GR-150C",
        "comparisonNote": "The photographed carton says GR-150NAC, while the Canadian listing uses GR-150C. Confirm suffix, electrical specification, plates and accessories before treating this as an exact match.",
        "priceUnit": "one countertop griddler",
        "source": "Cuisinart Canada",
        "url": "https://www.cuisinart.ca/",
        "referenceKey": "cuisinart_griddler_deluxe_20260910",
        "priceReviewedAt": "2026-09-10"
      }
    ]
  },
  "bulk-electronics-208-free-shipping-eligible-for-parts-of-ontario-only": {
    "title": "Bulk Electronics #208 — Free Shipping Eligible for Parts of Ontario Only",
    "shortTitle": "Bulk Electronics #208",
    "productId": "gid://shopify/Product/9682402771199",
    "reviewVersion": 3,
    "reviewedAt": "2026-09-10",
    "groups": [
      "me"
    ],
    "photo": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-208-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-208-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338117.png?v=1789064949",
    "photoWidth": 864,
    "photoHeight": 1536,
    "photos": [
      {
        "url": "https://cdn.shopify.com/s/files/1/0266/6024/1596/files/bulk-electronics-208-free-shipping-eligible-for-parts-of-ontario-only-bulk-electronics-208-free-shipping-eligible-for-parts-of-ontario-only-liquidationdeals-ca-1258338117.png?v=1789064949",
        "width": 864,
        "height": 1536
      }
    ],
    "items": [
      {
        "label": "eufy L60 robot-vacuum carton",
        "marker": [
          22,
          23
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top left",
        "note": "eufy L60 and 5,000 Pa are visible; this appears to be the vacuum-only carton, while exact accessories remain unverified.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Partly covered long carton",
        "marker": [
          51,
          13
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top centre",
        "note": "A slogan is visible, but the product type, brand and model are covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Nespresso Vertuo Pop+ Deluxe carton",
        "marker": [
          79,
          22
        ],
        "photoIndex": 1,
        "position": "Photo 1 · top right",
        "note": "Nespresso Vertuo Pop+ Deluxe by Breville is visible; colour and exact regional model suffix are not readable.",
        "price": 189,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Pop+ Deluxe ENV95S capsule coffee machine",
        "comparisonNote": "Same Vertuo Pop+ Deluxe family; colour, regional model suffix and any separately bundled accessories on the pictured carton remain unverified.",
        "priceUnit": "one capsule coffee machine",
        "source": "De’Longhi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/capsules-coffee-machines/nespresso-machines",
        "referenceKey": "nespresso_vertuo_pop_deluxe_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Piezano 12-inch pizza-oven carton",
        "marker": [
          53,
          33
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Piezano crispy-crust pizza-oven branding and 12-inch size are visible; exact model and included accessories are not confirmed.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Lefant robot-vacuum cartons",
        "marker": [
          19,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle left",
        "note": "Two separate Lefant robot-vacuum cartons are visible with different face designs; their model numbers and included accessories cannot be read.",
        "quantityLabel": "2 cartons shown",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "WORX 20V PowerShare outdoor-tool carton",
        "marker": [
          86,
          48
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle right",
        "note": "WORX 20V PowerShare branding and blower/trimmer imagery are visible; the exact kit, battery count and model numbers are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Nespresso Vertuo Next with Aeroccino",
        "marker": [
          51,
          54
        ],
        "photoIndex": 1,
        "position": "Photo 1 · middle centre",
        "note": "Nespresso Vertuo Next by De’Longhi and an Aeroccino milk-frother bundle are visible; exact colour/model suffix is covered.",
        "price": 299,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Nespresso Vertuo Next ENV120WAE by De’Longhi with Aeroccino",
        "comparisonNote": "Same Vertuo Next/Aeroccino family. The pictured carton’s colour and regional model suffix are covered, so verify them before assuming an exact match.",
        "priceUnit": "one coffee machine and Aeroccino frother bundle",
        "source": "De’Longhi Canada",
        "url": "https://www.delonghi.com/en-ca/c/coffee-e-espresso/coffee-machines/capsules-coffee-machines/nespresso-machines",
        "referenceKey": "nespresso_vertuo_next_bundle_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "Dreame L50 Ultra robot vacuum and mop",
        "marker": [
          27,
          76
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom left",
        "note": "Dreame L50 Ultra branding and a robot/base-station image are visible; included consumables and regional bundle are not inspected.",
        "price": 399.99,
        "currency": "CAD",
        "match": "Same brand",
        "comparison": "Dreame D20 Plus robot vacuum and mop with auto-empty base, 13,000 Pa",
        "comparisonNote": "Comparison model. Suction, mopping, navigation, base-station functions and included consumables differ from the photographed model.",
        "priceUnit": "one robot vacuum/mop and auto-empty base set",
        "source": "Dreame Canada",
        "url": "https://ca.dreametech.com/products/d20-plus-robot-vacuum",
        "referenceKey": "dreame_d20_20260910",
        "priceReviewedAt": "2026-09-10"
      },
      {
        "label": "20-pint smart-dehumidifier carton",
        "marker": [
          58,
          70
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Smart-dehumidifier wording and 20 pints/day are visible; brand, test standard and exact model are obscured.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Ninja Foodi dual-zone air-fryer carton",
        "marker": [
          55,
          85
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom centre",
        "note": "Ninja Foodi DualZone air-fryer branding is visible; capacity, regional model and included accessories are partly covered.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      },
      {
        "label": "Intex Dura-Beam air-mattress carton",
        "marker": [
          89,
          87
        ],
        "photoIndex": 1,
        "position": "Photo 1 · bottom right",
        "note": "Intex Dura-Beam branding is visible; mattress size, height, pump bundle and exact model are not readable.",
        "price": null,
        "reason": "The photos do not establish a specific product/model for pricing."
      }
    ]
  }
};
